import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, EventEmitter, ChangeDetectionStrategy, Input, Output, ViewChild, NgModule, HostBinding, Inject, Directive, signal, Pipe, Injectable, input, computed, HostListener, Optional, Self, TemplateRef, ContentChildren } from '@angular/core';
import * as i1$1 from '@angular/router';
import { RouterModule, GuardsCheckStart, GuardsCheckEnd, NavigationCancel } from '@angular/router';
import * as i1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i2$3 from '@angular/material/button-toggle';
import { MatButtonToggleModule, MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/button-toggle';
import * as i2$2 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i2$1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i3 from '@angular/material/tooltip';
import { MatTooltipModule, MatTooltip } from '@angular/material/tooltip';
import * as i3$1 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i1$4 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule } from '@angular/material/snack-bar';
import { Subject, takeUntil, BehaviorSubject, tap, catchError, of, from, mergeMap, map, filter, timer, debounceTime as debounceTime$1 } from 'rxjs';
import { format, startOfMonth, startOfDay } from 'date-fns';
import DOMPurify from 'dompurify';
import * as i1$2 from '@angular/platform-browser';
import * as i1$3 from '@angular/cdk/dialog';
import * as i1$5 from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { BlockBlobClient } from '@azure/storage-blob';
import mime from 'mime';
import { trigger, transition, style, animate, state } from '@angular/animations';
import * as i1$6 from '@angular/forms';
import { FormsModule, ReactiveFormsModule, FormGroup, DefaultValueAccessor, Validators, UntypedFormControl, FormControl } from '@angular/forms';
import * as i4 from '@angular/material/form-field';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import * as i6 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i8 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i4$1 from '@angular/material/checkbox';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import * as i5$2 from '@angular/material/core';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import * as i4$2 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i5 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import { enGB } from 'date-fns/locale';
import * as i2$4 from '@angular/material/slide-toggle';
import { MatSlideToggle, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { debounceTime, distinctUntilChanged, switchMap, map as map$1, tap as tap$1, first } from 'rxjs/operators';
import * as i4$3 from '@angular/material/radio';
import { MatRadioModule, MatRadioGroup } from '@angular/material/radio';
import { Jodit } from 'jodit';
import 'jodit/esm/plugins/about/about';
import 'jodit/esm/plugins/add-new-line/add-new-line';
import 'jodit/esm/plugins/backspace/backspace';
import 'jodit/esm/plugins/bold/bold';
import 'jodit/esm/plugins/class-span/class-span';
import 'jodit/esm/plugins/clean-html/clean-html';
import 'jodit/esm/plugins/clipboard/clipboard';
import 'jodit/esm/plugins/color/color';
import 'jodit/esm/plugins/copy-format/copy-format';
import 'jodit/esm/plugins/delete/delete';
import 'jodit/esm/plugins/drag-and-drop-element/drag-and-drop-element';
import 'jodit/esm/plugins/drag-and-drop/drag-and-drop';
import 'jodit/esm/plugins/dtd/dtd';
import 'jodit/esm/plugins/enter/enter';
import 'jodit/esm/plugins/file/file';
import 'jodit/esm/plugins/focus/focus';
import 'jodit/esm/plugins/font/font';
import 'jodit/esm/plugins/format-block/format-block';
import 'jodit/esm/plugins/hotkeys/hotkeys';
import 'jodit/esm/plugins/hr/hr';
import 'jodit/esm/plugins/iframe/iframe';
import 'jodit/esm/plugins/image-processor/image-processor';
import 'jodit/esm/plugins/image-properties/image-properties';
import 'jodit/esm/plugins/image/image';
import 'jodit/esm/plugins/indent/indent';
import 'jodit/esm/plugins/inline-popup/inline-popup';
import 'jodit/esm/plugins/justify/justify';
import 'jodit/esm/plugins/key-arrow-outside/key-arrow-outside';
import 'jodit/esm/plugins/limit/limit';
import 'jodit/esm/plugins/line-height/line-height';
import 'jodit/esm/plugins/link/link';
import 'jodit/esm/plugins/media/media';
import 'jodit/esm/plugins/mobile/mobile';
import 'jodit/esm/plugins/ordered-list/ordered-list';
import 'jodit/esm/plugins/paste-from-word/paste-from-word';
import 'jodit/esm/plugins/paste-storage/paste-storage';
import 'jodit/esm/plugins/paste/paste';
import 'jodit/esm/plugins/placeholder/placeholder';
import 'jodit/esm/plugins/powered-by-jodit/powered-by-jodit';
import 'jodit/esm/plugins/preview/preview';
import 'jodit/esm/plugins/print/print';
import 'jodit/esm/plugins/redo-undo/redo-undo';
import 'jodit/esm/plugins/resize-cells/resize-cells';
import 'jodit/esm/plugins/resize-handler/resize-handler';
import 'jodit/esm/plugins/resizer/resizer';
import 'jodit/esm/plugins/search/search';
import 'jodit/esm/plugins/select-cells/select-cells';
import 'jodit/esm/plugins/select/select';
import 'jodit/esm/plugins/size/size';
import 'jodit/esm/plugins/source/source';
import 'jodit/esm/plugins/spellcheck/spellcheck';
import 'jodit/esm/plugins/stat/stat';
import 'jodit/esm/plugins/sticky/sticky';
import 'jodit/esm/plugins/symbols/symbols';
import 'jodit/esm/plugins/tab/tab';
import 'jodit/esm/plugins/table-keyboard-navigation/table-keyboard-navigation';
import 'jodit/esm/plugins/table/table';
import 'jodit/esm/plugins/video/video';
import 'jodit/esm/plugins/wrap-nodes/wrap-nodes';
import 'jodit/esm/plugins/xpath/xpath';
import * as i5$1 from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import * as i4$4 from '@angular/material/select';
import { MatSelectModule, MatSelect } from '@angular/material/select';
import { themeBalham, provideGlobalGridOptions } from 'ag-grid-enterprise';
import * as i4$5 from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import * as i1$7 from '@angular/cdk/layout';
import { ArrayDataSource } from '@angular/cdk/collections';
import * as i5$3 from '@angular/cdk/tree';
import { NestedTreeControl, CdkTreeModule } from '@angular/cdk/tree';
import * as i1$8 from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import { AgGridAngular } from 'ag-grid-angular';
import * as i4$6 from '@angular/material/toolbar';
import { MatToolbarModule } from '@angular/material/toolbar';
const _c0 = [[["cui-top-menu"]], [["cui-side-nav-container"]], [["", 8, "body"]]];
const _c1 = ["cui-top-menu", "cui-side-nav-container", ".body"];
const _c2 = ["btn"];
const _c3 = ["*"];
const _c4 = a0 => ({
  "material-icons-outlined": a0
});
function CuiIconComponent_mat_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c4, !ctx_r0.isActive))("matTooltip", ctx_r0.tooltipText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.name);
  }
}
function CuiButtonDropdownActionComponent_cui_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cui-icon", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.icon);
  }
}
function CuiIconButtonComponent_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.name);
  }
}
function CuiCardHeaderComponent_cui_icon_btn_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cui-icon-btn", 1);
    i0.ɵɵlistener("clicked", function CuiCardHeaderComponent_cui_icon_btn_1_Template_cui_icon_btn_clicked_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close.emit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "close");
  }
}
const _c5 = [[["cui-card-header"]], [["cui-card-body"]], [["cui-card-footer"]]];
const _c6 = ["cui-card-header", "cui-card-body", "cui-card-footer"];
function CuiCardComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "mat-spinner", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("diameter", 50);
  }
}
const _c7 = a0 => ({
  width: a0
});
function CuiGuardLoadingIndicatorComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelement(1, "mat-spinner", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c7, ctx_r0.width));
    i0.ɵɵadvance();
    i0.ɵɵproperty("diameter", 90);
  }
}
const _c8 = a0 => ({
  clickable: a0
});
const _c9 = [[["cui-tile-base-body"]], [["cui-tile-base-footer"]]];
const _c10 = ["cui-tile-base-body", "cui-tile-base-footer"];
const _c11 = a0 => ({
  "background-color": a0
});
function CuiDashboardTileComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
    i0.ɵɵprojection(1, 1);
  }
}
function CuiDashboardTileComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 4);
  }
  if (rf & 2) {
    i0.ɵɵproperty("diameter", 50);
  }
}
const _c12 = a0 => ({
  color: a0
});
const _c13 = a0 => ({
  "font-size": a0
});
const _c14 = a0 => ({
  required: a0
});
function CuiFilesUploaderComponentDeprecated_ng_container_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CuiFilesUploaderComponentDeprecated_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Not allowed extensions ");
    i0.ɵɵelement(2, "cui-icon", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matTooltip", ctx_r2.notAllowedExtensions.join(", "))("name", "info");
  }
}
function CuiFilesUploaderComponentDeprecated_ng_template_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, " Allowed extensions ");
    i0.ɵɵelement(2, "cui-icon", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matTooltip", ctx_r2.allowedExtensions.length ? ctx_r2.allowedExtensions.join(", ") : "All")("name", "info");
  }
}
function CuiFilesUploaderComponentDeprecated_mat_error_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@animateOut", undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.globalFileUploadErrorMessage);
  }
}
function CuiFilesUploaderComponentDeprecated_div_22_div_1_small_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 27);
  }
  if (rf & 2) {
    const selectedFile_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHtml", selectedFile_r5.errMessages.join("; "), i0.ɵɵsanitizeHtml);
  }
}
function CuiFilesUploaderComponentDeprecated_div_22_div_1_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "mat-progress-bar", 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectedFile_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", selectedFile_r5.progress);
  }
}
function CuiFilesUploaderComponentDeprecated_div_22_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "div", 20);
    i0.ɵɵelement(2, "cui-icon", 21);
    i0.ɵɵelementStart(3, "div", 22)(4, "h5");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "small");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "formatBytes");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CuiFilesUploaderComponentDeprecated_div_22_div_1_small_9_Template, 1, 1, "small", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, CuiFilesUploaderComponentDeprecated_div_22_div_1_div_10_Template, 2, 1, "div", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 25)(12, "cui-icon-btn", 26);
    i0.ɵɵlistener("clicked", function CuiFilesUploaderComponentDeprecated_div_22_div_1_Template_cui_icon_btn_clicked_12_listener() {
      const i_r6 = i0.ɵɵrestoreView(_r4).index;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.disabled === false && ctx_r2.deleteFile(i_r6));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const selectedFile_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "folder");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(selectedFile_r5.file.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 8, selectedFile_r5.file.size));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", selectedFile_r5.errMessages.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", selectedFile_r5.uploadStarted);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matTooltip", "Remove selected file")("disabled", ctx_r2.disabled)("name", "delete");
  }
}
function CuiFilesUploaderComponentDeprecated_div_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, CuiFilesUploaderComponentDeprecated_div_22_div_1_Template, 13, 10, "div", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.selectedFiles);
  }
}
function CuiFilesUploaderComponent_div_0_div_1_small_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 27);
  }
  if (rf & 2) {
    const selectedFile_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHtml", selectedFile_r3.errMessages.join("; "), i0.ɵɵsanitizeHtml);
  }
}
function CuiFilesUploaderComponent_div_0_div_1_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "mat-progress-bar", 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectedFile_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", selectedFile_r3.progress)("color", selectedFile_r3.progress === 100 ? "accent" : "primary");
  }
}
function CuiFilesUploaderComponent_div_0_div_1_cui_icon_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cui-icon", 30);
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "done");
  }
}
function CuiFilesUploaderComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19);
    i0.ɵɵelement(2, "cui-icon", 20);
    i0.ɵɵelementStart(3, "div", 21)(4, "h5");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "small");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "formatBytes");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CuiFilesUploaderComponent_div_0_div_1_small_9_Template, 1, 1, "small", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, CuiFilesUploaderComponent_div_0_div_1_div_10_Template, 2, 2, "div", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 24);
    i0.ɵɵtemplate(12, CuiFilesUploaderComponent_div_0_div_1_cui_icon_12_Template, 1, 1, "cui-icon", 25);
    i0.ɵɵelementStart(13, "cui-icon-btn", 26);
    i0.ɵɵlistener("clicked", function CuiFilesUploaderComponent_div_0_div_1_Template_cui_icon_btn_clicked_13_listener() {
      const i_r4 = i0.ɵɵrestoreView(_r2).index;
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.config.disabled === false && ctx_r4.deleteFile(i_r4));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const selectedFile_r3 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "folder");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(selectedFile_r3.file.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 9, selectedFile_r3.file.size));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", selectedFile_r3.errMessages.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", selectedFile_r3.uploadStarted);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", selectedFile_r3.progress === 100);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matTooltip", "Remove selected file")("disabled", ctx_r4.config.disabled)("name", "delete");
  }
}
function CuiFilesUploaderComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, CuiFilesUploaderComponent_div_0_div_1_Template, 14, 11, "div", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.selectedFiles);
  }
}
function CuiFilesUploaderComponent_p_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatBytes");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Min size ", i0.ɵɵpipeBind1(2, 1, ctx_r4.config.minFileSize), " per file;");
  }
}
function CuiFilesUploaderComponent_ng_container_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CuiFilesUploaderComponent_ng_template_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 31);
    i0.ɵɵtext(1, " Not allowed extensions ");
    i0.ɵɵelement(2, "cui-icon", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matTooltip", ctx_r4.config.notAllowedExtensions.join(", "))("name", "info");
  }
}
function CuiFilesUploaderComponent_ng_template_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 31);
    i0.ɵɵtext(1, " Allowed extensions ");
    i0.ɵɵelement(2, "cui-icon", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matTooltip", ctx_r4.config.allowedExtensions.length ? ctx_r4.config.allowedExtensions.join(", ") : "All")("name", "info");
  }
}
function CuiFilesUploaderComponent_mat_error_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@animateOut", undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r4.globalFileUploadErrorMessage);
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "This field is mandatory to fill.");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Value must be unique.");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatBytes");
    i0.ɵɵpipe(3, "formatBytes");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("Value can not exceed max size of ", i0.ɵɵpipeBind1(2, 2, ctx_r0.control.errors == null ? null : ctx_r0.control.errors["maxSizeInBytes"]), ". Current size is ", i0.ɵɵpipeBind1(3, 4, ctx_r0.control.errors == null ? null : ctx_r0.control.errors["currentSize"]), "");
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Entered value does not meet the criteria. ", ctx_r0.hint, "");
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Email is not formatted correctly.");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Email is already in use.");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Such email does not exist.");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Email cannot belong to a public domain.");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Value cannot be lower than ", ctx_r0.control.errors == null ? null : ctx_r0.control.errors["min"].min, ".");
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Value cannot be higher than ", ctx_r0.control.errors == null ? null : ctx_r0.control.errors["max"].max, ".");
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Value must be at least ", ctx_r0.control.errors == null ? null : ctx_r0.control.errors["minlength"].requiredLength, " characters long. ");
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Value must be at most ", ctx_r0.control.errors == null ? null : ctx_r0.control.errors["maxlength"].requiredLength, " characters long. ");
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " Password should contain at least 1 uppercase, 1 lowercase, 1 digit and 1 special character. ");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Confirmed value does not match the previous one.");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "isoDate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Date cannot be earlier than ", i0.ɵɵpipeBind1(2, 1, ctx_r0.control.errors == null ? null : ctx_r0.control.errors["matDatepickerMin"].min), ". ");
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "isoDate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Date cannot be later than ", i0.ɵɵpipeBind1(2, 1, ctx_r0.control.errors == null ? null : ctx_r0.control.errors["matDatepickerMax"].max), ". ");
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " Invalid date format. Please enter a valid date. ");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Value must be an integer.");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " Value must contain latin letters and numbers only (no spaces or symbols). ");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Value cannot contain only spaces.");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " Phone number should start with plus symbol and can only contain digits. ");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Domain is not available.");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Value cannot equal 0.");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Date should be in mm/yy format.");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Date is invalid or your card has expired.");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "ZIP or postal code is invalid.");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Value cannot equal ", ctx_r0.control.errors == null ? null : ctx_r0.control.errors["valueEqualToCurrentValue"], " (original value). ");
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵi18n(1, 0);
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵi18n(1, 1);
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵi18n(1, 2);
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵi18n(1, 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵi18nExp(ctx_r0.control.errors == null ? null : ctx_r0.control.errors["timeMinValue"]);
    i0.ɵɵi18nApply(1);
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵi18n(1, 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵi18nExp(ctx_r0.control.errors == null ? null : ctx_r0.control.errors["timeMaxValue"]);
    i0.ɵɵi18nApply(1);
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵi18n(1, 5);
    i0.ɵɵelementContainerEnd();
  }
}
function CuiErrorsComponent_ng_container_0_ng_container_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.control.errors == null ? null : ctx_r0.control.errors["customErrorMessage"], " ");
  }
}
function CuiErrorsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CuiErrorsComponent_ng_container_0_ng_container_1_Template, 2, 0, "ng-container", 6)(2, CuiErrorsComponent_ng_container_0_ng_container_2_Template, 2, 0, "ng-container", 6)(3, CuiErrorsComponent_ng_container_0_ng_container_3_Template, 4, 6, "ng-container", 6)(4, CuiErrorsComponent_ng_container_0_ng_container_4_Template, 2, 1, "ng-container", 6)(5, CuiErrorsComponent_ng_container_0_ng_container_5_Template, 2, 0, "ng-container", 6)(6, CuiErrorsComponent_ng_container_0_ng_container_6_Template, 2, 0, "ng-container", 6)(7, CuiErrorsComponent_ng_container_0_ng_container_7_Template, 2, 0, "ng-container", 6)(8, CuiErrorsComponent_ng_container_0_ng_container_8_Template, 2, 0, "ng-container", 6)(9, CuiErrorsComponent_ng_container_0_ng_container_9_Template, 2, 1, "ng-container", 6)(10, CuiErrorsComponent_ng_container_0_ng_container_10_Template, 2, 1, "ng-container", 6)(11, CuiErrorsComponent_ng_container_0_ng_container_11_Template, 2, 1, "ng-container", 6)(12, CuiErrorsComponent_ng_container_0_ng_container_12_Template, 2, 1, "ng-container", 6)(13, CuiErrorsComponent_ng_container_0_ng_container_13_Template, 2, 0, "ng-container", 6)(14, CuiErrorsComponent_ng_container_0_ng_container_14_Template, 2, 0, "ng-container", 6)(15, CuiErrorsComponent_ng_container_0_ng_container_15_Template, 3, 3, "ng-container", 6)(16, CuiErrorsComponent_ng_container_0_ng_container_16_Template, 3, 3, "ng-container", 6)(17, CuiErrorsComponent_ng_container_0_ng_container_17_Template, 2, 0, "ng-container", 6)(18, CuiErrorsComponent_ng_container_0_ng_container_18_Template, 2, 0, "ng-container", 6)(19, CuiErrorsComponent_ng_container_0_ng_container_19_Template, 2, 0, "ng-container", 6)(20, CuiErrorsComponent_ng_container_0_ng_container_20_Template, 2, 0, "ng-container", 6)(21, CuiErrorsComponent_ng_container_0_ng_container_21_Template, 2, 0, "ng-container", 6)(22, CuiErrorsComponent_ng_container_0_ng_container_22_Template, 2, 0, "ng-container", 6)(23, CuiErrorsComponent_ng_container_0_ng_container_23_Template, 2, 0, "ng-container", 6)(24, CuiErrorsComponent_ng_container_0_ng_container_24_Template, 2, 0, "ng-container", 6)(25, CuiErrorsComponent_ng_container_0_ng_container_25_Template, 2, 0, "ng-container", 6)(26, CuiErrorsComponent_ng_container_0_ng_container_26_Template, 2, 0, "ng-container", 6)(27, CuiErrorsComponent_ng_container_0_ng_container_27_Template, 2, 1, "ng-container", 6)(28, CuiErrorsComponent_ng_container_0_ng_container_28_Template, 2, 0, "ng-container", 6)(29, CuiErrorsComponent_ng_container_0_ng_container_29_Template, 2, 0, "ng-container", 6)(30, CuiErrorsComponent_ng_container_0_ng_container_30_Template, 2, 0, "ng-container", 6)(31, CuiErrorsComponent_ng_container_0_ng_container_31_Template, 2, 1, "ng-container", 6)(32, CuiErrorsComponent_ng_container_0_ng_container_32_Template, 2, 1, "ng-container", 6)(33, CuiErrorsComponent_ng_container_0_ng_container_33_Template, 2, 0, "ng-container", 6)(34, CuiErrorsComponent_ng_container_0_ng_container_34_Template, 2, 1, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("required") && !ctx_r0.control.hasError("matDatepickerParse"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("isNotUnique"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("isTooBigInBytes"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("pattern"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("email"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("emailNotUnique"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("nonRegisteredEmail"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("emailBlockedDomain"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("min"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("max"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("minlength"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("maxlength"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("weakPassword"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("confirmationerror"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("matDatepickerMin"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("matDatepickerMax"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("matDatepickerParse"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("integerError"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("latinLettersAndNumbersError"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("emptyStringError"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("invalidPhoneError"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("domainNotAvailable"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("integerEqualToZeroError"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("invalidExpirationDateFormatError"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("invalidExpirationDateError"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("invalidZipCodeError"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("valueEqualToCurrentValue"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("confirmTermsAndConditions"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("confirmAdditionalStatement"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("validGuidError"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("timeMinError"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("timeMaxError"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("nonWhitespaceChangesError"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.hasError("customErrorMessage"));
  }
}
function CuiCheckboxComponent_mat_error_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵelement(1, "cui-errors", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r0.control);
  }
}
function CuiDatepickerComponent_mat_error_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵelement(1, "cui-errors", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r0.control);
  }
}
const _c15 = ["inputElement"];
function CuiFileInputComponent_ng_container_6_mat_spinner_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 10);
  }
  if (rf & 2) {
    const fileUploadProgress_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("mode", "determinate")("diameter", 30)("value", fileUploadProgress_r1.progress);
  }
}
function CuiFileInputComponent_ng_container_6_cui_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cui-icon", 11);
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "done");
  }
}
function CuiFileInputComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CuiFileInputComponent_ng_container_6_mat_spinner_1_Template, 1, 3, "mat-spinner", 8)(2, CuiFileInputComponent_ng_container_6_cui_icon_2_Template, 1, 1, "cui-icon", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const fileUploadProgress_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", fileUploadProgress_r1.progress < 100 && ctx_r1.fileId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", fileUploadProgress_r1.progress === 100 && ctx_r1.fileId);
  }
}
function CuiFileInputComponent_cui_icon_btn_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cui-icon-btn", 12);
    i0.ɵɵlistener("clicked", function CuiFileInputComponent_cui_icon_btn_8_Template_cui_icon_btn_clicked_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFileUploadClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", "attach_file")("disabled", ctx_r1.control.disabled);
  }
}
function CuiFileInputComponent_cui_icon_btn_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cui-icon-btn", 13);
    i0.ɵɵlistener("clicked", function CuiFileInputComponent_cui_icon_btn_9_Template_cui_icon_btn_clicked_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFileRemove());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", "delete")("disabled", ctx_r1.control.disabled);
  }
}
function CuiFileInputComponent_cui_icon_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cui-icon", 14);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", "info_outlined")("tooltipText", ctx_r1.tooltipText);
  }
}
function CuiFileInputComponent_span_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.suffix);
  }
}
function CuiFileInputComponent_mat_hint_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.hint);
  }
}
function CuiFileInputComponent_mat_error_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵelement(1, "cui-errors", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r1.control)("hint", ctx_r1.hint);
  }
}
const _c16 = a0 => ({
  disabled: a0
});
function CuiFormSlideToggleComponent_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function CuiInputComponent_cui_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cui-icon", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.prefixIcon);
  }
}
function CuiInputComponent_cui_icon_btn_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cui-icon-btn", 9);
    i0.ɵɵlistener("clicked", function CuiInputComponent_cui_icon_btn_6_Template_cui_icon_btn_clicked_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onCopy());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", "content_copy")("disabled", !ctx_r0.control.value);
  }
}
function CuiInputComponent_cui_icon_btn_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cui-icon-btn", 10);
    i0.ɵɵlistener("clicked", function CuiInputComponent_cui_icon_btn_7_Template_cui_icon_btn_clicked_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onClear());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "close");
  }
}
function CuiInputComponent_cui_icon_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cui-icon", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", "info_outlined")("tooltipText", ctx_r0.tooltipText);
  }
}
function CuiInputComponent_span_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.suffix);
  }
}
function CuiInputComponent_mat_hint_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.hint);
  }
}
function CuiInputComponent_mat_error_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵelement(1, "cui-errors", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r0.control)("hint", ctx_r0.hint);
  }
}
const _c17 = "[_nghost-%COMP%]{display:block;margin:var(--cui-small-space) 0}mat-form-field[_ngcontent-%COMP%]{width:100%}";
function CuiMonthPickerComponent_mat_error_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵelement(1, "cui-errors", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r2.control);
  }
}
function CuiRadioChoiceComponent_ng_template_0_small_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.hint);
  }
}
function CuiRadioChoiceComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
    i0.ɵɵtemplate(1, CuiRadioChoiceComponent_ng_template_0_small_1_Template, 2, 1, "small", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.hint);
  }
}
function CuiRadioComponent_mat_radio_button_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-radio-button", 3);
    i0.ɵɵelementContainer(1, 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const choice_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", choice_r1.value)("disabled", choice_r1.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", choice_r1.templateRef);
  }
}
function CuiRadioComponent_mat_error_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵelement(1, "cui-errors", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r1.control);
  }
}
const _c18 = ["matLabel"];
function CuiRichEditorComponent_mat_hint_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.hint);
  }
}
function CuiRichEditorComponent_mat_error_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵelement(1, "cui-errors", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r0.control);
  }
}
const _c19 = ["ngSelect"];
const _c20 = (a0, a1, a2) => ({
  "has-error": a0,
  required: a1,
  "has-selected": a2
});
function CuiSearchSelectSsrComponent_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 6);
    i0.ɵɵlistener("click", function CuiSearchSelectSsrComponent_2_ng_template_0_Template_p_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onAddNewClick());
    });
    i0.ɵɵelement(1, "cui-icon", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "add");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.addNewText, " ");
  }
}
function CuiSearchSelectSsrComponent_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CuiSearchSelectSsrComponent_2_ng_template_0_Template, 3, 2, "ng-template", 5);
  }
}
function CuiSearchSelectSsrComponent_4_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "small");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = ctx.item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r4.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r4.value);
  }
}
function CuiSearchSelectSsrComponent_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CuiSearchSelectSsrComponent_4_ng_template_0_Template, 4, 2, "ng-template", 8);
  }
}
function CuiSearchSelectSsrComponent_5_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r5.name);
  }
}
function CuiSearchSelectSsrComponent_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CuiSearchSelectSsrComponent_5_ng_template_0_Template, 2, 1, "ng-template", 8);
  }
}
function CuiSearchSelectSsrComponent_mat_error_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵelement(1, "cui-errors", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r2.control);
  }
}
function CuiSearchSelectComponent_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 6);
    i0.ɵɵlistener("click", function CuiSearchSelectComponent_2_ng_template_0_Template_p_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onAddNewClick());
    });
    i0.ɵɵelement(1, "cui-icon", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "add");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.addNewText, " ");
  }
}
function CuiSearchSelectComponent_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CuiSearchSelectComponent_2_ng_template_0_Template, 3, 2, "ng-template", 5);
  }
}
function CuiSearchSelectComponent_4_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "small");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = ctx.item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r4.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r4.value);
  }
}
function CuiSearchSelectComponent_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CuiSearchSelectComponent_4_ng_template_0_Template, 4, 2, "ng-template", 8);
  }
}
function CuiSearchSelectComponent_5_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r5.name);
  }
}
function CuiSearchSelectComponent_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CuiSearchSelectComponent_5_ng_template_0_Template, 2, 1, "ng-template", 8);
  }
}
function CuiSearchSelectComponent_mat_error_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵelement(1, "cui-errors", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r2.control);
  }
}
function CuiSimpleSelectComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r1.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r1.text);
  }
}
function CuiSimpleSelectComponent_mat_hint_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.hint);
  }
}
function CuiSimpleSelectComponent_mat_error_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵelement(1, "cui-errors", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r1.control);
  }
}
const _c21 = ["textareaElement"];
function CuiTextAreaComponent_mat_hint_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.hint);
  }
}
function CuiTextAreaComponent_mat_error_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵelement(1, "cui-errors", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r0.control);
  }
}
const _c22 = a0 => ({
  "has-error": a0
});
const _c23 = a0 => ({
  "has-value": a0
});
function CuiTimepickerComponent_cui_errors_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cui-errors", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r0.control)("hint", ctx_r0.hint);
  }
}
function CuiIconLinkComponent_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.name);
  }
}
function CuiListItemComponent_label_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function CuiListItemComponent_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.textIfEmpty);
  }
}
function CuiMenuComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function CuiMenuComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "mat-spinner", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("diameter", 90);
  }
}
function CuiMenuGroupComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CuiMenuGroupComponent_cui_icon_btn_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cui-icon-btn", 5);
    i0.ɵɵlistener("clicked", function CuiMenuGroupComponent_cui_icon_btn_5_Template_cui_icon_btn_clicked_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close.emit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "close");
  }
}
const _c24 = a0 => ({
  "item-disabled": a0
});
function CuiMenuItemComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CuiPageTitleComponent_cui_icon_btn_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cui-icon-btn", 1);
    i0.ɵɵlistener("clicked", function CuiPageTitleComponent_cui_icon_btn_2_Template_cui_icon_btn_clicked_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close.emit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "close");
  }
}
const _c25 = ["drawer"];
const _c26 = [[["", 8, "body"]], [["", 8, "footer"]]];
const _c27 = [".body", ".footer"];
const _c28 = (a0, a1) => ({
  isNavExpanded: a0,
  isMobileView: a1
});
const _c29 = a0 => ({
  "full-width": a0
});
const _c30 = a0 => ({
  "collapsed-view": a0
});
function CuiSideNavComponent_mat_drawer_container_0_a_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵlistener("click", function CuiSideNavComponent_mat_drawer_container_0_a_9_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const obs_r4 = i0.ɵɵnextContext().ngIf;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changeNavState(false, !obs_r4.isNavExpanded));
    });
    i0.ɵɵelement(1, "cui-icon", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const obs_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("matTooltipDisabled", obs_r4.isNavExpanded)("matTooltip", "Expand")("matTooltipPosition", "right")("ngClass", i0.ɵɵpureFunction1(5, _c30, !obs_r4.isNavExpanded));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "double_arrow");
  }
}
function CuiSideNavComponent_mat_drawer_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-drawer-container", 2);
    i0.ɵɵlistener("backdropClick", function CuiSideNavComponent_mat_drawer_container_0_Template_mat_drawer_container_backdropClick_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClosed());
    });
    i0.ɵɵelementStart(1, "mat-drawer", 3, 0);
    i0.ɵɵlistener("closed", function CuiSideNavComponent_mat_drawer_container_0_Template_mat_drawer_closed_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClosed());
    });
    i0.ɵɵelementStart(3, "div", 4)(4, "div", 5);
    i0.ɵɵprojection(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 6)(7, "div", 7);
    i0.ɵɵprojection(8, 1);
    i0.ɵɵtemplate(9, CuiSideNavComponent_mat_drawer_container_0_a_9_Template, 2, 7, "a", 8);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const obs_r4 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hasBackdrop", true)("ngClass", i0.ɵɵpureFunction1(7, _c29, obs_r4.isMobileView && obs_r4.isNavExpanded));
    i0.ɵɵadvance();
    i0.ɵɵproperty("mode", obs_r4.isMobileView ? "over" : "side")("opened", !obs_r4.isMobileView)("disableClose", !obs_r4.isMobileView)("ngStyle", i0.ɵɵpureFunction1(9, _c7, ctx_r1.sidenavWidth));
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngIf", !obs_r4.isMobileView);
  }
}
const _c31 = a0 => ({
  isNavExpanded: a0
});
const _c32 = a0 => ({
  "collapsed-view-child": a0
});
function CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("@fadeIn", undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", node_r2.groupName, " ");
  }
}
function CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_1_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("@fadeIn", undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(node_r2.name);
  }
}
function CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cdk-nested-tree-node", 6);
    i0.ɵɵtemplate(1, CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_1_span_1_Template, 2, 2, "span", 7);
    i0.ɵɵelementStart(2, "a", 8);
    i0.ɵɵlistener("click", function CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_1_Template_a_click_2_listener() {
      const node_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.onLinkClick(node_r2));
    });
    i0.ɵɵelement(3, "cui-icon", 9, 0);
    i0.ɵɵtemplate(5, CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_1_span_5_Template, 2, 2, "span", 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const node_r2 = ctx.$implicit;
    const elem_r4 = i0.ɵɵreference(4);
    const obs_r5 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", obs_r5.isNavExpanded && node_r2.groupName && node_r2.isFirstWithGroupName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matTooltipDisabled", obs_r5.isNavExpanded)("matTooltip", node_r2.name)("matTooltipPosition", "right")("routerLink", node_r2.url)("ngClass", i0.ɵɵpureFunction1(9, _c30, !obs_r5.isNavExpanded));
    i0.ɵɵadvance();
    i0.ɵɵproperty("isActive", elem_r4.elementRef.nativeElement.className.includes("active"))("name", node_r2.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", obs_r5.isNavExpanded);
  }
}
function CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_2_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("@fadeIn", undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", node_r7.groupName, " ");
  }
}
function CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_2_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("@fadeIn", undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(node_r7.name);
  }
}
function CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_2_cui_icon_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cui-icon", 17);
  }
  if (rf & 2) {
    const node_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("name", ctx_r2.treeControl.isExpanded(node_r7) ? "expand_less" : "expand_more");
  }
}
function CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cdk-nested-tree-node", 6);
    i0.ɵɵtemplate(1, CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_2_span_1_Template, 2, 2, "span", 7);
    i0.ɵɵelementStart(2, "a", 11);
    i0.ɵɵlistener("click", function CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_2_Template_a_click_2_listener() {
      const node_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.onExpandClick(node_r7, ctx_r2.treeControl.isExpanded(node_r7)));
    });
    i0.ɵɵelementStart(3, "div", 12);
    i0.ɵɵelement(4, "cui-icon", 13);
    i0.ɵɵtemplate(5, CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_2_span_5_Template, 2, 2, "span", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_2_cui_icon_6_Template, 1, 1, "cui-icon", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 15);
    i0.ɵɵelementContainer(8, 16);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const node_r7 = ctx.$implicit;
    const obs_r5 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", obs_r5.isNavExpanded && node_r7.groupName && node_r7.isFirstWithGroupName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matTooltipDisabled", obs_r5.isNavExpanded)("matTooltip", node_r7.name)("matTooltipPosition", "right")("ngClass", i0.ɵɵpureFunction1(12, _c30, !obs_r5.isNavExpanded));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", node_r7.icon)("isActive", ctx_r2.treeControl.isExpanded(node_r7));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", obs_r5.isNavExpanded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", obs_r5.isNavExpanded);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("tree-invisible", !ctx_r2.treeControl.isExpanded(node_r7));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c32, !obs_r5.isNavExpanded));
  }
}
function CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "cdk-tree", 3);
    i0.ɵɵtemplate(1, CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_1_Template, 6, 11, "cdk-nested-tree-node", 4)(2, CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_cdk_nested_tree_node_2_Template, 9, 16, "cdk-nested-tree-node", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("dataSource", ctx_r2.dataSource)("treeControl", ctx_r2.treeControl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cdkTreeNodeDefWhen", ctx_r2.hasChild);
  }
}
function CuiSideNavExpandComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CuiSideNavExpandComponent_ng_container_0_cdk_tree_1_Template, 3, 3, "cdk-tree", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.dataSource);
  }
}
function CuiSideNavGroupComponent_h2_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function CuiSideNavItemComponent_ng_container_0_ng_container_1_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("@fadeIn", undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.name);
  }
}
function CuiSideNavItemComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 2);
    i0.ɵɵlistener("click", function CuiSideNavItemComponent_ng_container_0_ng_container_1_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onLinkClick(ctx_r1.externalUrl));
    });
    i0.ɵɵelement(2, "cui-icon", 3, 0);
    i0.ɵɵtemplate(4, CuiSideNavItemComponent_ng_container_0_ng_container_1_span_4_Template, 2, 2, "span", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const elem_r3 = i0.ɵɵreference(3);
    const obs_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r1.externalUrl, i0.ɵɵsanitizeUrl)("matTooltipDisabled", obs_r4.isNavExpanded)("matTooltip", ctx_r1.name)("matTooltipPosition", "right")("ngClass", i0.ɵɵpureFunction1(8, _c30, !obs_r4.isNavExpanded));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.icon)("isActive", elem_r3.elementRef.nativeElement.className.includes("active"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", obs_r4.isNavExpanded);
  }
}
function CuiSideNavItemComponent_ng_container_0_ng_container_2_a_1_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("@fadeIn", undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.name);
  }
}
function CuiSideNavItemComponent_ng_container_0_ng_container_2_a_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 6);
    i0.ɵɵlistener("click", function CuiSideNavItemComponent_ng_container_0_ng_container_2_a_1_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onLinkClick(ctx_r1.url));
    });
    i0.ɵɵelement(1, "cui-icon", 3, 0);
    i0.ɵɵtemplate(3, CuiSideNavItemComponent_ng_container_0_ng_container_2_a_1_span_3_Template, 2, 2, "span", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const elem_r6 = i0.ɵɵreference(2);
    const obs_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r1.url)("matTooltipDisabled", obs_r4.isNavExpanded)("matTooltip", ctx_r1.name)("matTooltipPosition", "right")("ngClass", i0.ɵɵpureFunction1(8, _c30, !obs_r4.isNavExpanded));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.icon)("isActive", elem_r6.elementRef.nativeElement.className.includes("active"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", obs_r4.isNavExpanded);
  }
}
function CuiSideNavItemComponent_ng_container_0_ng_container_2_a_2_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("@fadeIn", undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.name);
  }
}
function CuiSideNavItemComponent_ng_container_0_ng_container_2_a_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵlistener("click", function CuiSideNavItemComponent_ng_container_0_ng_container_2_a_2_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onLinkClick());
    });
    i0.ɵɵelement(1, "cui-icon", 8, 0);
    i0.ɵɵtemplate(3, CuiSideNavItemComponent_ng_container_0_ng_container_2_a_2_span_3_Template, 2, 2, "span", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const elem_r8 = i0.ɵɵreference(2);
    const obs_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltipDisabled", obs_r4.isNavExpanded)("matTooltip", ctx_r1.name)("matTooltipPosition", "right")("ngClass", i0.ɵɵpureFunction1(7, _c30, !obs_r4.isNavExpanded));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.icon)("isActive", elem_r8.elementRef.nativeElement.className.includes("active"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", obs_r4.isNavExpanded);
  }
}
function CuiSideNavItemComponent_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CuiSideNavItemComponent_ng_container_0_ng_container_2_a_1_Template, 4, 10, "a", 4)(2, CuiSideNavItemComponent_ng_container_0_ng_container_2_a_2_Template, 4, 9, "a", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !!ctx_r1.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.url);
  }
}
function CuiSideNavItemComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CuiSideNavItemComponent_ng_container_0_ng_container_1_Template, 5, 10, "ng-container", 1)(2, CuiSideNavItemComponent_ng_container_0_ng_container_2_Template, 3, 2, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.externalUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.externalUrl);
  }
}
const _c33 = "[_nghost-%COMP%]{display:flex;justify-content:stretch;font-weight:var(--cui-font-weight-medium)}.active[_nghost-%COMP%]   .handle[_ngcontent-%COMP%]{background-color:var(--cui-color-active);color:var(--cui-color-titles)}.active[_nghost-%COMP%]   .handle[_ngcontent-%COMP%]:hover{background-color:var(--cui-color-hover);color:var(--cui-color-titles)}.handle[_ngcontent-%COMP%]:hover{background-color:var(--cui-color-hover);color:var(--cui-color-titles)}.handle[_ngcontent-%COMP%]{cursor:pointer;height:2.5rem;padding:0 var(--cui-large-space);display:flex;border:none;width:100%;font-family:var(--cui-font-family);font-size:var(--cui-font-h5-size);text-decoration:none;align-items:center;color:var(--cui-color-breadcrumbs);font-weight:var(--cui-font-weight-medium);transition:background-color linear .2s,color linear .2s}.handle.collapsed-view[_ngcontent-%COMP%]{display:flex;justify-content:center;width:100%;padding:0}.handle.collapsed-view[_ngcontent-%COMP%]   cui-icon[_ngcontent-%COMP%]{margin:0}.no-wrap[_ngcontent-%COMP%]{overflow:hidden}.no-wrap[_ngcontent-%COMP%]   div[_ngcontent-%COMP%], .no-wrap[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}cui-icon[_ngcontent-%COMP%]{color:var(--cui-color-primary);margin-right:var(--cui-medium-space)}a[href].active[_ngcontent-%COMP%]{color:var(--cui-color-primary);background-color:var(--cui-color-active)}";
function CuiSimpleTableComponent_mat_table_0_ng_container_1_mat_header_cell_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", column_r1.headerName, " ");
  }
}
function CuiSimpleTableComponent_mat_table_0_ng_container_1_mat_cell_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r2 = ctx.$implicit;
    const column_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", column_r1.valueSelector(row_r2), " ");
  }
}
function CuiSimpleTableComponent_mat_table_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 5);
    i0.ɵɵtemplate(1, CuiSimpleTableComponent_mat_table_0_ng_container_1_mat_header_cell_1_Template, 2, 1, "mat-header-cell", 6)(2, CuiSimpleTableComponent_mat_table_0_ng_container_1_mat_cell_2_Template, 2, 1, "mat-cell", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const column_r1 = ctx.$implicit;
    i0.ɵɵproperty("matColumnDef", column_r1.key);
  }
}
function CuiSimpleTableComponent_mat_table_0_mat_header_row_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-row");
  }
}
function CuiSimpleTableComponent_mat_table_0_mat_row_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-row");
  }
}
function CuiSimpleTableComponent_mat_table_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-table", 1);
    i0.ɵɵtemplate(1, CuiSimpleTableComponent_mat_table_0_ng_container_1_Template, 3, 1, "ng-container", 2)(2, CuiSimpleTableComponent_mat_table_0_mat_header_row_2_Template, 1, 0, "mat-header-row", 3);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtemplate(4, CuiSimpleTableComponent_mat_table_0_mat_row_4_Template, 1, 0, "mat-row", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dataSource", ctx_r2.dataSource);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._colDefs);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matHeaderRowDef", ctx_r2._colHeaders)("matHeaderRowDefSticky", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matRowDefColumns", ctx_r2._colHeaders);
  }
}
function CuiSlideToggleComponent_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function RangeDateFilterComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "form", 3);
    i0.ɵɵelement(1, "cui-date-picker", 4)(2, "cui-date-picker", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", ctx_r0.params.labelFrom || "From")("panelClass", "ag-custom-component-popup");
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", ctx_r0.params.labelTo || "To")("panelClass", "ag-custom-component-popup")("minDate", ctx_r0.createdFromControl == null ? null : ctx_r0.createdFromControl.value);
  }
}
function CustomTextFilterComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "form", 3);
    i0.ɵɵelement(1, "cui-input", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", (tmp_2_0 = ctx_r0.params.label) !== null && tmp_2_0 !== undefined ? tmp_2_0 : "Text");
  }
}
const _c34 = "[_nghost-%COMP%]{display:block;padding:var(--cui-small-space);padding-bottom:0}.ag-filter-apply-panel[_ngcontent-%COMP%]{display:flex;gap:var(--cui-small-space)}";
function CuiMultilineCellRendererComponent_small_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.line2);
  }
}
function CuiMultilineCellRendererComponent_mat_error_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.errorMessage);
  }
}
function CuiTableCellCheckmarkRendererComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "N/A");
    i0.ɵɵelementContainerEnd();
  }
}
function CuiTableCellCheckmarkRendererComponent_cui_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cui-icon", 2);
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "check");
  }
}
function CuiTableCellCheckmarkRendererComponent_cui_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cui-icon", 2);
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "close");
  }
}
const _forTrack0 = ($index, $item) => $item.name;
const _forTrack1 = ($index, $item) => $item.type;
function CuiTableRowDetailRendererComponent_For_2_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵtext(0);
    i0.ɵɵelementStart(1, "cui-icon-btn", 4);
    i0.ɵɵlistener("clicked", function CuiTableRowDetailRendererComponent_For_2_Conditional_4_Conditional_0_Template_cui_icon_btn_clicked_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const params_r2 = i0.ɵɵnextContext();
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.setValue(params_r2.value.iconAction, params_r2.setValue));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const params_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", params_r2.value.cellValue, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", params_r2.value.iconName)("disabled", params_r2.value.iconDisabled);
  }
}
function CuiTableRowDetailRendererComponent_For_2_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵelement(1, "cui-icon", 5);
  }
  if (rf & 2) {
    const params_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", params_r2.value.cellValue, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", params_r2.value.iconName)("tooltipText", params_r2.value.iconTooltip);
  }
}
function CuiTableRowDetailRendererComponent_For_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CuiTableRowDetailRendererComponent_For_2_Conditional_4_Conditional_0_Template, 2, 3)(1, CuiTableRowDetailRendererComponent_For_2_Conditional_4_Conditional_1_Template, 2, 3);
  }
  if (rf & 2) {
    const property_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵconditional(property_r4.renderer.type === "cuiTableCellIconButtonRenderer" ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(property_r4.renderer.type === "cuiTableCellIconRenderer" ? 1 : -1);
  }
}
function CuiTableRowDetailRendererComponent_For_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cui-icon", 3);
  }
  if (rf & 2) {
    const property_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", property_r4.renderer.isChecked === true ? "check" : "close");
  }
}
function CuiTableRowDetailRendererComponent_For_2_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const property_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(property_r4.value);
  }
}
function CuiTableRowDetailRendererComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "p", 1);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 2);
    i0.ɵɵtemplate(4, CuiTableRowDetailRendererComponent_For_2_Conditional_4_Template, 2, 2)(5, CuiTableRowDetailRendererComponent_For_2_Conditional_5_Template, 1, 1, "cui-icon", 3)(6, CuiTableRowDetailRendererComponent_For_2_Conditional_6_Template, 2, 1, "p");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_11_0;
    const property_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(property_r4.name);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_11_0 = property_r4.renderer.params) ? 4 : property_r4.renderer.isChecked === true || property_r4.renderer.isChecked === false ? 5 : 6, tmp_11_0);
  }
}
function CuiTableRowDetailRendererComponent_Conditional_3_For_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cui-icon-btn", 4);
    i0.ɵɵlistener("clicked", function CuiTableRowDetailRendererComponent_Conditional_3_For_4_Conditional_0_Template_cui_icon_btn_clicked_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const action_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.setValue(action_r6.params.value.iconAction, action_r6.params.setValue));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", action_r6.params.value.iconName)("disabled", action_r6.params.value.iconDisabled);
  }
}
function CuiTableRowDetailRendererComponent_Conditional_3_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CuiTableRowDetailRendererComponent_Conditional_3_For_4_Conditional_0_Template, 1, 2, "cui-icon-btn", 7);
  }
  if (rf & 2) {
    const action_r6 = ctx.$implicit;
    i0.ɵɵconditional(action_r6.params ? 0 : -1);
  }
}
function CuiTableRowDetailRendererComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 1);
    i0.ɵɵtext(1, "Actions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 6);
    i0.ɵɵrepeaterCreate(3, CuiTableRowDetailRendererComponent_Conditional_3_For_4_Template, 1, 1, null, null, _forTrack1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r2.actionColumns);
  }
}
function CuiTableButtonComponent_cui_button_cta_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cui-button-cta", 4);
    i0.ɵɵlistener("clicked", function CuiTableButtonComponent_cui_button_cta_0_Template_cui_button_cta_clicked_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.ctaClicked.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ctaTooltip", ctx_r1.ctaTooltip)("disabled", ctx_r1.ctaDisabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.ctaText);
  }
}
function CuiTableButtonComponent_cui_button_cta_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cui-button-cta", 4);
    i0.ɵɵlistener("clicked", function CuiTableButtonComponent_cui_button_cta_1_Template_cui_button_cta_clicked_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.secondaryBtnClicked.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ctaTooltip", ctx_r1.secondaryBtnTooltip)("disabled", ctx_r1.secondaryBtnDisabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.secondaryBtnText);
  }
}
function CuiTableButtonComponent_button_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵelement(1, "cui-icon", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const menu_r4 = i0.ɵɵreference(4);
    i0.ɵɵproperty("matMenuTriggerFor", menu_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "menu");
  }
}
function CuiTableButtonComponent_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function CuiTableButtonComponent_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.ctaClicked.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.ctaDisabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.ctaText, " ");
  }
}
function CuiTableButtonComponent_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function CuiTableButtonComponent_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.secondaryBtnClicked.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.secondaryBtnDisabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.secondaryBtnText, " ");
  }
}
function CuiTableToggleComponent_mat_button_toggle_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-button-toggle", 3);
    i0.ɵɵlistener("click", function CuiTableToggleComponent_mat_button_toggle_2_Template_mat_button_toggle_click_0_listener() {
      const option_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleClicked.emit(option_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r2, " ");
  }
}
function CuiTableControlsComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cui-input", 3);
    i0.ɵɵlistener("clearSearch", function CuiTableControlsComponent_Conditional_0_Template_cui_input_clearSearch_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearSearch());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formControl", ctx_r1.searchControl)("label", "Search...")("prefixIcon", "search")("clearBtn", true);
  }
}
function CuiTableControlsComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cui-table-toggle", 4);
    i0.ɵɵlistener("toggleClicked", function CuiTableControlsComponent_Conditional_1_Template_cui_table_toggle_toggleClicked_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleClicked.emit($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("toggleDefaultOption", ctx_r1.toggleDefaultOption)("toggleOptions", ctx_r1.toggleOptions);
  }
}
const _c35 = a0 => ({
  isMobileView: a0
});
function CuiTopMenuItemComponent_div_0_cui_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cui-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.iconName);
  }
}
function CuiTopMenuItemComponent_div_0_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function CuiTopMenuItemComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, CuiTopMenuItemComponent_div_0_cui_icon_1_Template, 1, 1, "cui-icon", 2)(2, CuiTopMenuItemComponent_div_0_span_2_Template, 2, 1, "span", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const obs_r2 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltipDisabled", obs_r2.isMobileView)("matTooltip", ctx_r0.tooltipText)("matTooltipPosition", "below");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.iconName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !obs_r2.isMobileView && ctx_r0.text);
  }
}
const _c36 = [[["cui-top-menu-item"]]];
const _c37 = ["cui-top-menu-item"];
const _c38 = (a0, a1) => ({
  isSideOpen: a0,
  isMobileView: a1
});
const _c39 = (a0, a1) => ({
  "mobile-logo-size": a0,
  "companial-logo-size": a1
});
function CuiTopMenuComponent_mat_toolbar_0_cui_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cui-icon", 6);
    i0.ɵɵlistener("click", function CuiTopMenuComponent_mat_toolbar_0_cui_icon_2_Template_cui_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const obs_r2 = i0.ɵɵnextContext().ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onToolbarMenuToggle(obs_r2.isSideOpen));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "menu");
  }
}
function CuiTopMenuComponent_mat_toolbar_0_img_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 7);
  }
  if (rf & 2) {
    const obs_r2 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c39, obs_r2.isMobileView, !obs_r2.isMobileView))("src", "assets/companialLogo.svg", i0.ɵɵsanitizeUrl);
  }
}
function CuiTopMenuComponent_mat_toolbar_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-toolbar", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, CuiTopMenuComponent_mat_toolbar_0_cui_icon_2_Template, 1, 1, "cui-icon", 3)(3, CuiTopMenuComponent_mat_toolbar_0_img_3_Template, 1, 5, "img", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵprojection(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showLogo);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showLogo);
  }
}
let CuiAppContainerComponent = /*#__PURE__*/(() => {
  class CuiAppContainerComponent {
    static {
      this.ɵfac = function CuiAppContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiAppContainerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiAppContainerComponent,
        selectors: [["cui-app-container"]],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        template: function CuiAppContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵprojection(0);
            i0.ɵɵprojection(1, 1);
            i0.ɵɵprojection(2, 2);
          }
        },
        dependencies: [CommonModule, RouterModule],
        styles: ["[_nghost-%COMP%]{display:grid;grid-template-areas:\"top-menu top-menu\" \"side-nav  body\" \"side-nav  body\";height:100%;overflow:hidden;grid-template-columns:auto 1fr;grid-template-rows:auto 1fr}"]
      });
    }
  }
  return CuiAppContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiButtonComponent = /*#__PURE__*/(() => {
  class CuiButtonComponent {
    constructor() {
      this.clicked = new EventEmitter();
    }
    onClick(event) {
      event.stopPropagation();
      if (!this.disabled) {
        this.clicked.emit();
      }
    }
    focus() {
      this.btn.focus();
    }
    static {
      this.ɵfac = function CuiButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiButtonComponent,
        selectors: [["cui-button"]],
        viewQuery: function CuiButtonComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.btn = _t.first);
          }
        },
        inputs: {
          disabled: "disabled"
        },
        outputs: {
          clicked: "clicked"
        },
        ngContentSelectors: _c3,
        decls: 3,
        vars: 1,
        consts: [["btn", ""], ["mat-stroked-button", "", "type", "button", "color", "accent", "disableRipple", "true", 3, "click", "disabled"]],
        template: function CuiButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "button", 1, 0);
            i0.ɵɵlistener("click", function CuiButtonComponent_Template_button_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClick($event));
            });
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("disabled", ctx.disabled);
          }
        },
        dependencies: [MatButtonModule, i1.MatButton],
        styles: ["button[_ngcontent-%COMP%]{font-family:var(--cui-font-buttons-font-family);font-size:var(--cui-font-buttons-size-large);font-weight:var(--cui-font-buttons-weight);line-height:var(--cui-font-buttons-line-height-large);border-radius:var(--cui-size-buttons-border-radius);min-width:var(--cui-size-buttons-min-width);padding:0 var(--cui-size-buttons-padding-left-right);height:var(--cui-size-buttons-height-large);text-transform:var(--cui-buttons-text-transform);letter-spacing:var(--cui-font-buttons-letter-spacing-large)}.mat-stroked-button[_ngcontent-%COMP%]:not(.mat-button-disabled){border-color:var(--cui-button-color)}.mat-stroked-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%]{color:var(--cui-color-buttons-disabled);border-color:var(--cui-color-buttons-disabled)}"],
        changeDetection: 0
      });
    }
  }
  return CuiButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiIconComponent = /*#__PURE__*/(() => {
  class CuiIconComponent {
    constructor(elementRef) {
      this.elementRef = elementRef;
      this.name = '';
      this.isActive = false;
      this.tooltipText = '';
    }
    static {
      this.ɵfac = function CuiIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiIconComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiIconComponent,
        selectors: [["cui-icon"]],
        inputs: {
          name: "name",
          isActive: "isActive",
          tooltipText: "tooltipText"
        },
        decls: 1,
        vars: 1,
        consts: [[3, "ngClass", "matTooltip", 4, "ngIf"], [3, "ngClass", "matTooltip"]],
        template: function CuiIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CuiIconComponent_mat_icon_0_Template, 2, 5, "mat-icon", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.name);
          }
        },
        dependencies: [CommonModule, i2.NgClass, i2.NgIf, MatIconModule, i2$1.MatIcon, MatTooltipModule, i3.MatTooltip],
        styles: ["[_nghost-%COMP%]{display:flex}"],
        changeDetection: 0
      });
    }
  }
  return CuiIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiButtonDropdownComponent = /*#__PURE__*/(() => {
  class CuiButtonDropdownComponent {
    constructor() {
      this.text = '';
      this.disabled = false;
      this.clicked = new EventEmitter();
    }
    onClick(event) {
      event.stopPropagation();
      if (!this.disabled) {
        this.clicked.emit();
      }
    }
    static {
      this.ɵfac = function CuiButtonDropdownComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiButtonDropdownComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiButtonDropdownComponent,
        selectors: [["cui-button-dropdown"]],
        inputs: {
          text: "text",
          disabled: "disabled"
        },
        outputs: {
          clicked: "clicked"
        },
        ngContentSelectors: _c3,
        decls: 8,
        vars: 4,
        consts: [["dropdownMenu", ""], ["disableRipple", "true", 1, "cui-btn-dropdown-cta", 3, "click", "disabled"], ["disableRipple", "true", 1, "cui-btn-dropdown", 3, "matMenuTriggerFor"], [3, "name"]],
        template: function CuiButtonDropdownComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "mat-button-toggle-group")(1, "mat-button-toggle", 1);
            i0.ɵɵlistener("click", function CuiButtonDropdownComponent_Template_mat_button_toggle_click_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClick($event));
            });
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "mat-button-toggle", 2);
            i0.ɵɵelement(4, "cui-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "mat-menu", null, 0);
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const dropdownMenu_r2 = i0.ɵɵreference(6);
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.text);
            i0.ɵɵadvance();
            i0.ɵɵproperty("matMenuTriggerFor", dropdownMenu_r2);
            i0.ɵɵadvance();
            i0.ɵɵproperty("name", "arrow_drop_down");
          }
        },
        dependencies: [CommonModule, MatButtonModule, MatMenuModule, i2$2.MatMenu, i2$2.MatMenuTrigger, CuiIconComponent, MatButtonToggleModule, i2$3.MatButtonToggleGroup, i2$3.MatButtonToggle],
        styles: ["[_nghost-%COMP%]   mat-button-toggle-group[_ngcontent-%COMP%]{border-radius:var(--cui-size-buttons-border-radius);height:var(--cui-size-buttons-height-large);border:none;box-shadow:var(--mdc-protected-button-container-elevation-shadow)}"],
        changeDetection: 0
      });
    }
  }
  return CuiButtonDropdownComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiButtonDropdownActionComponent = /*#__PURE__*/(() => {
  class CuiButtonDropdownActionComponent {
    constructor() {
      this.icon = '';
      this.disabled = false;
      this.clicked = new EventEmitter();
    }
    onClick() {
      if (!this.disabled) {
        this.clicked.emit();
      }
    }
    static {
      this.ɵfac = function CuiButtonDropdownActionComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiButtonDropdownActionComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiButtonDropdownActionComponent,
        selectors: [["cui-button-dropdown-action"]],
        inputs: {
          icon: "icon",
          disabled: "disabled"
        },
        outputs: {
          clicked: "clicked"
        },
        ngContentSelectors: _c3,
        decls: 4,
        vars: 2,
        consts: [["type", "button", "mat-menu-item", "", "disableRipple", "true", 3, "click", "disabled"], [1, "action-content"], [3, "name", 4, "ngIf"], [3, "name"]],
        template: function CuiButtonDropdownActionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function CuiButtonDropdownActionComponent_Template_button_click_0_listener() {
              return ctx.onClick();
            });
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵtemplate(2, CuiButtonDropdownActionComponent_cui_icon_2_Template, 1, 1, "cui-icon", 2);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.icon);
          }
        },
        dependencies: [CommonModule, i2.NgIf, MatButtonModule, MatMenuModule, i2$2.MatMenuItem, CuiIconComponent],
        styles: ["button[_ngcontent-%COMP%]{min-height:32px}button[_ngcontent-%COMP%]   .action-content[_ngcontent-%COMP%]{display:flex;color:var(--cui-color-body-text);font-family:var(--cui-font-buttons-font-family);font-weight:var(--cui-font-buttons-weight);font-size:var(--cui-font-buttons-size-small);line-height:var(--cui-font-buttons-line-height-small);text-transform:var(--cui-buttons-text-transform);letter-spacing:var(--cui-font-buttons-letter-spacing-large);border-right:var(--cui-size-buttons-border-right);align-items:center}"],
        changeDetection: 0
      });
    }
  }
  return CuiButtonDropdownActionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiButtonCtaComponent = /*#__PURE__*/(() => {
  class CuiButtonCtaComponent {
    constructor() {
      this.type = 'submit';
      this.clicked = new EventEmitter();
    }
    onClick(event) {
      event.stopPropagation();
      if (!this.disabled) {
        this.clicked.emit();
      }
    }
    focus() {
      this.btn.focus();
    }
    static {
      this.ɵfac = function CuiButtonCtaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiButtonCtaComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiButtonCtaComponent,
        selectors: [["cui-button-cta"]],
        viewQuery: function CuiButtonCtaComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.btn = _t.first);
          }
        },
        inputs: {
          disabled: "disabled",
          type: "type",
          ctaTooltip: "ctaTooltip"
        },
        outputs: {
          clicked: "clicked"
        },
        ngContentSelectors: _c3,
        decls: 4,
        vars: 4,
        consts: [["btn", ""], [3, "matTooltip", "matTooltipDisabled"], ["mat-raised-button", "", "color", "accent", "disableRipple", "true", 1, "cui-btn-cta", 3, "click", "type", "disabled"]],
        template: function CuiButtonCtaComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1)(1, "button", 2, 0);
            i0.ɵɵlistener("click", function CuiButtonCtaComponent_Template_button_click_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClick($event));
            });
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("matTooltip", ctx.ctaTooltip)("matTooltipDisabled", !ctx.ctaTooltip);
            i0.ɵɵadvance();
            i0.ɵɵproperty("type", ctx.type)("disabled", ctx.disabled);
          }
        },
        dependencies: [MatButtonModule, i1.MatButton, MatTooltipModule, i3.MatTooltip],
        styles: ["button.cui-btn-cta[_ngcontent-%COMP%]{font-family:var(--cui-font-buttons-font-family);font-weight:var(--cui-font-buttons-weight);font-size:var(--cui-font-buttons-size-large);line-height:var(--cui-font-buttons-line-height-large);border-radius:var(--cui-size-buttons-border-radius);min-width:var(--cui-size-buttons-min-width);padding:0 var(--cui-size-buttons-padding-left-right);height:var(--cui-size-buttons-height-large);text-transform:var(--cui-buttons-text-transform);letter-spacing:var(--cui-font-buttons-letter-spacing-large);color:var(--color-white)}.mat-tooltip-trigger[_ngcontent-%COMP%]{display:inline-flex}.mat-raised-button[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:none}.mat-raised-button[_ngcontent-%COMP%]:not(.mat-button-disabled):active{box-shadow:none}.mat-raised-button[_ngcontent-%COMP%]:not(.mat-button-disabled):active:not([class*=mat-elevation-z]){box-shadow:none}.mat-raised-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%]{background-color:var(--cui-color-buttons-disabled)}"],
        changeDetection: 0
      });
    }
  }
  return CuiButtonCtaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiButtonLinkComponent = /*#__PURE__*/(() => {
  class CuiButtonLinkComponent {
    static {
      this.ɵfac = function CuiButtonLinkComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiButtonLinkComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiButtonLinkComponent,
        selectors: [["cui-button-link"]],
        inputs: {
          link: "link",
          disabled: "disabled"
        },
        ngContentSelectors: _c3,
        decls: 2,
        vars: 2,
        consts: [["mat-button", "", "color", "accent", "disableRipple", "true", "routerLinkActive", "active", 3, "disabled", "routerLink"]],
        template: function CuiButtonLinkComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "a", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("disabled", ctx.disabled)("routerLink", ctx.link);
          }
        },
        dependencies: [RouterModule, i1$1.RouterLink, i1$1.RouterLinkActive, MatButtonModule, i1.MatAnchor],
        styles: ["a[_ngcontent-%COMP%]{font-family:var(--cui-font-buttons-font-family);font-size:var(--cui-font-buttons-size-large);font-weight:var(--cui-font-buttons-weight);line-height:var(--cui-font-buttons-line-height-large);border-radius:var(--cui-size-buttons-border-radius);min-width:var(--cui-size-buttons-min-width);padding:calc(var(--cui-medium-space) - 1px) var(--cui-size-buttons-padding-left-right);height:var(--cui-size-buttons-height-large);text-transform:var(--cui-buttons-text-transform)}a[_ngcontent-%COMP%]:hover, a[_ngcontent-%COMP%]:focus, a[_ngcontent-%COMP%]:active{text-decoration:underline;outline:none}a.active[_ngcontent-%COMP%]{border-color:var(--cui-color-buttons-active);color:var(--cui-color-buttons-active)}.mat-stroked-button[_ngcontent-%COMP%]:not(.mat-button-disabled){border-color:var(--cui-button-color)}.mat-stroked-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%]{color:var(--cui-color-buttons-disabled);border-color:var(--cui-color-buttons-disabled)}"],
        changeDetection: 0
      });
    }
  }
  return CuiButtonLinkComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiButtonLinkCtaComponent = /*#__PURE__*/(() => {
  class CuiButtonLinkCtaComponent {
    constructor() {
      this.tooltipText = '';
    }
    static {
      this.ɵfac = function CuiButtonLinkCtaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiButtonLinkCtaComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiButtonLinkCtaComponent,
        selectors: [["cui-button-link-cta"]],
        inputs: {
          link: "link",
          tooltipText: "tooltipText",
          disabled: "disabled"
        },
        ngContentSelectors: _c3,
        decls: 2,
        vars: 3,
        consts: [["mat-raised-button", "", "color", "accent", "disableRipple", "true", "routerLinkActive", "active", 1, "cui-btn-link-cta", 3, "matTooltip", "disabled", "routerLink"]],
        template: function CuiButtonLinkCtaComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "a", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("matTooltip", ctx.tooltipText)("disabled", ctx.disabled)("routerLink", ctx.link);
          }
        },
        dependencies: [RouterModule, i1$1.RouterLink, i1$1.RouterLinkActive, MatButtonModule, i1.MatAnchor, MatTooltipModule, i3.MatTooltip],
        styles: ["a.cui-btn-link-cta[_ngcontent-%COMP%]{font-family:var(--cui-font-buttons-font-family);font-size:var(--cui-font-buttons-size-large);font-weight:var(--cui-font-buttons-weight);line-height:var(--cui-font-buttons-line-height-large);border-radius:var(--cui-size-buttons-border-radius);min-width:var(--cui-size-buttons-min-width);padding:var(--cui-medium-space) var(--cui-size-buttons-padding-left-right);height:var(--cui-size-buttons-height-large);text-transform:var(--cui-buttons-text-transform);letter-spacing:var(--cui-font-buttons-letter-spacing-large);color:var(--color-white)}a.cui-btn-link-cta[_ngcontent-%COMP%]:hover, a.cui-btn-link-cta[_ngcontent-%COMP%]:focus, a.cui-btn-link-cta[_ngcontent-%COMP%]:active{text-decoration:none;outline:none}a.cui-btn-link-cta.active[_ngcontent-%COMP%]{background-color:var(--cui-color-buttons-active)}.mat-raised-button[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:none}.mat-raised-button[_ngcontent-%COMP%]:not(.mat-button-disabled):active{box-shadow:none}.mat-raised-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%]{background-color:var(--cui-color-buttons-disabled)}"],
        changeDetection: 0
      });
    }
  }
  return CuiButtonLinkCtaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiButtonsModule = /*#__PURE__*/(() => {
  class CuiButtonsModule {
    static {
      this.ɵfac = function CuiButtonsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiButtonsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CuiButtonsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CuiButtonComponent, CuiButtonDropdownActionComponent, CuiButtonDropdownComponent, CuiButtonCtaComponent, CuiButtonLinkComponent, CuiButtonLinkCtaComponent]
      });
    }
  }
  return CuiButtonsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiCardBodyComponent = /*#__PURE__*/(() => {
  class CuiCardBodyComponent {
    static {
      this.ɵfac = function CuiCardBodyComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiCardBodyComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiCardBodyComponent,
        selectors: [["cui-card-body"]],
        standalone: false,
        ngContentSelectors: _c3,
        decls: 1,
        vars: 0,
        template: function CuiCardBodyComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        styles: ["[_nghost-%COMP%]{display:block;overflow:auto;color:var(--cui-color-body-text);scrollbar-gutter:stable}"],
        changeDetection: 0
      });
    }
  }
  return CuiCardBodyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiCardFooterComponent = /*#__PURE__*/(() => {
  class CuiCardFooterComponent {
    static {
      this.ɵfac = function CuiCardFooterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiCardFooterComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiCardFooterComponent,
        selectors: [["cui-card-footer"]],
        standalone: false,
        ngContentSelectors: _c3,
        decls: 1,
        vars: 0,
        template: function CuiCardFooterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        styles: ["[_nghost-%COMP%]{display:flex;gap:var(--cui-medium-space);padding-right:var(--cui-medium-space);justify-content:flex-end}"],
        changeDetection: 0
      });
    }
  }
  return CuiCardFooterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiIconButtonComponent = /*#__PURE__*/(() => {
  class CuiIconButtonComponent {
    constructor() {
      this.name = '';
      this.disabled = false;
      this.clicked = new EventEmitter();
    }
    static {
      this.ɵfac = function CuiIconButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiIconButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiIconButtonComponent,
        selectors: [["cui-icon-btn"]],
        inputs: {
          name: "name",
          disabled: "disabled"
        },
        outputs: {
          clicked: "clicked"
        },
        decls: 2,
        vars: 2,
        consts: [["mat-icon-button", "", 3, "click", "disabled"], [4, "ngIf"]],
        template: function CuiIconButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function CuiIconButtonComponent_Template_button_click_0_listener() {
              return ctx.clicked.emit();
            });
            i0.ɵɵtemplate(1, CuiIconButtonComponent_mat_icon_1_Template, 2, 1, "mat-icon", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.name);
          }
        },
        dependencies: [CommonModule, i2.NgIf, MatIconModule, i2$1.MatIcon, MatButtonModule, i1.MatIconButton],
        styles: ["[_nghost-%COMP%]{display:flex}"],
        changeDetection: 0
      });
    }
  }
  return CuiIconButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiCardHeaderComponent = /*#__PURE__*/(() => {
  class CuiCardHeaderComponent {
    constructor() {
      this.showCloseBtn = false;
      this.close = new EventEmitter();
    }
    static {
      this.ɵfac = function CuiCardHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiCardHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiCardHeaderComponent,
        selectors: [["cui-card-header"]],
        inputs: {
          showCloseBtn: "showCloseBtn"
        },
        outputs: {
          close: "close"
        },
        standalone: false,
        ngContentSelectors: _c3,
        decls: 2,
        vars: 1,
        consts: [["class", "close-btn", "aria-label", "close", 3, "name", "clicked", 4, "ngIf"], ["aria-label", "close", 1, "close-btn", 3, "clicked", "name"]],
        template: function CuiCardHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
            i0.ɵɵtemplate(1, CuiCardHeaderComponent_cui_icon_btn_1_Template, 1, 1, "cui-icon-btn", 0);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showCloseBtn);
          }
        },
        dependencies: [i2.NgIf, CuiIconButtonComponent],
        styles: ["[_nghost-%COMP%]{display:flex;justify-content:space-between;align-items:center;gap:var(--cui-medium-space);padding-right:var(--cui-medium-space)}.close-btn[_ngcontent-%COMP%]{align-self:flex-start}"],
        changeDetection: 0
      });
    }
  }
  return CuiCardHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiCardComponent = /*#__PURE__*/(() => {
  class CuiCardComponent {
    constructor() {
      this.isLoading = false;
    }
    get hideContent() {
      return this.isLoading;
    }
    static {
      this.ɵfac = function CuiCardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiCardComponent,
        selectors: [["cui-card"]],
        hostVars: 2,
        hostBindings: function CuiCardComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("hidden-content", ctx.hideContent);
          }
        },
        inputs: {
          isLoading: "isLoading"
        },
        standalone: false,
        ngContentSelectors: _c6,
        decls: 4,
        vars: 1,
        consts: [["class", "spinner-container", 4, "ngIf"], [1, "spinner-container"], ["mode", "indeterminate", 1, "absolute-centered", 3, "diameter"]],
        template: function CuiCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c5);
            i0.ɵɵprojection(0);
            i0.ɵɵprojection(1, 1);
            i0.ɵɵprojection(2, 2);
            i0.ɵɵtemplate(3, CuiCardComponent_div_3_Template, 2, 1, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.isLoading);
          }
        },
        dependencies: [i2.NgIf, i3$1.MatProgressSpinner],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;background-color:var(--cui-color-card-bg);border-radius:var(--cui-border-radius);box-shadow:var(--cui-shadow);padding:var(--cui-medium-space) 0 var(--cui-medium-space) var(--cui-medium-space);overflow:hidden;position:relative;gap:var(--cui-small-space);max-height:inherit}.spinner-container[_ngcontent-%COMP%]   .absolute-centered[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}"],
        changeDetection: 0
      });
    }
  }
  return CuiCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiCardModule = /*#__PURE__*/(() => {
  class CuiCardModule {
    static {
      this.ɵfac = function CuiCardModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiCardModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CuiCardModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatProgressSpinnerModule, MatButtonModule, CuiIconButtonComponent]
      });
    }
  }
  return CuiCardModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ApplicationReloadNotificationComponent = /*#__PURE__*/(() => {
  class ApplicationReloadNotificationComponent {
    constructor(data) {
      this.data = data;
    }
    reload() {
      document.location.reload();
    }
    static {
      this.ɵfac = function ApplicationReloadNotificationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ApplicationReloadNotificationComponent)(i0.ɵɵdirectiveInject(MAT_SNACK_BAR_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ApplicationReloadNotificationComponent,
        selectors: [["cui-app-reload-notification"]],
        decls: 4,
        vars: 1,
        consts: [["mat-button", "", "color", "accent", 3, "click"]],
        template: function ApplicationReloadNotificationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "span");
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "button", 0);
            i0.ɵɵlistener("click", function ApplicationReloadNotificationComponent_Template_button_click_2_listener() {
              return ctx.reload();
            });
            i0.ɵɵtext(3, "Reload");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.data && ctx.data.message ? ctx.data.message : "Unknown issue has occurred");
          }
        },
        dependencies: [CommonModule, MatSnackBarModule, MatButtonModule, i1.MatButton],
        styles: ["[_nghost-%COMP%]{display:flex;align-items:center;gap:var(--cui-small-space)}"]
      });
    }
  }
  return ApplicationReloadNotificationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SubscribingBase = /*#__PURE__*/(() => {
  class SubscribingBase {
    constructor() {
      this.destroyed$ = new Subject();
      this.subs = [];
    }
    ngOnDestroy() {
      this.unsubscribe();
    }
    subscribe(observable, onSuccess, onFail, onCompleted) {
      this.subs.push(observable.subscribe(onSuccess, onFail, onCompleted));
    }
    unsubscribe() {
      this.destroyed$.next();
      this.destroyed$.complete();
      this.subs.forEach(s => s.unsubscribe());
    }
    static {
      this.ɵfac = function SubscribingBase_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SubscribingBase)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SubscribingBase
      });
    }
  }
  return SubscribingBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiGuardLoadingIndicatorComponent = /*#__PURE__*/(() => {
  class CuiGuardLoadingIndicatorComponent extends SubscribingBase {
    constructor(router) {
      super();
      this.router = router;
      this.width = '20rem';
      this.loading = signal(false);
      this.router.events.pipe(takeUntil(this.destroyed$)).subscribe(event => {
        if (this.router.url === this.urlToCheck) {
          if (event instanceof GuardsCheckStart) {
            this.loading.set(true);
          }
          if (event instanceof GuardsCheckEnd || event instanceof NavigationCancel) {
            this.loading.set(false);
          }
        }
      });
    }
    static {
      this.ɵfac = function CuiGuardLoadingIndicatorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiGuardLoadingIndicatorComponent)(i0.ɵɵdirectiveInject(i1$1.Router));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiGuardLoadingIndicatorComponent,
        selectors: [["cui-guard-loading-indicator"]],
        inputs: {
          urlToCheck: "urlToCheck",
          width: "width"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [[1, "spinner-container", 3, "ngStyle"], ["mode", "indeterminate", 1, "absolute-centered", 3, "diameter"]],
        template: function CuiGuardLoadingIndicatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CuiGuardLoadingIndicatorComponent_Conditional_0_Template, 2, 4, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.loading() ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i2.NgStyle, MatProgressSpinnerModule, i3$1.MatProgressSpinner],
        styles: ["@use \"../../../styles/configs/formatting.scss\" as formatting;.spinner-container[_ngcontent-%COMP%]{@include formatting.maxVerticalHeight();position:relative;min-height:31.25rem}.spinner-container[_ngcontent-%COMP%]   .absolute-centered[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}"],
        changeDetection: 0
      });
    }
  }
  return CuiGuardLoadingIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Configurations {
  constructor() {
    this.apiUrl = 'api';
  }
}
const rootStyles = getComputedStyle(document.documentElement);
const getCssVariableValue = variableName => {
  return rootStyles.getPropertyValue(variableName).trim();
};

/**
 * Example output: "2019-10-24T00:00:000Z"
 */
const formatToISODate = date => new Date(formatDate(date)).toISOString();
const formatDate = (date, formatType = 'yyyy-MM-dd') => format(date, formatType);
const createDateWithZeroTime = date => {
  return new Date(`${date} 00:00:00`);
};
const formatToISODateEndOfDay = date => new Date(date.setHours(23, 59, 59, 999)).toISOString();
function isNotNullOrUndefined(input) {
  return input !== null && input !== undefined;
}
function generateRandomAlphaString(length) {
  const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let randomString = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * alphabet.length);
    randomString += alphabet.charAt(randomIndex);
  }
  return randomString;
}
const isGUID = val => {
  const guidRegxp = /^[0-9a-fA-F]{8}(?:-[0-9a-fA-F]{4}){3}-[0-9a-fA-F]{12}$/;
  return guidRegxp.test(val);
};
let IsoDatePipe = /*#__PURE__*/(() => {
  class IsoDatePipe {
    transform(value) {
      return formatToISODate(value).slice(0, 10);
    }
    static {
      this.ɵfac = function IsoDatePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IsoDatePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "isoDate",
        type: IsoDatePipe,
        pure: true
      });
    }
  }
  return IsoDatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormatBytesPipe = /*#__PURE__*/(() => {
  class FormatBytesPipe {
    transform(bytes) {
      if (bytes === 0) {
        return '0 Bytes';
      }
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
    static {
      this.ɵfac = function FormatBytesPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormatBytesPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "formatBytes",
        type: FormatBytesPipe,
        pure: true
      });
    }
  }
  return FormatBytesPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ParseHtmlPipe = /*#__PURE__*/(() => {
  class ParseHtmlPipe {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
      DOMPurify.setConfig({
        ADD_TAGS: ['iframe', 'video', 'audio', 'source'],
        ADD_ATTR: ['target', 'loading', 'style', 'frameborder', 'allowfullscreen'],
        ALLOW_DATA_ATTR: true,
        USE_PROFILES: {
          html: true,
          svg: true,
          svgFilters: true
        },
        FORBID_TAGS: ['script', 'object'],
        FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover']
      });
      DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
        if (data.attrName === 'style') {
          data.forceKeepAttr = true;
        }
      });
    }
    transform(value) {
      if (!value) return '';
      const sanitizedHtml = DOMPurify.sanitize(value);
      return this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
    }
    static {
      this.ɵfac = function ParseHtmlPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ParseHtmlPipe)(i0.ɵɵdirectiveInject(i1$2.DomSanitizer, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "parseHtml",
        type: ParseHtmlPipe,
        pure: true
      });
    }
  }
  return ParseHtmlPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DialogService = /*#__PURE__*/(() => {
  class DialogService {
    constructor(dialog) {
      this.dialog = dialog;
    }
    openDialog(component, data, config) {
      return this.dialog.open(component, {
        minWidth: '25%',
        maxWidth: '90%',
        maxHeight: '95vh',
        data,
        restoreFocus: false,
        autoFocus: 'dialog',
        ...config
      });
    }
    static {
      this.ɵfac = function DialogService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DialogService)(i0.ɵɵinject(i1$3.Dialog));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DialogService,
        factory: DialogService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DialogService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotificationsService = /*#__PURE__*/(() => {
  class NotificationsService {
    constructor(snackBar) {
      this.snackBar = snackBar;
    }
    showNotification(message, dismissText = 'Dismiss', config) {
      const defaultConfig = {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      };
      const finalConfig = {
        ...defaultConfig,
        ...config
      };
      this.snackBar.open(message, dismissText, finalConfig);
    }
    showNotificationFromComponent(component, config) {
      this.snackBar.openFromComponent(component, config);
    }
    showNotificationFromTemplate(template, config) {
      this.snackBar.openFromTemplate(template, config);
    }
    static {
      this.ɵfac = function NotificationsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotificationsService)(i0.ɵɵinject(i1$4.MatSnackBar));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NotificationsService,
        factory: NotificationsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NotificationsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UserValidationService = /*#__PURE__*/(() => {
  class UserValidationService {
    constructor(http) {
      this.http = http;
      this.validationInProgress$ = new BehaviorSubject(false);
      this.emailExistsInProgress$ = new BehaviorSubject(false);
    }
    validateEmail(validationUrl, email) {
      this.validationInProgress$.next(true);
      return this.http.post(validationUrl, {
        email
      }).pipe(tap(() => {
        this.validationInProgress$.next(false);
      }), catchError(e => {
        this.validationInProgress$.next(false);
        throw e;
      }));
    }
    /**
     *
     * @param validationUrl Url to call to check if email is and existing user in our app
     * @param email - string of email
     * @returns Possibly will return the User Object.
     */
    emailExists(validationUrl, email) {
      this.emailExistsInProgress$.next(true);
      return this.http.get(validationUrl, {
        params: {
          email
        }
      }).pipe(tap(() => {
        this.emailExistsInProgress$.next(false);
      }), catchError(e => {
        this.emailExistsInProgress$.next(false);
        throw e;
      }));
    }
    static {
      this.ɵfac = function UserValidationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserValidationService)(i0.ɵɵinject(i1$5.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UserValidationService,
        factory: UserValidationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return UserValidationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiDashboardBaseComponent = /*#__PURE__*/(() => {
  class CuiDashboardBaseComponent {
    static {
      this.ɵfac = function CuiDashboardBaseComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiDashboardBaseComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiDashboardBaseComponent,
        selectors: [["cui-dashboard-base"]],
        ngContentSelectors: _c3,
        decls: 1,
        vars: 0,
        template: function CuiDashboardBaseComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        styles: ["[_nghost-%COMP%]{display:grid;grid-gap:var(--cui-large-space);grid-template-columns:repeat(auto-fit,minmax(10rem,1fr));grid-auto-rows:10rem;grid-auto-flow:dense}@media only screen and (max-width: 600px){[_nghost-%COMP%]{grid-gap:var(--cui-medium-space);grid-template-columns:repeat(2,1fr)}}"],
        changeDetection: 0
      });
    }
  }
  return CuiDashboardBaseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTileBaseBobyComponent = /*#__PURE__*/(() => {
  class CuiTileBaseBobyComponent {
    static {
      this.ɵfac = function CuiTileBaseBobyComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTileBaseBobyComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTileBaseBobyComponent,
        selectors: [["cui-tile-base-body"]],
        ngContentSelectors: _c3,
        decls: 1,
        vars: 0,
        template: function CuiTileBaseBobyComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        dependencies: [CommonModule, RouterModule],
        styles: ["[_nghost-%COMP%]{display:flex;justify-content:space-between;gap:var(--cui-medium-space);height:100%}@media only screen and (max-width: 600px){[_nghost-%COMP%]{gap:var(--cui-small-space)}}"],
        changeDetection: 0
      });
    }
  }
  return CuiTileBaseBobyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTileBaseFooterComponent = /*#__PURE__*/(() => {
  class CuiTileBaseFooterComponent {
    constructor() {
      this.footerLink = input(null);
      this.footerQueryParams = input(undefined);
      this.isClickable = input(undefined);
      this.isClickableComputed = computed(() => {
        if (this.isClickable() !== undefined) return this.isClickable();
        return this.footerLink() !== undefined;
      });
    }
    static {
      this.ɵfac = function CuiTileBaseFooterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTileBaseFooterComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTileBaseFooterComponent,
        selectors: [["cui-tile-base-footer"]],
        inputs: {
          footerLink: [1, "footerLink"],
          footerQueryParams: [1, "footerQueryParams"],
          isClickable: [1, "isClickable"]
        },
        ngContentSelectors: _c3,
        decls: 2,
        vars: 5,
        consts: [["routerLinkActive", "active", 1, "tile-footer-container", 3, "routerLink", "queryParams", "ngClass"]],
        template: function CuiTileBaseFooterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("routerLink", ctx.footerLink())("queryParams", ctx.footerQueryParams())("ngClass", i0.ɵɵpureFunction1(3, _c8, ctx.isClickableComputed()));
          }
        },
        dependencies: [CommonModule, i2.NgClass, RouterModule, i1$1.RouterLink, i1$1.RouterLinkActive],
        styles: [".tile-footer-container[_ngcontent-%COMP%]{display:flex;justify-content:space-between;border-bottom:1px solid var(--color-gray-light);transition:box-shadow .3s ease-out}.tile-footer-container.clickable[_ngcontent-%COMP%]:hover{box-shadow:var(--cui-shadow);cursor:pointer}"],
        changeDetection: 0
      });
    }
  }
  return CuiTileBaseFooterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiDashboardTileComponent = /*#__PURE__*/(() => {
  class CuiDashboardTileComponent {
    constructor() {
      this.title = input.required();
      this.titleLink = input(undefined);
      this.titleQueryParams = input(undefined);
      this.tileLink = input(undefined);
      this.tileQueryParams = input(undefined);
      this.isClickable = input(undefined);
      this.isClickableComputed = computed(() => {
        if (this.isClickable() !== undefined) return this.isClickable();
        return this.tileLink() !== undefined;
      });
      this.isLoading = input(false);
      this.tileColor = input('#ffffff'); //white by default
    }
    static {
      this.ɵfac = function CuiDashboardTileComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiDashboardTileComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiDashboardTileComponent,
        selectors: [["cui-tile-base"]],
        inputs: {
          title: [1, "title"],
          titleLink: [1, "titleLink"],
          titleQueryParams: [1, "titleQueryParams"],
          tileLink: [1, "tileLink"],
          tileQueryParams: [1, "tileQueryParams"],
          isClickable: [1, "isClickable"],
          isLoading: [1, "isLoading"],
          tileColor: [1, "tileColor"]
        },
        ngContentSelectors: _c10,
        decls: 7,
        vars: 12,
        consts: [["routerLinkActive", "active", 1, "tile-container", 3, "ngStyle", "ngClass", "routerLink", "queryParams"], [1, "tile-header"], [1, "tile-title"], ["routerLinkActive", "active", 3, "routerLink", "queryParams"], ["mode", "indeterminate", 1, "absolute-centered", 3, "diameter"]],
        template: function CuiDashboardTileComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c9);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h4", 2)(3, "a", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(5, CuiDashboardTileComponent_Conditional_5_Template, 2, 0)(6, CuiDashboardTileComponent_Conditional_6_Template, 1, 1, "mat-spinner", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(8, _c11, ctx.tileColor()))("ngClass", i0.ɵɵpureFunction1(10, _c8, ctx.isClickableComputed()))("routerLink", ctx.tileLink())("queryParams", ctx.tileQueryParams());
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("routerLink", ctx.titleLink())("queryParams", ctx.titleQueryParams());
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.title(), " ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.isLoading() ? 5 : 6);
          }
        },
        dependencies: [RouterModule, i1$1.RouterLink, i1$1.RouterLinkActive, CommonModule, i2.NgClass, i2.NgStyle, MatProgressSpinnerModule, i3$1.MatProgressSpinner],
        styles: [".tile-container[_ngcontent-%COMP%]{border-radius:var(--cui-border-radius);box-shadow:var(--cui-shadow);padding:var(--cui-small-space) var(--cui-medium-space);position:relative;min-width:10rem;height:100%;display:flex;flex-direction:column;gap:var(--cui-extra-small-space);transition:all .3s ease-out}.tile-container.clickable[_ngcontent-%COMP%]:hover{transform:scale(1.03);cursor:pointer}@media only screen and (max-width: 600px){.tile-container[_ngcontent-%COMP%]{gap:var(--cui-extra-small-space)}}.tile-title[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--color-gray-very-dark)}@media only screen and (max-width: 600px){.tile-title[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{font-size:var(--cui-font-h3-size)}}.absolute-centered[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}"],
        changeDetection: 0
      });
    }
  }
  return CuiDashboardTileComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTileNumberComponent = /*#__PURE__*/(() => {
  class CuiTileNumberComponent {
    constructor() {
      this.number = input.required();
      this.fontSize = input('3.25rem');
      this.bgColor = input('none'); //transparent by default
      this.textColor = input('#000000'); //black by default
      this.tileLink = input();
      this.tileQueryParams = input(undefined);
      this.isClickable = input(undefined);
      this.isClickableComputed = computed(() => {
        if (this.isClickable() !== undefined) return this.isClickable();
        return this.tileLink() !== undefined;
      });
      this.title = input();
    }
    static {
      this.ɵfac = function CuiTileNumberComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTileNumberComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTileNumberComponent,
        selectors: [["cui-tile-number"]],
        inputs: {
          number: [1, "number"],
          fontSize: [1, "fontSize"],
          bgColor: [1, "bgColor"],
          textColor: [1, "textColor"],
          tileLink: [1, "tileLink"],
          tileQueryParams: [1, "tileQueryParams"],
          isClickable: [1, "isClickable"],
          title: [1, "title"]
        },
        decls: 5,
        vars: 17,
        consts: [["routerLinkActive", "active", 1, "number-tile-container", 3, "routerLink", "queryParams", "ngStyle", "ngClass"], [1, "tile-title", 3, "ngStyle"], [1, "absolute-centered", 3, "ngStyle"]],
        template: function CuiTileNumberComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h5", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "span", 2);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("routerLink", ctx.tileLink())("queryParams", ctx.tileQueryParams())("ngStyle", i0.ɵɵpureFunction1(9, _c11, ctx.bgColor()))("ngClass", i0.ɵɵpureFunction1(11, _c8, ctx.isClickableComputed()));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(13, _c12, ctx.textColor()));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate2("", ctx.title(), " ", ctx.tileLink() ? "\u2192" : "", "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(15, _c13, ctx.fontSize()));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.number(), "");
          }
        },
        dependencies: [CommonModule, i2.NgClass, i2.NgStyle, RouterModule, i1$1.RouterLink, i1$1.RouterLinkActive],
        styles: ["[_nghost-%COMP%]{flex:1}.number-tile-container[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:column;height:100%;border-radius:var(--cui-border-radius);padding:var(--cui-small-space);align-items:center;justify-content:center;transition:all .3s ease-out}@media only screen and (max-width: 600px){.number-tile-container[_ngcontent-%COMP%]{padding:var(--cui-extra-small-space)}}.number-tile-container.clickable[_ngcontent-%COMP%]:hover{cursor:pointer;transform:scale(1.03)}span[_ngcontent-%COMP%]{line-height:normal}.tile-title[_ngcontent-%COMP%]{text-align:center}"],
        changeDetection: 0
      });
    }
  }
  return CuiTileNumberComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiDashboardModule = /*#__PURE__*/(() => {
  class CuiDashboardModule {
    static {
      this.ɵfac = function CuiDashboardModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiDashboardModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CuiDashboardModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CuiDashboardTileComponent, CuiTileNumberComponent, CuiTileBaseBobyComponent, CuiTileBaseFooterComponent]
      });
    }
  }
  return CuiDashboardModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BlobStorageService = /*#__PURE__*/(() => {
  class BlobStorageService {
    constructor(notificationsService) {
      this.notificationsService = notificationsService;
      this.fileUploadProgress = new BehaviorSubject(null);
      this.fileProgress = this.fileUploadProgress.asObservable();
    }
    // Function for attachments upload to Azure Blob Storage.
    multiFilesUpload(attachmentsURL, files) {
      return of(files.map((file, idx) => {
        this.uploadFile(attachmentsURL[idx].URL, file).subscribe();
        return {
          uploadId: attachmentsURL[idx].uploadId,
          fileName: file.name
        };
      }));
    }
    uploadFile(url, file) {
      this.fileUploadProgress.next({
        fileName: file.name,
        progress: 0
      });
      const contentType = mime.getType(file.name) || 'application/octet-stream';
      const client = new BlockBlobClient(url);
      const config = {
        maxSingleShotSize: 31_457_280,
        // 30MB
        concurrency: 3,
        blobHTTPHeaders: {
          blobContentType: contentType,
          blobCacheControl: isImage(contentType) ? 'max-age=604800' : undefined
        },
        onProgress: progress => {
          const progressInPercentage = this.calculateProgress(file.size, progress.loadedBytes);
          const result = {
            fileName: file.name,
            progress: progressInPercentage - 1
          };
          this.fileUploadProgress.next(result);
        }
      };
      return from(client.uploadData(file, config)).pipe(tap(({
        _response
      }) => {
        // Need to wait for the response to be 201 in order to be sure that file has finished uploading.
        if (_response.status === 201) {
          const result = {
            fileName: file.name,
            progress: 100
          };
          this.fileUploadProgress.next(result);
        }
      }), catchError(err => {
        const error = new HttpErrorResponse({
          error: {
            errorCode: '400',
            errorMessage: 'Failed to upload file to File Storage'
          },
          status: 400
        });
        this.notificationsService.showNotification(`Status: ${error.status}. Message: ${error.error.errorMessage ?? error.error.message}`);
        this.fileUploadProgress.next({
          fileName: file.name,
          progress: 0,
          errorMessages: ['Failed to upload file to File Storage']
        });
        throw error;
      }));
    }
    calculateProgress(fileSize, loadedBytes) {
      return Math.ceil(loadedBytes / fileSize * 100);
    }
    static {
      this.ɵfac = function BlobStorageService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BlobStorageService)(i0.ɵɵinject(NotificationsService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BlobStorageService,
        factory: BlobStorageService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BlobStorageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const isImage = mimeType => {
  const imageMimeTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/tiff', 'image/svg+xml'];
  return imageMimeTypes.includes(mimeType);
};
let FileDragNDropDirective$1 = /*#__PURE__*/(() => {
  let FileDragNDropDirective$1 = class FileDragNDropDirective {
    constructor() {
      this.fileDropped = new EventEmitter();
      this.background = '#f1f1f2';
      this.border = 'solid 1px #0000002b';
      this.borderRadius = '10px';
    }
    onDragOver(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.background = '#f1f1f2';
      this.border = 'solid 1px #bcbec0';
    }
    onDragLeave(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.background = '#f1f1f2';
      this.border = 'solid 1px #0000002b';
    }
    onDrop(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.background = '#f1f1f2';
      this.border = 'solid 1px #0000002b';
      let files = evt.dataTransfer.files;
      let valid_files = files;
      this.fileDropped.emit(valid_files);
    }
    static {
      this.ɵfac = function FileDragNDropDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FileDragNDropDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: FileDragNDropDirective,
        selectors: [["", "fileDragAndDrop", ""]],
        hostVars: 6,
        hostBindings: function FileDragNDropDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("dragover", function FileDragNDropDirective_dragover_HostBindingHandler($event) {
              return ctx.onDragOver($event);
            })("dragleave", function FileDragNDropDirective_dragleave_HostBindingHandler($event) {
              return ctx.onDragLeave($event);
            })("drop", function FileDragNDropDirective_drop_HostBindingHandler($event) {
              return ctx.onDrop($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("background", ctx.background)("border", ctx.border)("border-radius", ctx.borderRadius);
          }
        },
        outputs: {
          fileDropped: "fileDropped"
        }
      });
    }
  };
  return FileDragNDropDirective$1;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiFilesUploaderComponentDeprecated = /*#__PURE__*/(() => {
  class CuiFilesUploaderComponentDeprecated extends SubscribingBase {
    set attachmentsToUpload(attachmentsURL) {
      if (attachmentsURL && attachmentsURL.length) {
        this.isUploadingMultipleFiles = true;
        this.selectedFiles = this.selectedFiles.filter(file => !file.errMessages.length);
        this.subscribe(this.blobStorageService.multiFilesUpload(attachmentsURL, this.selectedFiles.map(f => f.file)), res => this.uploadedAttachments = res);
      }
    }
    constructor(formatBytesPipe, blobStorageService, cdr) {
      super();
      this.formatBytesPipe = formatBytesPipe;
      this.blobStorageService = blobStorageService;
      this.cdr = cdr;
      this.disabled = false;
      this.isRequired = false;
      this.allowedExtensions = [];
      this.notAllowedExtensions = [];
      this.allowedFilesCount = 1;
      this.maxFileSize = 268_435_456; // 256MB
      this.validFileListModified = new EventEmitter();
      this.uploadedFilesList = new EventEmitter();
      this.isValid = new EventEmitter();
      this.globalFileUploadErrorMessage = '';
      this.selectedFiles = [];
      this.uploadedAttachments = [];
      this.isUploadingMultipleFiles = false;
    }
    ngOnInit() {
      this.subscribe(this.blobStorageService.fileProgress, res => {
        if (res) {
          const fileToUpdateIndex = this.selectedFiles.findIndex(file => file.file.name === res?.fileName);
          if (fileToUpdateIndex !== -1) {
            this.selectedFiles.splice(fileToUpdateIndex, 1, {
              uploadStarted: true,
              progress: res.progress,
              file: this.selectedFiles[fileToUpdateIndex].file,
              errMessages: res.errorMessages ?? []
            });
            if (this.isUploadingMultipleFiles) {
              if (res.progress === 100 && this.selectedFiles.every(file => file.progress === 100)) {
                this.returnUploadedFiles();
              }
            }
            this.cdr.detectChanges(); // TODO: remove cdr, find way to rerender component without it. For now it is good enough as it is.
          }
        }
      });
      this.updateValidity();
    }
    onFileDropped(e) {
      this.addFiles(e);
      this.updateValidity();
    }
    onFileBrowseHandler(e) {
      this.addFiles(e.target.files);
      e.target.value = '';
      this.updateValidity();
    }
    deleteFile(index) {
      this.selectedFiles.splice(index, 1);
      this.updateValidity();
    }
    returnUploadedFiles() {
      this.uploadedFilesList.emit(this.uploadedAttachments);
      this.selectedFiles = [];
    }
    addFiles(files) {
      this.globalFileUploadErrorMessage = '';
      const fileListAsArray = Array.from(files);
      if (fileListAsArray.length + this.selectedFiles.length > this.allowedFilesCount) {
        this.globalFileUploadErrorMessage = `Please upload no more than ${this.allowedFilesCount} file${this.allowedFilesCount > 1 ? 's' : ''}.`;
        this.clearGlobalErrMessage();
        return;
      }
      fileListAsArray.forEach(file => {
        this.selectedFiles.push({
          uploadStarted: false,
          progress: 0,
          errMessages: [],
          file
        });
      });
    }
    isCorrectExtension(name) {
      const extension = `.${name[name.length - 1]}`.toLocaleLowerCase();
      // Check if the file extension is in the allowed or not allowed extensions list.
      return this.notAllowedExtensions.length ? !this.notAllowedExtensions.includes(extension) : this.allowedExtensions.length ? this.allowedExtensions.includes(extension) : true;
    }
    emitValidFileList() {
      const validFiles = this.selectedFiles.filter(files => !files.errMessages.length);
      this.validFileListModified.emit(validFiles.map(uFile => uFile.file));
    }
    clearGlobalErrMessage() {
      setTimeout(() => {
        this.globalFileUploadErrorMessage = '';
        this.cdr.detectChanges();
      }, 5000);
    }
    updateValidity() {
      this.selectedFiles.forEach((sFile, sFileIndex) => {
        const fileNameSplitted = sFile.file.name.split('.');
        const errMessages = [];
        if (!this.isCorrectExtension(fileNameSplitted)) {
          errMessages.push(`File extension doesn't fit allowed extension list.`);
        }
        if (sFile.file.size > this.maxFileSize) {
          errMessages.push(`File size is over <strong>${this.formatBytesPipe.transform(this.maxFileSize)}</strong>.`);
        }
        if (sFile.file.size <= 0) {
          errMessages.push(`File size must be more than <strong>0</strong> bytes.`);
        }
        if (this.selectedFiles.some((f, fIndex) => f.file.name === sFile.file.name && fIndex !== sFileIndex)) {
          errMessages.push(`Duplicate file name: <strong>${sFile.file.name}</strong>.`);
        }
        sFile.errMessages = errMessages;
      });
      this.emitValidFileList();
      // File list is not valid when:
      if (this.selectedFiles.some(file => file.errMessages.length) ||
      // At least one file has error, or
      this.isRequired && !this.selectedFiles.length // when fileList is required and there are no selected files.
      ) {
        this.isValid.emit(false);
        return;
      }
      this.isValid.emit(true);
    }
    static {
      this.ɵfac = function CuiFilesUploaderComponentDeprecated_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiFilesUploaderComponentDeprecated)(i0.ɵɵdirectiveInject(FormatBytesPipe), i0.ɵɵdirectiveInject(BlobStorageService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiFilesUploaderComponentDeprecated,
        selectors: [["cui-files-uploader-deprecated"]],
        inputs: {
          disabled: "disabled",
          isRequired: "isRequired",
          allowedExtensions: "allowedExtensions",
          notAllowedExtensions: "notAllowedExtensions",
          allowedFilesCount: "allowedFilesCount",
          maxFileSize: "maxFileSize",
          attachmentsToUpload: "attachmentsToUpload"
        },
        outputs: {
          validFileListModified: "validFileListModified",
          uploadedFilesList: "uploadedFilesList",
          isValid: "isValid"
        },
        features: [i0.ɵɵProvidersFeature([FormatBytesPipe]), i0.ɵɵInheritDefinitionFeature],
        decls: 23,
        vars: 17,
        consts: [["fileDropRef", ""], ["notAllowedExtensionsTemp", ""], ["allowedExtensionsTemp", ""], ["fileDragAndDrop", "", 1, "dropzone", "container", 3, "fileDropped"], ["id", "container-btn", 1, "upload-button"], ["type", "file", "id", "fileDropRef", 3, "change", "disabled", "accept", "multiple"], [3, "clicked", "disabled"], ["for", "fileDropRef"], [3, "ngClass"], [1, "upload-instruction"], [1, "files-instruction"], [1, "expectations"], [4, "ngIf", "ngIfThen", "ngIfElse"], [4, "ngIf"], ["class", "files-list", 4, "ngIf"], [1, "extensions"], [3, "matTooltip", "name"], [1, "files-list"], ["class", "single-file", 4, "ngFor", "ngForOf"], [1, "single-file"], [1, "left-side"], [1, "folder", 3, "name"], [1, "info"], ["class", "error", 3, "innerHtml", 4, "ngIf"], ["class", "progress", 4, "ngIf"], [1, "right-side"], ["aria-label", "Copy", 3, "clicked", "matTooltip", "disabled", "name"], [1, "error", 3, "innerHtml"], [1, "progress"], ["mode", "determinate", 3, "value"]],
        template: function CuiFilesUploaderComponentDeprecated_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 3);
            i0.ɵɵlistener("fileDropped", function CuiFilesUploaderComponentDeprecated_Template_div_fileDropped_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.disabled === false && ctx.onFileDropped($event));
            });
            i0.ɵɵelementStart(1, "div", 4)(2, "input", 5, 0);
            i0.ɵɵlistener("change", function CuiFilesUploaderComponentDeprecated_Template_input_change_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFileBrowseHandler($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "cui-button", 6);
            i0.ɵɵlistener("clicked", function CuiFilesUploaderComponentDeprecated_Template_cui_button_clicked_4_listener() {
              i0.ɵɵrestoreView(_r1);
              const fileDropRef_r2 = i0.ɵɵreference(3);
              return i0.ɵɵresetView(fileDropRef_r2.click());
            });
            i0.ɵɵtext(5, "Select your file");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "label", 7)(7, "h2");
            i0.ɵɵtext(8, "or");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "h2", 8);
            i0.ɵɵtext(10, "drop it here!");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(11, "div", 9)(12, "div", 10)(13, "div", 11);
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "formatBytes");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(16, CuiFilesUploaderComponentDeprecated_ng_container_16_Template, 1, 0, "ng-container", 12)(17, CuiFilesUploaderComponentDeprecated_ng_template_17_Template, 3, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(19, CuiFilesUploaderComponentDeprecated_ng_template_19_Template, 3, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(21, CuiFilesUploaderComponentDeprecated_mat_error_21_Template, 2, 2, "mat-error", 13);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(22, CuiFilesUploaderComponentDeprecated_div_22_Template, 2, 1, "div", 14);
          }
          if (rf & 2) {
            const notAllowedExtensionsTemp_r7 = i0.ɵɵreference(18);
            const allowedExtensionsTemp_r8 = i0.ɵɵreference(20);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.disabled)("accept", ctx.allowedExtensions.join(", "))("multiple", ctx.allowedFilesCount > 1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c14, ctx.isRequired));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate3(" Expectations: Up to ", ctx.allowedFilesCount, " file", ctx.allowedFilesCount > 1 ? "s" : "", "; Max size ", i0.ɵɵpipeBind1(15, 13, ctx.maxFileSize), " per file. ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.notAllowedExtensions.length)("ngIfThen", notAllowedExtensionsTemp_r7)("ngIfElse", allowedExtensionsTemp_r8);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.globalFileUploadErrorMessage);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.selectedFiles && ctx.selectedFiles.length);
          }
        },
        dependencies: [CommonModule, i2.NgClass, i2.NgForOf, i2.NgIf, CuiButtonsModule, CuiButtonComponent, CuiIconComponent, FormsModule, CuiIconButtonComponent, MatFormFieldModule, i4.MatError, ReactiveFormsModule, FileDragNDropDirective$1, FormatBytesPipe, MatButtonModule, MatProgressBarModule, i6.MatProgressBar, MatTooltipModule, i3.MatTooltip],
        styles: [".dropzone.container[_ngcontent-%COMP%]{container-type:inline-size}@container (max-width: 400px){.dropzone.container[_ngcontent-%COMP%]   .upload-button#container-btn[_ngcontent-%COMP%]{margin-bottom:var(--cui-small-space);display:block}.dropzone.container[_ngcontent-%COMP%]   .upload-button#container-btn[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{flex-direction:column}.dropzone.container[_ngcontent-%COMP%]   .upload-button#container-btn[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{padding:0;text-align:center}.dropzone.container[_ngcontent-%COMP%]   .upload-button#container-btn[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   h2.required[_ngcontent-%COMP%]:after{right:21px}.dropzone.container[_ngcontent-%COMP%]   .expectations[_ngcontent-%COMP%]{margin-bottom:var(--cui-medium-space)}}.dropzone[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between;padding:var(--cui-large-space)}.dropzone[_ngcontent-%COMP%]   .upload-button[_ngcontent-%COMP%]{display:flex;align-items:center;position:relative;margin:0 auto var(--cui-medium-space) auto}.dropzone[_ngcontent-%COMP%]   .upload-button[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:flex}.dropzone[_ngcontent-%COMP%]   .upload-button[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]:first-child{padding-left:var(--cui-medium-space);margin-right:5px}.dropzone[_ngcontent-%COMP%]   .upload-button[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   h2.required[_ngcontent-%COMP%]{position:relative}.dropzone[_ngcontent-%COMP%]   .upload-button[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   h2.required[_ngcontent-%COMP%]:after{content:\"*\";color:var(--color-danger);font-size:13px;position:absolute;right:-10px;top:-5px}.dropzone[_ngcontent-%COMP%]   .upload-instruction[_ngcontent-%COMP%]   .extensions[_ngcontent-%COMP%]{display:flex;align-items:center;padding-top:var(--cui-small-space)}.dropzone[_ngcontent-%COMP%]   .upload-instruction[_ngcontent-%COMP%]   .extensions[_ngcontent-%COMP%]   cui-icon[_ngcontent-%COMP%]{padding-left:5px}.dropzone[_ngcontent-%COMP%]   .upload-instruction[_ngcontent-%COMP%]   mat-error[_ngcontent-%COMP%]{padding-top:var(--cui-medium-space)}input[type=file][_ngcontent-%COMP%]{display:none}.files-list[_ngcontent-%COMP%]{margin-top:var(--cui-medium-space)}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;border-bottom:solid 1px var(--cui-color-border);margin-bottom:var(--cui-medium-space)}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]   cui-icon.folder[_ngcontent-%COMP%]{margin:var(--cui-small-space)}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]   .left-side[_ngcontent-%COMP%]{display:flex;align-items:center;flex:1}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]   .left-side[_ngcontent-%COMP%]   mat-progress-bar[_ngcontent-%COMP%]{border-radius:15px;height:10px}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{width:100%;overflow:hidden;overflow-wrap:anywhere;display:flex;flex-direction:column}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   small.error[_ngcontent-%COMP%]{color:var(--color-danger)}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]{width:100%;padding:0 var(--cui-medium-space)}"],
        data: {
          animation: [trigger('animateOut', [transition(':leave', [style({
            opacity: 1
          }), animate('1s ease-in', style({
            opacity: 0
          }))])])]
        },
        changeDetection: 0
      });
    }
  }
  return CuiFilesUploaderComponentDeprecated;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileDragNDropDirective = /*#__PURE__*/(() => {
  class FileDragNDropDirective {
    constructor() {
      this.fileDropped = new EventEmitter();
      this.background = '#f1f1f2';
      this.border = 'solid 1px #0000002b';
      this.borderRadius = '10px';
    }
    onDragOver(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.background = '#f1f1f2';
      this.border = 'solid 1px #bcbec0';
    }
    onDragLeave(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.background = '#f1f1f2';
      this.border = 'solid 1px #0000002b';
    }
    onDrop(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.background = '#f1f1f2';
      this.border = 'solid 1px #0000002b';
      let files = evt.dataTransfer.files;
      let valid_files = files;
      this.fileDropped.emit(valid_files);
    }
    static {
      this.ɵfac = function FileDragNDropDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FileDragNDropDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: FileDragNDropDirective,
        selectors: [["", "fileDragAndDrop", ""]],
        hostVars: 6,
        hostBindings: function FileDragNDropDirective_HostBindings1(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("dragover", function FileDragNDropDirective_dragover_HostBindingHandler($event) {
              return ctx.onDragOver($event);
            })("dragleave", function FileDragNDropDirective_dragleave_HostBindingHandler($event) {
              return ctx.onDragLeave($event);
            })("drop", function FileDragNDropDirective_drop_HostBindingHandler($event) {
              return ctx.onDrop($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("background", ctx.background)("border", ctx.border)("border-radius", ctx.borderRadius);
          }
        },
        outputs: {
          fileDropped: "fileDropped"
        }
      });
    }
  }
  return FileDragNDropDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileStorageService = /*#__PURE__*/(() => {
  class FileStorageService {
    constructor(notificationsService, http, config) {
      this.notificationsService = notificationsService;
      this.http = http;
      this.config = config;
      this.fileUploadProgress = new BehaviorSubject(null);
      this.fileProgress = this.fileUploadProgress.asObservable();
      this.abortControllers = {};
    }
    /**
     *
     *
     * @param id - need for file activation. This id is the fileId we get when we create File in Core.FileManagement
     * @returns Observable<unknown>
     */
    activateFile(id) {
      return this.http.post(`${this.config.apiUrl}/file-management/files/${id}/activate`, null).pipe(tap(() => {
        this.fileUploadProgress.next(null);
      }));
    }
    /**
     *
     * @param fileMetadata - metadata needed in order to create file in Core.FileManagement
     * @param file - actual file which will be uploaded to Azure Blob Storage.
     * @returns Observable<string> - the fileId that was returned by POST method of file crete in Core.FileManagement
     */
    createFileWithUpload(fileMetadata, file) {
      return this.http.post(`${this.config.apiUrl}/file-management/files`, fileMetadata).pipe(mergeMap(result => this.uploadFileToBlobStorage(result.uploadURL, file, result.id).pipe(map(() => result.id))));
    }
    /**
     *
     * @param fileMetadata - metadata needed in order to create file in Core.FileManagement
     * @returns  Observable<CreateFileResponse> - uploadUrl and fileId
     */
    createFileWithoutUpload(fileMetadata) {
      return this.http.post(`${this.config.apiUrl}/file-management/files`, fileMetadata);
    }
    /**
     *
     * @param url - uploadUrl that is returned by POST method from Core.FileManagement
     * @param file - actual file to upload to blob storage
     * @param fileId - fileId to stream observable to file uploader components or other consumers
     * @returns Observable<void>
     */
    uploadFileToBlobStorage(url, file, fileId) {
      this.fileUploadProgress.next({
        fileName: file.name,
        progress: 0,
        fileId
      });
      const abortController = new AbortController();
      const client = new BlockBlobClient(url);
      const config = {
        maxSingleShotSize: 31_457_280,
        // 30MB
        concurrency: 3,
        onProgress: progress => {
          const progressInPercentage = this.calculateProgress(file.size, progress.loadedBytes);
          const result = {
            fileName: file.name,
            progress: progressInPercentage - 1,
            fileId
          };
          this.fileUploadProgress.next(result);
        },
        abortSignal: abortController.signal
      };
      this.abortControllers[fileId] = abortController;
      return from(client.uploadData(file, config)).pipe(tap(({
        _response
      }) => {
        // Need to wait for the response to be 201 in order to be sure that file has finished uploading.
        if (_response.status === 201) {
          const result = {
            fileName: file.name,
            progress: 100,
            fileId
          };
          delete this.abortControllers[fileId];
          this.fileUploadProgress.next(result);
        }
      }), map(() => undefined), catchError(err => {
        if (!err.name.includes('AbortError')) {
          const error = new HttpErrorResponse({
            error: {
              errorCode: '400',
              errorMessage: 'Failed to upload file to File Storage'
            },
            status: 400
          });
          this.notificationsService.showNotification(`Status: ${error.status}. Message: ${error.error.errorMessage ?? error.error.message}`);
          this.fileUploadProgress.next({
            fileName: file.name,
            progress: 0,
            errorMessages: ['Failed to upload file to File Storage'],
            fileId
          });
          throw error;
        } else {
          this.fileUploadProgress.next(null);
          this.notificationsService.showNotification(`File upload was aborted successfully`);
          return of();
        }
      }));
    }
    calculateProgress(fileSize, loadedBytes) {
      return Math.ceil(loadedBytes / fileSize * 100);
    }
    static {
      this.ɵfac = function FileStorageService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FileStorageService)(i0.ɵɵinject(NotificationsService), i0.ɵɵinject(i1$5.HttpClient), i0.ɵɵinject(Configurations));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FileStorageService,
        factory: FileStorageService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FileStorageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DEFAULT_CONFIG = {
  disabled: false,
  isRequired: false,
  uploadFilesImmediately: false,
  branchId: '',
  allowedExtensions: [],
  notAllowedExtensions: [],
  allowedFilesCount: 1,
  maxFileSize: 268_435_456,
  // 256MB
  minFileSize: 0 // Default to 0, meaning no minimum size requirement
};
let CuiFilesUploaderComponent = /*#__PURE__*/(() => {
  class CuiFilesUploaderComponent extends SubscribingBase {
    set config(providedConfig) {
      this._config = {
        ...DEFAULT_CONFIG,
        ...providedConfig
      };
    }
    get config() {
      return this._config;
    }
    constructor(formatBytesPipe, fileStorageService, cdr) {
      super();
      this.formatBytesPipe = formatBytesPipe;
      this.fileStorageService = fileStorageService;
      this.cdr = cdr;
      /**
       * Emits only the files that are added into fileUploader and are valid ( meets all requirements ).
       */
      this.validFileListModified = new EventEmitter();
      /**
       * Fires wether current state of Files uploader is valid or not.
       * This can be used for disabling Submit button in form in which this uploader is used.
       */
      this.isValid = new EventEmitter();
      this.globalFileUploadErrorMessage = '';
      this.selectedFiles = [];
      this.fileIds = [];
      this._config = DEFAULT_CONFIG;
    }
    ngOnInit() {
      this.subscribe(this.fileStorageService.fileProgress, res => {
        if (res) {
          const fileToUpdateIndex = this.selectedFiles.findIndex(file => file.fileId === res.fileId);
          if (fileToUpdateIndex !== -1) {
            this.selectedFiles.splice(fileToUpdateIndex, 1, {
              uploadStarted: true,
              progress: res.progress,
              file: this.selectedFiles[fileToUpdateIndex].file,
              errMessages: res.errorMessages ?? [],
              fileId: res.fileId
            });
            this.cdr.detectChanges(); // TODO: remove cdr, find way to rerender component without it. For now it is good enough as it is.
          }
        }
      });
      this.updateValidity();
    }
    /**
     * File needs to be first uploaded before activation.
     * So If this method is called before files are uploaded then it will not do anything
     *
     * @returns void
     */
    activateFiles() {
      if (this.fileIds.length) {
        this.fileIds.forEach(id => this.subscribe(this.fileStorageService.activateFile(id), () => undefined));
        this.fileIds = [];
      }
    }
    /**
     * This method is called when we want to create file metadata in Core.FileManagement DB and want to
     * upload actual file to Azure Blob Storage.
     *
     * For this method to work all added files needs to be valid.
     * @returns void
     */
    uploadFiles() {
      if (this.selectedFiles.some(file => file.errMessages.length)) {
        this.globalFileUploadErrorMessage = `You can not start upload when at least one of the files has error messages. Please remove invalid files.`;
        this.cdr.detectChanges();
        this.clearGlobalErrMessage();
        return;
      }
      if (this.selectedFiles.length) {
        this.selectedFiles.forEach(selectedFile => {
          if (!selectedFile.uploadStarted) {
            this.subscribe(this.fileStorageService.createFileWithUpload({
              fileName: selectedFile.file.name,
              branchId: this.config.branchId,
              path: this.config.path,
              partnerId: this.config.partnerId
            }, selectedFile.file), id => this.fileIds.push(id));
          }
        });
      }
    }
    onFileDropped(e) {
      this.addFiles(e);
      this.updateValidity();
    }
    onFileBrowseHandler(e) {
      this.addFiles(e.target.files);
      e.target.value = '';
      this.updateValidity();
    }
    deleteFile(index) {
      const fileToDelete = this.selectedFiles[index];
      if (fileToDelete.uploadStarted && fileToDelete.fileId && fileToDelete.progress !== 100) {
        this.fileStorageService.abortControllers[fileToDelete.fileId].abort();
        delete this.fileStorageService.abortControllers[fileToDelete.fileId];
      }
      this.selectedFiles.splice(index, 1);
      this.removeFileId(fileToDelete.fileId);
      this.updateValidity();
    }
    removeFileId(fileId) {
      const idx = this.fileIds.findIndex(id => id === fileId);
      if (idx !== -1) {
        this.fileIds.splice(idx, 1);
      }
    }
    addFiles(files) {
      this.globalFileUploadErrorMessage = '';
      const fileListAsArray = Array.from(files);
      if (fileListAsArray.length + this.selectedFiles.length > this._config.allowedFilesCount) {
        this.globalFileUploadErrorMessage = `Please upload no more than ${this._config.allowedFilesCount} file${this._config.allowedFilesCount > 1 ? 's' : ''}.`;
        this.clearGlobalErrMessage();
        return;
      }
      fileListAsArray.forEach(file => {
        this.selectedFiles.push({
          uploadStarted: false,
          progress: 0,
          errMessages: [],
          file
        });
      });
      if (this.config.uploadFilesImmediately) {
        this.uploadFiles();
      }
    }
    isCorrectExtension(name) {
      const extension = `.${name[name.length - 1]}`.toLocaleLowerCase();
      // Check if the file extension is in the allowed or not allowed extensions list.
      return this._config.notAllowedExtensions.length ? !this._config.notAllowedExtensions.includes(extension) : this._config.allowedExtensions.length ? this._config.allowedExtensions.includes(extension) : true;
    }
    emitValidFileList() {
      const validFiles = this.selectedFiles.filter(files => !files.errMessages.length);
      this.validFileListModified.emit(validFiles.map(uFile => uFile.file));
    }
    clearGlobalErrMessage() {
      setTimeout(() => {
        this.globalFileUploadErrorMessage = '';
        this.cdr.detectChanges();
      }, 5000);
    }
    updateValidity() {
      this.selectedFiles.forEach((sFile, sFileIndex) => {
        const fileNameSplitted = sFile.file.name.split('.');
        const errMessages = [];
        if (!this.isCorrectExtension(fileNameSplitted)) {
          errMessages.push(`File extension doesn't fit allowed extension list.`);
        }
        if (sFile.file.size > this._config.maxFileSize) {
          errMessages.push(`File size is over <strong>${this.formatBytesPipe.transform(this._config.maxFileSize)}</strong>.`);
        }
        if (this._config.minFileSize > 0 && sFile.file.size < this._config.minFileSize) {
          errMessages.push(`File size must be at least <strong>${this.formatBytesPipe.transform(this._config.minFileSize)}</strong>.`);
        }
        if (sFile.file.size <= 0) {
          errMessages.push(`File size must be more than <strong>0</strong> bytes.`);
        }
        if (this.selectedFiles.some((f, fIndex) => f.file.name === sFile.file.name && fIndex !== sFileIndex)) {
          errMessages.push(`Duplicate file name: <strong>${sFile.file.name}</strong>.`);
        }
        sFile.errMessages = errMessages;
      });
      this.emitValidFileList();
      // File list is not valid when:
      if (this.selectedFiles.some(file => file.errMessages.length) ||
      // At least one file has error, or
      this._config.isRequired && !this.selectedFiles.length // when fileList is required and there are no selected files.
      ) {
        this.isValid.emit(false);
        return;
      }
      this.isValid.emit(true);
    }
    static {
      this.ɵfac = function CuiFilesUploaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiFilesUploaderComponent)(i0.ɵɵdirectiveInject(FormatBytesPipe), i0.ɵɵdirectiveInject(FileStorageService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiFilesUploaderComponent,
        selectors: [["cui-files-uploader"]],
        inputs: {
          config: "config"
        },
        outputs: {
          validFileListModified: "validFileListModified",
          isValid: "isValid"
        },
        features: [i0.ɵɵProvidersFeature([FormatBytesPipe]), i0.ɵɵInheritDefinitionFeature],
        decls: 32,
        vars: 18,
        consts: [["fileDropRef", ""], ["notAllowedExtensionsTemp", ""], ["allowedExtensionsTemp", ""], ["class", "files-list", 4, "ngIf"], ["fileDragAndDrop", "", 1, "dropzone", "container", 3, "fileDropped"], ["id", "container-btn", 1, "upload-button"], ["type", "file", "id", "fileDropRef", 3, "change", "disabled", "accept", "multiple"], [3, "clicked", "disabled"], ["for", "fileDropRef"], [3, "ngClass"], [1, "upload-instruction"], [1, "files-instruction"], [1, "expectations"], [4, "ngIf"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["class", "mat-mdc-form-field-error", 4, "ngIf"], [1, "files-list"], ["class", "single-file", 4, "ngFor", "ngForOf"], [1, "single-file"], [1, "left-side"], [1, "folder", 3, "name"], [1, "info"], ["class", "error", 3, "innerHtml", 4, "ngIf"], ["class", "progress", 4, "ngIf"], [1, "right-side"], [3, "name", 4, "ngIf"], ["aria-label", "Copy", 3, "clicked", "matTooltip", "disabled", "name"], [1, "error", 3, "innerHtml"], [1, "progress"], ["mode", "determinate", 3, "value", "color"], [3, "name"], [1, "extensions"], [3, "matTooltip", "name"], [1, "mat-mdc-form-field-error"]],
        template: function CuiFilesUploaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, CuiFilesUploaderComponent_div_0_Template, 2, 1, "div", 3);
            i0.ɵɵelementStart(1, "div", 4);
            i0.ɵɵlistener("fileDropped", function CuiFilesUploaderComponent_Template_div_fileDropped_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.config.disabled === false && ctx.onFileDropped($event));
            });
            i0.ɵɵelementStart(2, "div", 5)(3, "input", 6, 0);
            i0.ɵɵlistener("change", function CuiFilesUploaderComponent_Template_input_change_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFileBrowseHandler($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "cui-button", 7);
            i0.ɵɵlistener("clicked", function CuiFilesUploaderComponent_Template_cui_button_clicked_5_listener() {
              i0.ɵɵrestoreView(_r1);
              const fileDropRef_r6 = i0.ɵɵreference(4);
              return i0.ɵɵresetView(fileDropRef_r6.click());
            });
            i0.ɵɵtext(6, "Select your file");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "label", 8)(8, "h3");
            i0.ɵɵtext(9, "or");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "h3", 9);
            i0.ɵɵtext(11, "drop it here!");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(12, "div", 10)(13, "mat-accordion")(14, "mat-expansion-panel")(15, "mat-expansion-panel-header")(16, "mat-panel-title");
            i0.ɵɵtext(17, " File upload requirements ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(18, "div", 11)(19, "div", 12)(20, "p");
            i0.ɵɵtext(21);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(22, CuiFilesUploaderComponent_p_22_Template, 3, 3, "p", 13);
            i0.ɵɵelementStart(23, "p");
            i0.ɵɵtext(24);
            i0.ɵɵpipe(25, "formatBytes");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(26, CuiFilesUploaderComponent_ng_container_26_Template, 1, 0, "ng-container", 14)(27, CuiFilesUploaderComponent_ng_template_27_Template, 3, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(29, CuiFilesUploaderComponent_ng_template_29_Template, 3, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(31, CuiFilesUploaderComponent_mat_error_31_Template, 2, 2, "mat-error", 15);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const notAllowedExtensionsTemp_r7 = i0.ɵɵreference(28);
            const allowedExtensionsTemp_r8 = i0.ɵɵreference(30);
            i0.ɵɵproperty("ngIf", ctx.selectedFiles && ctx.selectedFiles.length);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", ctx.config.disabled)("accept", ctx.config.allowedExtensions.join(", "))("multiple", ctx.config.allowedFilesCount > 1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.config.disabled);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c14, ctx.config.isRequired));
            i0.ɵɵadvance(11);
            i0.ɵɵtextInterpolate2("Up to ", ctx.config.allowedFilesCount, " file", ctx.config.allowedFilesCount > 1 ? "s" : "", ";");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.config.minFileSize > 0);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("Max size ", i0.ɵɵpipeBind1(25, 14, ctx.config.maxFileSize), " per file.");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.config.notAllowedExtensions.length)("ngIfThen", notAllowedExtensionsTemp_r7)("ngIfElse", allowedExtensionsTemp_r8);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.globalFileUploadErrorMessage);
          }
        },
        dependencies: [CommonModule, i2.NgClass, i2.NgForOf, i2.NgIf, CuiButtonsModule, CuiButtonComponent, CuiIconComponent, FormsModule, CuiIconButtonComponent, MatFormFieldModule, i4.MatError, ReactiveFormsModule, FileDragNDropDirective, FormatBytesPipe, MatButtonModule, MatProgressBarModule, i6.MatProgressBar, MatTooltipModule, i3.MatTooltip, MatExpansionModule, i8.MatAccordion, i8.MatExpansionPanel, i8.MatExpansionPanelHeader, i8.MatExpansionPanelTitle],
        styles: [".dropzone.container[_ngcontent-%COMP%]{container-type:inline-size}@container (max-width: 400px){.dropzone.container[_ngcontent-%COMP%]   .upload-button#container-btn[_ngcontent-%COMP%]{margin-bottom:var(--cui-small-space);display:block}.dropzone.container[_ngcontent-%COMP%]   .upload-button#container-btn[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{flex-direction:column}.dropzone.container[_ngcontent-%COMP%]   .upload-button#container-btn[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{padding:0;text-align:center}.dropzone.container[_ngcontent-%COMP%]   .upload-button#container-btn[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   h3.required[_ngcontent-%COMP%]:after{right:43px}.dropzone.container[_ngcontent-%COMP%]   .expectations[_ngcontent-%COMP%]{margin-bottom:var(--cui-medium-space)}}.dropzone[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between;padding:var(--cui-medium-space)}.dropzone[_ngcontent-%COMP%]   .upload-button[_ngcontent-%COMP%]{display:flex;align-items:center;position:relative;margin:0 auto var(--cui-small-space) auto}.dropzone[_ngcontent-%COMP%]   .upload-button[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:flex}.dropzone[_ngcontent-%COMP%]   .upload-button[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]:first-child{padding-left:var(--cui-medium-space);margin-right:5px}.dropzone[_ngcontent-%COMP%]   .upload-button[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   h3.required[_ngcontent-%COMP%]{position:relative}.dropzone[_ngcontent-%COMP%]   .upload-button[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   h3.required[_ngcontent-%COMP%]:after{content:\"*\";color:var(--color-danger);font-size:13px;position:absolute;right:-10px;top:-5px}.dropzone[_ngcontent-%COMP%]   .upload-instruction[_ngcontent-%COMP%]   .extensions[_ngcontent-%COMP%]{display:flex;align-items:center}.dropzone[_ngcontent-%COMP%]   .upload-instruction[_ngcontent-%COMP%]   .extensions[_ngcontent-%COMP%]   cui-icon[_ngcontent-%COMP%]{padding-left:5px}input[type=file][_ngcontent-%COMP%]{display:none}.files-list[_ngcontent-%COMP%]{margin-top:var(--cui-medium-space)}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;border-bottom:solid 1px var(--cui-color-border);margin-bottom:var(--cui-medium-space)}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]   cui-icon.folder[_ngcontent-%COMP%]{margin:var(--cui-small-space)}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]   .left-side[_ngcontent-%COMP%]{display:flex;align-items:center;flex:1}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]   .left-side[_ngcontent-%COMP%]   mat-progress-bar[_ngcontent-%COMP%]{border-radius:15px;height:10px}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]   .right-side[_ngcontent-%COMP%]{display:flex;align-items:center}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{width:100%;overflow:hidden;overflow-wrap:anywhere;display:flex;flex-direction:column}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   small.error[_ngcontent-%COMP%]{color:var(--color-danger)}.files-list[_ngcontent-%COMP%]   .single-file[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]{width:100%;padding:0 var(--cui-medium-space)}"],
        data: {
          animation: [trigger('animateOut', [transition(':leave', [style({
            opacity: 1
          }), animate('1s ease-in', style({
            opacity: 0
          }))])])]
        },
        changeDetection: 0
      });
    }
  }
  return CuiFilesUploaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileUploadComponentDialog = /*#__PURE__*/(() => {
  class FileUploadComponentDialog {
    constructor(dialogRef, fileService) {
      this.dialogRef = dialogRef;
      this.fileService = fileService;
      this.isValid = false;
      this.title = dialogRef.config.data?.title ?? 'Upload file';
      this.config = dialogRef.config.data?.config ?? DEFAULT_CONFIG;
    }
    onConfirm() {
      if (this.file) {
        this.fileService.createFileWithoutUpload({
          fileName: this.file.name,
          branchId: this.config.branchId,
          path: this.config.path,
          partnerId: this.config.partnerId
        }).subscribe(res => {
          this.dialogRef.close({
            file: this.file,
            fileId: res.id,
            uploadURL: res.uploadURL,
            fileProgress: this.fileService.fileProgress
          });
        });
      }
    }
    onCancel() {
      this.dialogRef.close(undefined);
    }
    fileListModified(files) {
      this.file = files[0];
    }
    updateValidity(isValid) {
      this.isValid = isValid;
    }
    static {
      this.ɵfac = function FileUploadComponentDialog_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FileUploadComponentDialog)(i0.ɵɵdirectiveInject(i1$3.DialogRef), i0.ɵɵdirectiveInject(FileStorageService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FileUploadComponentDialog,
        selectors: [["cui-files-upload-dialog"]],
        decls: 11,
        vars: 4,
        consts: [[3, "close", "showCloseBtn"], [3, "validFileListModified", "isValid", "config"], [3, "clicked"], [3, "clicked", "disabled"]],
        template: function FileUploadComponentDialog_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cui-card")(1, "cui-card-header", 0);
            i0.ɵɵlistener("close", function FileUploadComponentDialog_Template_cui_card_header_close_1_listener() {
              return ctx.onCancel();
            });
            i0.ɵɵelementStart(2, "h3");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "cui-card-body")(5, "cui-files-uploader", 1);
            i0.ɵɵlistener("validFileListModified", function FileUploadComponentDialog_Template_cui_files_uploader_validFileListModified_5_listener($event) {
              return ctx.fileListModified($event);
            })("isValid", function FileUploadComponentDialog_Template_cui_files_uploader_isValid_5_listener($event) {
              return ctx.updateValidity($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "cui-card-footer")(7, "cui-button", 2);
            i0.ɵɵlistener("clicked", function FileUploadComponentDialog_Template_cui_button_clicked_7_listener() {
              return ctx.onCancel();
            });
            i0.ɵɵtext(8, "Cancel");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "cui-button-cta", 3);
            i0.ɵɵlistener("clicked", function FileUploadComponentDialog_Template_cui_button_cta_clicked_9_listener() {
              return ctx.onConfirm();
            });
            i0.ɵɵtext(10, "Upload");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("showCloseBtn", true);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("config", ctx.config);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", !ctx.file || !ctx.isValid);
          }
        },
        dependencies: [CuiCardModule, CuiCardComponent, CuiCardHeaderComponent, CuiCardBodyComponent, CuiCardFooterComponent, CuiButtonsModule, CuiButtonComponent, CuiButtonCtaComponent, CuiFilesUploaderComponent],
        styles: ["[_nghost-%COMP%]{min-width:fit-content;max-width:80%;display:block;margin:auto}"],
        changeDetection: 0
      });
    }
  }
  return FileUploadComponentDialog;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiAlertComponent = /*#__PURE__*/(() => {
  class CuiAlertComponent {
    getAlertClass() {
      return `alert-${this.type}`;
    }
    getIcon() {
      switch (this.type) {
        case 'success':
          return 'check_circle';
        case 'info':
          return 'info';
        case 'warning':
          return 'warning';
        case 'danger':
          return 'error';
        default:
          return '';
      }
    }
    static {
      this.ɵfac = function CuiAlertComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiAlertComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiAlertComponent,
        selectors: [["cui-alert"]],
        inputs: {
          type: "type",
          message: "message"
        },
        decls: 4,
        vars: 5,
        consts: [[1, "alert", 3, "ngClass"], [3, "name"], [3, "innerHTML"]],
        template: function CuiAlertComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "cui-icon", 1)(2, "span", 2);
            i0.ɵɵpipe(3, "parseHtml");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.getAlertClass());
            i0.ɵɵadvance();
            i0.ɵɵproperty("name", ctx.getIcon());
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(3, 3, ctx.message), i0.ɵɵsanitizeHtml);
          }
        },
        dependencies: [CommonModule, i2.NgClass, CuiIconComponent, ParseHtmlPipe],
        styles: [".alert[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:left;width:100%;border:1px solid var(--color-white);border-radius:3px}cui-icon[_ngcontent-%COMP%]{min-width:25px;margin:.25em .5em}.alert-success[_ngcontent-%COMP%]{color:var(--color-success);border-color:var(--color-success)}.alert-info[_ngcontent-%COMP%]{color:var(--color-info);border-color:var(--color-info)}.alert-warning[_ngcontent-%COMP%]{color:var(--color-warning);border-color:var(--color-warning)}.alert-danger[_ngcontent-%COMP%]{color:var(--color-danger);border-color:var(--color-danger)}"],
        changeDetection: 0
      });
    }
  }
  return CuiAlertComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormComponentBase = /*#__PURE__*/(() => {
  class FormComponentBase extends SubscribingBase {
    get invalid() {
      return !!(this.control && this.control.invalid);
    }
    get dirty() {
      return !!(this.control && this.control.dirty);
    }
    get touched() {
      return !!(this.control && this.control.touched);
    }
    get showErrors() {
      return this.invalid && this.touched;
    }
    get disabled() {
      return !!(this.control && this.control.disabled);
    }
    get pending() {
      return !!(this.control && this.control.pending);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵFormComponentBase_BaseFactory;
        return function FormComponentBase_Factory(__ngFactoryType__) {
          return (ɵFormComponentBase_BaseFactory || (ɵFormComponentBase_BaseFactory = i0.ɵɵgetInheritedFactory(FormComponentBase)))(__ngFactoryType__ || FormComponentBase);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormComponentBase,
        selectors: [["ng-component"]],
        inputs: {
          required: "required",
          html: "html",
          label: "label",
          hint: "hint",
          placeholder: "placeholder",
          suffix: "suffix"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 0,
        vars: 0,
        template: function FormComponentBase_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return FormComponentBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormArrayComponentBase = /*#__PURE__*/(() => {
  class FormArrayComponentBase extends FormComponentBase {
    constructor(formArrayControlContainer) {
      super();
      this.formArrayControlContainer = formArrayControlContainer;
    }
    get items() {
      return this.formGroups.map(this.mapGroupToEntity);
    }
    get control() {
      return this.formArrayControlContainer && this.formArrayControlContainer.control;
    }
    get formGroups() {
      return !!this.control ? this.control.controls : [];
    }
    add(entity) {
      this.control.markAsTouched();
      if (entity instanceof FormGroup) {
        return this.addFormGroup(entity);
      }
      return this.addEntity(entity);
    }
    update(_) {
      throw new Error('update(entity: TEntity | FormGroup) not implemented yet');
    }
    remove(entity) {
      this.control.markAsTouched();
      if (entity instanceof FormGroup) {
        this.removeFormGroup(entity);
      } else {
        this.removeEntity(entity);
      }
    }
    findFormGroupBy(predicate) {
      const wrappedPredicate = formGroup => {
        const entity = this.mapGroupToEntity(formGroup);
        return predicate(entity);
      };
      return this.formGroups.find(wrappedPredicate);
    }
    getControl(formGroup, controlName) {
      return formGroup && formGroup.get(controlName);
    }
    getControlValue(formGroup, controlName) {
      const formControl = this.getControl(formGroup, controlName);
      return formControl && formControl.value;
    }
    setControlValue(formGroup, controlName, value) {
      const formControl = this.getControl(formGroup, controlName);
      formControl.setValue(value);
    }
    addEntity(entity) {
      const formGroup = this.mapEntityToGroup(entity);
      this.addFormGroup(formGroup);
      return formGroup;
    }
    addFormGroup(formGroup) {
      this.control.push(formGroup);
      return formGroup;
    }
    removeEntity(entity) {
      const group = this.mapEntityToGroup(entity);
      this.removeFormGroup(group);
    }
    removeFormGroup(formGroup) {
      const matchingGroup = this.findFormGroup(formGroup);
      if (matchingGroup instanceof FormGroup) {
        const index = this.formGroups.indexOf(matchingGroup);
        this.control.removeAt(index);
      } else {
        console.error('Trying to remove non-existing entity');
      }
    }
    getFormGroupId(entity) {
      return this.getId(this.mapGroupToEntity(entity));
    }
    formGroupIdMatcher(id) {
      return formGroup => this.getFormGroupId(formGroup) === id;
    }
    findFormGroup(formGroup) {
      const id = this.getFormGroupId(formGroup);
      return this.formGroups.find(this.formGroupIdMatcher(id));
    }
    static {
      this.ɵfac = function FormArrayComponentBase_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormArrayComponentBase)(i0.ɵɵdirectiveInject(i1$6.ControlContainer));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormArrayComponentBase,
        selectors: [["ng-component"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 0,
        vars: 0,
        template: function FormArrayComponentBase_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return FormArrayComponentBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormControlComponentBase = /*#__PURE__*/(() => {
  class FormControlComponentBase extends FormComponentBase {
    constructor(ngControl) {
      super();
      this.ngControl = ngControl;
      this.defaultAccessor = {
        writeValue: () => {},
        setDisabledState: () => {},
        registerOnTouched: () => {},
        registerOnChange: () => {}
      };
      ngControl.valueAccessor = this.defaultAccessor;
    }
    get control() {
      return this.ngControl.control;
    }
    set controlValueAccessor(accessor) {
      this.ngControl.valueAccessor = accessor;
    }
    static {
      this.ɵfac = function FormControlComponentBase_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormControlComponentBase)(i0.ɵɵdirectiveInject(i1$6.NgControl));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormControlComponentBase,
        selectors: [["ng-component"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 0,
        vars: 0,
        template: function FormControlComponentBase_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return FormControlComponentBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiErrorsComponent = /*#__PURE__*/(() => {
  class CuiErrorsComponent {
    constructor() {
      this.hint = '';
    }
    static {
      this.ɵfac = function CuiErrorsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiErrorsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiErrorsComponent,
        selectors: [["cui-errors"]],
        inputs: {
          control: "control",
          hint: "hint"
        },
        decls: 1,
        vars: 1,
        consts: () => {
          let i18n_0;
          if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG__USR_APP_NODE_MODULES_CUI_COMPONENTS_FESM2022_CUI_COMPONENTS_MJS_0 = goog.getMsg(" Please confirm that you have read and accept Companial Terms of Service and Privacy Policy ");
            i18n_0 = MSG__USR_APP_NODE_MODULES_CUI_COMPONENTS_FESM2022_CUI_COMPONENTS_MJS_0;
          } else {
            i18n_0 = $localize` Please confirm that you have read and accept Companial Terms of Service and Privacy Policy `;
          }
          let i18n_1;
          if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG__USR_APP_NODE_MODULES_CUI_COMPONENTS_FESM2022_CUI_COMPONENTS_MJS_1 = goog.getMsg(" Please confirm that you have read and agree with this statement ");
            i18n_1 = MSG__USR_APP_NODE_MODULES_CUI_COMPONENTS_FESM2022_CUI_COMPONENTS_MJS_1;
          } else {
            i18n_1 = $localize` Please confirm that you have read and agree with this statement `;
          }
          let i18n_2;
          if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG__USR_APP_NODE_MODULES_CUI_COMPONENTS_FESM2022_CUI_COMPONENTS_MJS_2 = goog.getMsg(" Value is not a valid GUID ");
            i18n_2 = MSG__USR_APP_NODE_MODULES_CUI_COMPONENTS_FESM2022_CUI_COMPONENTS_MJS_2;
          } else {
            i18n_2 = $localize` Value is not a valid GUID `;
          }
          let i18n_3;
          if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG__USR_APP_NODE_MODULES_CUI_COMPONENTS_FESM2022_CUI_COMPONENTS_MJS_3 = goog.getMsg(" Time cannot be earlier than {$interpolation}. ", {
              "interpolation": "\uFFFD0\uFFFD"
            }, {
              original_code: {
                "interpolation": "{{ control.errors?.['timeMinValue'] }}"
              }
            });
            i18n_3 = MSG__USR_APP_NODE_MODULES_CUI_COMPONENTS_FESM2022_CUI_COMPONENTS_MJS_3;
          } else {
            i18n_3 = $localize` Time cannot be earlier than ${"\uFFFD0\uFFFD"}:INTERPOLATION:. `;
          }
          let i18n_4;
          if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG__USR_APP_NODE_MODULES_CUI_COMPONENTS_FESM2022_CUI_COMPONENTS_MJS_4 = goog.getMsg(" Time cannot be later than {$interpolation}. ", {
              "interpolation": "\uFFFD0\uFFFD"
            }, {
              original_code: {
                "interpolation": "{{ control.errors?.['timeMaxValue'] }}"
              }
            });
            i18n_4 = MSG__USR_APP_NODE_MODULES_CUI_COMPONENTS_FESM2022_CUI_COMPONENTS_MJS_4;
          } else {
            i18n_4 = $localize` Time cannot be later than ${"\uFFFD0\uFFFD"}:INTERPOLATION:. `;
          }
          let i18n_5;
          if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG__USR_APP_NODE_MODULES_CUI_COMPONENTS_FESM2022_CUI_COMPONENTS_MJS_5 = goog.getMsg(" Field cannot contain only whitespace changes. ");
            i18n_5 = MSG__USR_APP_NODE_MODULES_CUI_COMPONENTS_FESM2022_CUI_COMPONENTS_MJS_5;
          } else {
            i18n_5 = $localize` Field cannot contain only whitespace changes. `;
          }
          return [i18n_0, i18n_1, i18n_2, i18n_3, i18n_4, i18n_5, [4, "ngIf"]];
        },
        template: function CuiErrorsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CuiErrorsComponent_ng_container_0_Template, 35, 34, "ng-container", 6);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", !!ctx.control);
          }
        },
        dependencies: [CommonModule, i2.NgIf, IsoDatePipe, FormatBytesPipe],
        encapsulation: 2
      });
    }
  }
  return CuiErrorsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiCheckboxComponent = /*#__PURE__*/(() => {
  class CuiCheckboxComponent extends FormControlComponentBase {
    constructor(ngControl) {
      super(ngControl);
      this.ngInvalid = this.invalid;
      this.ngTouched = this.touched;
      this.valueChange = new EventEmitter();
    }
    set valueAccessor(value) {
      this.controlValueAccessor = value;
    }
    static {
      this.ɵfac = function CuiCheckboxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiCheckboxComponent)(i0.ɵɵdirectiveInject(i1$6.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiCheckboxComponent,
        selectors: [["cui-checkbox"]],
        viewQuery: function CuiCheckboxComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatCheckbox, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.valueAccessor = _t.first);
          }
        },
        hostVars: 4,
        hostBindings: function CuiCheckboxComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ngInvalid", ctx.ngInvalid)("ngTouched", ctx.ngTouched);
          }
        },
        outputs: {
          valueChange: "valueChange"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 5,
        consts: [["color", "accent", 3, "change", "formControl", "required"], [3, "innerHTML"], [1, "hint"], [4, "ngIf"], [3, "control"]],
        template: function CuiCheckboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-checkbox", 0);
            i0.ɵɵlistener("change", function CuiCheckboxComponent_Template_mat_checkbox_change_0_listener($event) {
              return ctx.valueChange.emit($event.checked);
            });
            i0.ɵɵelement(1, "span", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "small", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, CuiCheckboxComponent_mat_error_4_Template, 2, 1, "mat-error", 3);
          }
          if (rf & 2) {
            i0.ɵɵproperty("formControl", ctx.control)("required", ctx.required);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", ctx.html ? ctx.html : ctx.label, i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.hint);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.control.invalid && ctx.control.touched);
          }
        },
        dependencies: [CommonModule, i2.NgIf, ReactiveFormsModule, i1$6.NgControlStatus, i1$6.RequiredValidator, i1$6.FormControlDirective, MatFormFieldModule, i4.MatError, MatCheckboxModule, i4$1.MatCheckbox, CuiErrorsComponent],
        styles: ["[_nghost-%COMP%]{display:block}.ng-invalid.ng-touched[_nghost-%COMP%] > label[_ngcontent-%COMP%]{color:#f44336}small.hint[_ngcontent-%COMP%]{display:block;font-size:75%;color:#7f7f7f}mat-error[_ngcontent-%COMP%]{padding-left:25px}"],
        changeDetection: 0
      });
    }
  }
  return CuiCheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MY_DATE_FORMAT$1 = {
  parse: {
    dateInput: 'dd/MM/yyyy' // this is how your date will be parsed from Input
  },
  display: {
    dateInput: 'yyyy-MM-dd',
    // this is how your date will get displayed on the Input
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy'
  }
};
let CuiDatepickerComponent = /*#__PURE__*/(() => {
  class CuiDatepickerComponent extends FormControlComponentBase {
    constructor(ngControl, cdr) {
      super(ngControl);
      this.cdr = cdr;
      this.panelClass = '';
      this.oldValue = new Date();
    }
    ngDoCheck() {
      if (this.control.value !== this.oldValue) {
        this.oldValue = this.control.value;
        this.cdr.detectChanges();
      }
    }
    static {
      this.ɵfac = function CuiDatepickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiDatepickerComponent)(i0.ɵɵdirectiveInject(i1$6.NgControl, 10), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiDatepickerComponent,
        selectors: [["cui-date-picker"]],
        inputs: {
          minDate: "minDate",
          maxDate: "maxDate",
          filter: "filter",
          panelClass: "panelClass"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: MAT_DATE_LOCALE,
          useValue: enGB
        }, {
          provide: DateAdapter,
          useClass: DateFnsAdapter,
          deps: [MAT_DATE_LOCALE]
        }, {
          provide: MAT_DATE_FORMATS,
          useValue: MY_DATE_FORMAT$1
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 9,
        consts: [["picker", ""], ["matInput", "", 3, "matDatepicker", "matDatepickerFilter", "min", "max", "formControl"], ["matSuffix", "", 3, "for"], [3, "panelClass"], [4, "ngIf"], [3, "control"]],
        template: function CuiDatepickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field")(1, "mat-label");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "input", 1)(4, "mat-datepicker-toggle", 2)(5, "mat-datepicker", 3, 0);
            i0.ɵɵtemplate(7, CuiDatepickerComponent_mat_error_7_Template, 2, 1, "mat-error", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const picker_r2 = i0.ɵɵreference(6);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("matDatepicker", picker_r2)("matDatepickerFilter", ctx.filter)("min", ctx.minDate)("max", ctx.maxDate)("formControl", ctx.control);
            i0.ɵɵadvance();
            i0.ɵɵproperty("for", picker_r2);
            i0.ɵɵadvance();
            i0.ɵɵproperty("panelClass", ctx.panelClass);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.control.invalid);
          }
        },
        dependencies: [MatNativeDateModule, MatFormFieldModule, i4.MatFormField, i4.MatLabel, i4.MatError, i4.MatSuffix, CommonModule, i2.NgIf, MatDatepickerModule, i4$2.MatDatepicker, i4$2.MatDatepickerInput, i4$2.MatDatepickerToggle, ReactiveFormsModule, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.FormControlDirective, MatInputModule, i5.MatInput, CuiErrorsComponent],
        styles: ["[_nghost-%COMP%]{display:block;margin:var(--cui-small-space) 0}mat-form-field[_ngcontent-%COMP%]{width:100%}"],
        changeDetection: 0
      });
    }
  }
  return CuiDatepickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DEFAULT_INPUT_CONFIG = {
  ...DEFAULT_CONFIG,
  allowedFilesCount: 1,
  // Allowed files count is always 1 for file input
  skipBlobStorageUpload: false,
  uploadFilesImmediately: false
};
let CuiFileInputComponent = /*#__PURE__*/(() => {
  class CuiFileInputComponent extends FormControlComponentBase {
    set config(providedConfig) {
      this._config = {
        ...DEFAULT_INPUT_CONFIG,
        ...providedConfig
      };
    }
    get config() {
      return this._config;
    }
    constructor(ngControl, dialogService, fileStorageService) {
      super(ngControl);
      this.dialogService = dialogService;
      this.fileStorageService = fileStorageService;
      this.tooltipText = '';
      this.fileUploaded = new EventEmitter();
      this.fileUploadProgress$ = this.fileStorageService.fileProgress.pipe(filter(fileUpload => fileUpload !== null && fileUpload.fileId === this.fileId), tap(fileUpload => {
        if (fileUpload === null) {
          this.hint = '';
          this.control.updateValueAndValidity();
        } else if (fileUpload.progress === 100) {
          this.hint = '';
          this.control.updateValueAndValidity();
        } else {
          this.control.markAsPending();
          this.hint = 'Upload in progress...';
        }
      }));
      this._config = DEFAULT_INPUT_CONFIG;
    }
    set valueAccessor(value) {
      this.controlValueAccessor = value;
    }
    /**
     * When this method is called file upload to blob storage is started.
     */
    onFileUploadClick() {
      const onClosed = this.dialogService.openDialog(FileUploadComponentDialog, {
        config: this.config
      }, {
        minWidth: '80%'
      }).closed;
      this.subscribe(onClosed, data => {
        if (data && data.file && data.fileId) {
          this.control.setValue(data.file.name);
          this.fileId = data.fileId;
          this.control.markAsDirty();
          this.fileUploaded.emit({
            fileId: data.fileId,
            file: data.file
          });
          if (!this.config.skipBlobStorageUpload) {
            this.fileStorageService.uploadFileToBlobStorage(data.uploadURL, data.file, data.fileId).subscribe();
          }
        } else {
          this.onFileRemove();
        }
      });
    }
    onFileRemove() {
      if (this.fileStorageService.abortControllers[this.fileId]) {
        this.fileStorageService.abortControllers[this.fileId].abort();
        delete this.fileStorageService.abortControllers[this.fileId];
      }
      this.control.setValue('');
      this.fileId = undefined;
      this.control.markAsDirty();
      this.hint = '';
    }
    /**
     * Method for activating file. Most probably this method will be called when user submits the whole form in
     * which this file input component is used.
     * @returns Observable<unknown>
     */
    activateUploadedFile() {
      if (this.fileId) {
        return this.fileStorageService.activateFile(this.fileId);
      } else {
        return of();
      }
    }
    static {
      this.ɵfac = function CuiFileInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiFileInputComponent)(i0.ɵɵdirectiveInject(i1$6.NgControl, 10), i0.ɵɵdirectiveInject(DialogService), i0.ɵɵdirectiveInject(FileStorageService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiFileInputComponent,
        selectors: [["cui-file-input"]],
        viewQuery: function CuiFileInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c15, 7);
            i0.ɵɵviewQuery(DefaultValueAccessor, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.valueAccessor = _t.first);
          }
        },
        inputs: {
          autocomplete: "autocomplete",
          tooltipText: "tooltipText",
          tabIndex: "tabIndex",
          config: "config"
        },
        outputs: {
          fileUploaded: "fileUploaded"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 14,
        vars: 17,
        consts: [["inputElement", ""], ["matInput", "", 3, "type", "formControl", "readonly", "required", "placeholder", "autocomplete"], ["matSuffix", "", 1, "mat-suffix"], [4, "ngIf"], ["aria-label", "File", 3, "name", "disabled", "clicked", 4, "ngIf"], ["aria-label", "Remove", 3, "name", "disabled", "clicked", 4, "ngIf"], ["aria-label", "Info", 3, "name", "tooltipText", 4, "ngIf"], ["matSuffix", "", 4, "ngIf"], ["matSuffix", "", 3, "mode", "diameter", "value", 4, "ngIf"], ["aria-label", "Info", "matSuffix", "", 3, "name", 4, "ngIf"], ["matSuffix", "", 3, "mode", "diameter", "value"], ["aria-label", "Info", "matSuffix", "", 3, "name"], ["aria-label", "File", 3, "clicked", "name", "disabled"], ["aria-label", "Remove", 3, "clicked", "name", "disabled"], ["aria-label", "Info", 3, "name", "tooltipText"], ["matSuffix", ""], [3, "control", "hint"]],
        template: function CuiFileInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field")(1, "mat-label");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "input", 1, 0);
            i0.ɵɵelementStart(5, "div", 2);
            i0.ɵɵtemplate(6, CuiFileInputComponent_ng_container_6_Template, 3, 2, "ng-container", 3);
            i0.ɵɵpipe(7, "async");
            i0.ɵɵtemplate(8, CuiFileInputComponent_cui_icon_btn_8_Template, 1, 2, "cui-icon-btn", 4)(9, CuiFileInputComponent_cui_icon_btn_9_Template, 1, 2, "cui-icon-btn", 5)(10, CuiFileInputComponent_cui_icon_10_Template, 1, 2, "cui-icon", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, CuiFileInputComponent_span_11_Template, 2, 1, "span", 7)(12, CuiFileInputComponent_mat_hint_12_Template, 2, 1, "mat-hint", 3)(13, CuiFileInputComponent_mat_error_13_Template, 2, 2, "mat-error", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("type", "text")("formControl", ctx.control)("readonly", true)("required", ctx.required)("placeholder", ctx.placeholder)("autocomplete", ctx.autocomplete);
            i0.ɵɵattribute("tabindex", ctx.tabIndex);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 15, ctx.fileUploadProgress$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.control.value);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !!ctx.control.value);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.tooltipText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.suffix);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.hint);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.control.invalid);
          }
        },
        dependencies: [CommonModule, i2.NgIf, i2.AsyncPipe, FormsModule, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.RequiredValidator, ReactiveFormsModule, i1$6.FormControlDirective, MatInputModule, i5.MatInput, i4.MatFormField, i4.MatLabel, i4.MatHint, i4.MatError, i4.MatSuffix, MatFormFieldModule, CuiErrorsComponent, CuiIconButtonComponent, CuiIconComponent, MatProgressSpinnerModule, i3$1.MatProgressSpinner],
        styles: ["[_nghost-%COMP%]{display:block;margin:var(--cui-small-space) 0}mat-form-field[_ngcontent-%COMP%]{width:100%}.mat-suffix[_ngcontent-%COMP%]{display:flex;align-items:center}"]
      });
    }
  }
  return CuiFileInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiFormSlideToggleComponent = /*#__PURE__*/(() => {
  class CuiFormSlideToggleComponent extends FormControlComponentBase {
    constructor(ngControl) {
      super(ngControl);
      this.classes = [];
    }
    set valueAccessor(value) {
      this.controlValueAccessor = value;
    }
    static {
      this.ɵfac = function CuiFormSlideToggleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiFormSlideToggleComponent)(i0.ɵɵdirectiveInject(i1$6.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiFormSlideToggleComponent,
        selectors: [["cui-form-slide-toggle"]],
        viewQuery: function CuiFormSlideToggleComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatSlideToggle, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.valueAccessor = _t.first);
          }
        },
        inputs: {
          classes: "classes"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 7,
        consts: [[3, "ngClass"], [4, "ngIf"], ["disableRipple", "", 3, "formControl"]],
        template: function CuiFormSlideToggleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "label", 0);
            i0.ɵɵtemplate(1, CuiFormSlideToggleComponent_span_1_Template, 2, 1, "span", 1);
            i0.ɵɵelement(2, "mat-slide-toggle", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.classes.join(" "));
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c16, ctx.disabled));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formControl", ctx.control);
          }
        },
        dependencies: [MatSlideToggleModule, i2$4.MatSlideToggle, ReactiveFormsModule, i1$6.NgControlStatus, i1$6.FormControlDirective, CommonModule, i2.NgClass, i2.NgIf],
        styles: ["[_nghost-%COMP%]{display:block;margin:0}label[_ngcontent-%COMP%]{cursor:pointer;display:flex;align-items:center;width:100%}label[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{margin-right:var(--cui-small-space)}label.disabled[_ngcontent-%COMP%]{color:var(--color-disabled);cursor:default}"],
        changeDetection: 0
      });
    }
  }
  return CuiFormSlideToggleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const emailBlockedDomainRegExp = new RegExp('(?<=@)[^.]+(?=.)');
const digitRegExp = new RegExp('[0-9]');
const plusSymbolRegExp = new RegExp(/[+]/g);
const integerRegExp = new RegExp('^0$|^-?[1-9][0-9]*$');
const allowedExpirationDateFormatRegExp = new RegExp('^(0[1-9]|1[0-2])/([0-9]{2}|[0-9]{2})$');
const allowedPhoneNumberSymbols = new RegExp(/[+\- ()\d]/g);
const latinLettersAndNumbersRegExp = new RegExp('^[a-zA-Z0-9]*$');
const specialSymbolRegExp = new RegExp(/[$-/:-?{-~!"^_@`\[\]]/);
const upperCaseRegExp = new RegExp(/[A-Z]+/);
const lowerCaseRegExp = new RegExp(/[a-z]+/);
const numericRegExp = new RegExp(/[0-9]+/);
const allowedUrlLinkRegExp = new RegExp(/^[a-zA-Z0-9-_.]+$/);
let CuiValidators = /*#__PURE__*/(() => {
  class CuiValidators {
    static {
      this.fieldRepeated = originalField => {
        return c => {
          if (!(c && c.parent && c.parent.get)) {
            return null;
          }
          const myValue = c.value;
          const otherValue = c.parent.get(originalField).value;
          return otherValue === myValue ? null : {
            confirmationerror: true
          };
        };
      };
    }
    static {
      this.noDuplicates = existingValues => {
        return control => {
          if (existingValues.includes(control.value)) {
            return {
              isNotUnique: true
            };
          }
          return null;
        };
      };
    }
    static {
      this.richTextRequired = (emptyText = '') => {
        return control => {
          if (control.value === emptyText) {
            return {
              required: true
            };
          }
          return null;
        };
      };
    }
    static {
      this.maxDataSizeInBytes = bytes => {
        return control => {
          if (control.value) {
            const dataSize = new Blob([control.value]).size;
            if (dataSize > bytes) {
              return {
                isTooBigInBytes: true,
                maxSizeInBytes: bytes,
                currentSize: dataSize
              };
            }
          }
          return null;
        };
      };
    }
    static checkAsyncValidator(check, error, showImmediateError = false) {
      return control => {
        if (!control.valueChanges) {
          return of(null);
        } else {
          return control.valueChanges.pipe(debounceTime(1000), distinctUntilChanged(), switchMap(check), map$1(status => status ? {
            [error]: true
          } : null), tap$1(() => {
            if (showImmediateError) {
              control.markAsDirty();
              control.markAsTouched();
            }
          }), first());
        }
      };
    }
    static checkEndpointAsyncValidator(check, error) {
      return c =>
      // wait for a second before validating
      timer(1000).pipe(map$1(() => c.value), switchMap(check), map$1(isValid => isValid ? null : {
        [error]: true
      }));
    }
    static fileRequired() {
      return control => {
        const isEmpty = control.value.length < 1;
        return isEmpty ? {
          required: ''
        } : null;
      };
    }
    static {
      this.integersOnly = control => {
        const isValid = !control.value || integerRegExp.test(control.value);
        return isValid ? null : {
          integerError: true
        };
      };
    }
    static {
      this.notEqualToZero = control => {
        const isValid = !control.value || +control.value !== 0;
        return isValid ? null : {
          integerEqualToZeroError: true
        };
      };
    }
    static {
      this.notEqualToCurrentValue = currentValue => {
        return control => {
          const isValid = +control.value !== currentValue;
          return isValid ? null : {
            valueEqualToCurrentValue: currentValue
          };
        };
      };
    }
    static latinLettersAndNumbersOnly() {
      return control => {
        const isValid = !control.value || latinLettersAndNumbersRegExp.test(control.value);
        return isValid ? null : {
          latinLettersAndNumbersError: true
        };
      };
    }
    static confirmTermsAndConditions() {
      return control => {
        return control.value ? null : {
          confirmTermsAndConditions: true
        };
      };
    }
    static emailBlockedDomain() {
      return control => {
        const blockedDomains = ['gmail', 'yahoo', 'yandex', 'icloud', 'gmx', 'proton', 'aol', 'inbox'];
        const domainRegExpValue = emailBlockedDomainRegExp.exec(control.value);
        if (domainRegExpValue) {
          const isValid = !control.value || !blockedDomains.includes(domainRegExpValue[0]);
          return isValid ? null : {
            emailBlockedDomain: true
          };
        }
        return null;
      };
    }
    static noEmptyStrings() {
      return control => {
        const isValid = !control.value || control.value.trim();
        return isValid ? null : {
          emptyStringError: true
        };
      };
    }
    static phoneNumber(control) {
      const phone = control.value;
      if (!phone) {
        return null;
      }
      const containsDigits = digitRegExp.test(phone);
      const tooManyPluses = (phone.match(plusSymbolRegExp) || []).length > 1;
      const plusNotAtStart = phone.includes('+') && phone[0] !== '+';
      if (!containsDigits || plusNotAtStart || tooManyPluses) {
        return {
          invalidPhoneError: true
        };
      }
      const leftovers = phone.replace(allowedPhoneNumberSymbols, '');
      return leftovers?.length > 0 ? {
        invalidPhoneError: true
      } : null;
    }
    static creditCardExpiresDate(control) {
      const date = control.value;
      if (!date) {
        return null;
      }
      const isValidFormat = allowedExpirationDateFormatRegExp.test(date);
      if (!isValidFormat) {
        return {
          invalidExpirationDateFormatError: true
        };
      }
      const inputValues = date.split('/');
      const inputMonth = Number(inputValues[0]);
      const inputYear = Number(inputValues[1]);
      return isValidExpirationDate(inputYear, inputMonth) ? null : {
        invalidExpirationDateError: true
      };
    }
    static passwordStrength(control) {
      const password = control.value;
      if (!password) {
        return null;
      }
      const hasUpperCase = upperCaseRegExp.test(password);
      const hasLowerCase = lowerCaseRegExp.test(password);
      const hasNumeric = numericRegExp.test(password);
      const hasSymbol = specialSymbolRegExp.test(password);
      const isPasswordValid = hasUpperCase && hasLowerCase && hasNumeric && hasSymbol;
      return isPasswordValid ? null : {
        weakPassword: true
      };
    }
    static validGuid() {
      return control => {
        const isValid = isGUID(control.value);
        return isValid ? null : {
          validGuidError: true
        };
      };
    }
    static timeMin(min) {
      return control => {
        if (control.value === '') {
          return null;
        }
        const [minHours, minMinutes] = min.split(':');
        const [hours, minutes] = control.value.split(':');
        if (hours && minutes) {
          if (+hours > +minHours) {
            return null;
          } else if (+hours === +minHours && +minutes > +minMinutes) {
            return null;
          }
        }
        return {
          timeMinError: true,
          timeMinValue: min
        };
      };
    }
    static timeMax(max) {
      return control => {
        if (control.value === '') {
          return null;
        }
        const [maxHours, maxMinutes] = max.split(':');
        const [hours, minutes] = control.value.split(':');
        if (hours && minutes) {
          if (+hours < +maxHours) {
            return null;
          } else if (+hours === +maxHours && +minutes < +maxMinutes) {
            return null;
          }
        }
        return {
          timeMaxError: true,
          timeMaxValue: max
        };
      };
    }
    static nonWhitespaceChanges(oldValue) {
      return control => {
        const hasOnlyWhiteSpaceChanges = control.value !== oldValue && control.value.trim() === oldValue;
        return !hasOnlyWhiteSpaceChanges ? null : {
          nonWhitespaceChangesError: true
        };
      };
    }
    static guidOrEmptyValidator() {
      return control => {
        const value = control.value;
        if (!value) {
          return null;
        }
        const isValid = isGUID(control.value);
        return isValid ? null // Valid GUID
        : {
          validGuidError: true
        }; // Invalid GUID
      };
    }
    static customErrorMessage(validationFn, errorMessage) {
      return control => {
        const isValid = validationFn(control);
        return isValid ? null : {
          customErrorMessage: errorMessage
        };
      };
    }
    static noMaliciousCode() {
      return control => {
        const content = control.value;
        if (!content) {
          return null;
        }
        // Check for script tags
        if (/<script\b[^>]*>(.*?)<\/script>/i.test(content)) {
          return {
            customErrorMessage: 'Script tags are not allowed'
          };
        }
        // Check for iframe tags
        if (/<iframe\b[^>]*>/i.test(content)) {
          return {
            customErrorMessage: 'Iframe elements are not allowed'
          };
        }
        // Check for javascript: URLs
        if (/javascript:/i.test(content)) {
          return {
            customErrorMessage: 'JavaScript URLs are not allowed'
          };
        }
        // Check for event handlers (on*)
        if (/\s+on\w+\s*=/i.test(content)) {
          return {
            customErrorMessage: 'Event handlers are not allowed'
          };
        }
        // Check for data: URLs (could contain malicious code)
        if (/data:[^;]+;base64/i.test(content)) {
          return {
            customErrorMessage: 'Data URLs are not allowed'
          };
        }
        // Check for SVG with embedded scripts
        if (/<svg\b[^>]*>.*?<script\b[^>]*>/i.test(content)) {
          return {
            customErrorMessage: 'SVG with scripts is not allowed'
          };
        }
        // Check for CSS with javascript URLs
        if (/url\s*\(\s*javascript:/i.test(content)) {
          return {
            customErrorMessage: 'CSS with JavaScript URLs is not allowed'
          };
        }
        // Check for meta tags with content refresh
        if (/<meta\b[^>]*\bhttp-equiv\s*=\s*["']?refresh["']?/i.test(content)) {
          return {
            customErrorMessage: 'Meta refresh tags are not allowed'
          };
        }
        // Check for form actions with javascript:
        if (/<form\b[^>]*\baction\s*=\s*["']?javascript:/i.test(content)) {
          return {
            customErrorMessage: 'Form with JavaScript actions is not allowed'
          };
        }
        // Check for object/embed tags
        if (/<(object|embed)\b[^>]*>/i.test(content)) {
          return {
            customErrorMessage: 'Object or embed tags are not allowed'
          };
        }
        return null;
      };
    }
  }
  return CuiValidators;
})();
/**
 * @param expirationYearTwoDigits Ex.: 21 (if year 2021)
 * @param expirationMonth Ex.: 1 (if January)
 */
function isValidExpirationDate(expirationYearTwoDigits, expirationMonth) {
  // currentYear result example: (2021) => "21"
  const currentYearTwoDigits = Number(new Date().getFullYear().toString().slice(-2));
  const currentMonth = Number(new Date().getMonth() + 1);
  if (currentYearTwoDigits > expirationYearTwoDigits) {
    // Expired in previous years
    return false;
  }
  if (currentYearTwoDigits === expirationYearTwoDigits && currentMonth > expirationMonth) {
    // Expired in previous months
    return false;
  }
  if (expirationYearTwoDigits > currentYearTwoDigits + 20) {
    // User entered an expiration year that is more than 20 years in the future
    return false;
  }
  return true;
}
let CuiInputComponent = /*#__PURE__*/(() => {
  class CuiInputComponent extends FormControlComponentBase {
    constructor(ngControl) {
      super(ngControl);
      this.type = 'text';
      this.copyBtn = false;
      this.clearBtn = false;
      this.tooltipText = '';
      this.copy = new EventEmitter();
      this.clearSearch = new EventEmitter();
    }
    set valueAccessor(value) {
      this.controlValueAccessor = value;
    }
    ngAfterContentInit() {
      if (this.autoFocus !== undefined) {
        setTimeout(() => this.inputElement.nativeElement.focus());
      }
    }
    onCopy() {
      navigator.clipboard.writeText(this.ngControl.value);
      this.copy.emit(this.ngControl.value);
    }
    onClear() {
      this.control.setValue('');
      this.clearSearch.emit();
    }
    static {
      this.ɵfac = function CuiInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiInputComponent)(i0.ɵɵdirectiveInject(i1$6.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiInputComponent,
        selectors: [["cui-input"]],
        viewQuery: function CuiInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c15, 7);
            i0.ɵɵviewQuery(DefaultValueAccessor, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.valueAccessor = _t.first);
          }
        },
        inputs: {
          autocomplete: "autocomplete",
          autoFocus: "autoFocus",
          type: "type",
          minNumber: "minNumber",
          maxNumber: "maxNumber",
          copyBtn: "copyBtn",
          clearBtn: "clearBtn",
          tooltipText: "tooltipText",
          prefixIcon: "prefixIcon",
          tabIndex: "tabIndex"
        },
        outputs: {
          copy: "copy",
          clearSearch: "clearSearch"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 12,
        vars: 16,
        consts: [["inputElement", ""], ["matPrefix", "", 3, "name", 4, "ngIf"], ["matInput", "", 3, "type", "formControl", "required", "placeholder", "autocomplete", "min", "max"], ["aria-label", "Copy", "matSuffix", "", 3, "name", "disabled", "clicked", 4, "ngIf"], ["aria-label", "Clear", "matSuffix", "", 3, "name", "clicked", 4, "ngIf"], ["aria-label", "Info", "matSuffix", "", 3, "name", "tooltipText", 4, "ngIf"], ["matSuffix", "", 4, "ngIf"], [4, "ngIf"], ["matPrefix", "", 3, "name"], ["aria-label", "Copy", "matSuffix", "", 3, "clicked", "name", "disabled"], ["aria-label", "Clear", "matSuffix", "", 3, "clicked", "name"], ["aria-label", "Info", "matSuffix", "", 3, "name", "tooltipText"], ["matSuffix", ""], [3, "control", "hint"]],
        template: function CuiInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field")(1, "mat-label");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, CuiInputComponent_cui_icon_3_Template, 1, 1, "cui-icon", 1);
            i0.ɵɵelement(4, "input", 2, 0);
            i0.ɵɵtemplate(6, CuiInputComponent_cui_icon_btn_6_Template, 1, 2, "cui-icon-btn", 3)(7, CuiInputComponent_cui_icon_btn_7_Template, 1, 1, "cui-icon-btn", 4)(8, CuiInputComponent_cui_icon_8_Template, 1, 2, "cui-icon", 5)(9, CuiInputComponent_span_9_Template, 2, 1, "span", 6)(10, CuiInputComponent_mat_hint_10_Template, 2, 1, "mat-hint", 7)(11, CuiInputComponent_mat_error_11_Template, 2, 2, "mat-error", 7);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.prefixIcon);
            i0.ɵɵadvance();
            i0.ɵɵproperty("type", ctx.type)("formControl", ctx.control)("required", ctx.required)("placeholder", ctx.placeholder)("autocomplete", ctx.autocomplete)("min", ctx.minNumber)("max", ctx.maxNumber);
            i0.ɵɵattribute("tabindex", ctx.tabIndex);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.copyBtn);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.clearBtn && ctx.control.value);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.tooltipText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.suffix);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.hint);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.control.invalid);
          }
        },
        dependencies: [CommonModule, i2.NgIf, FormsModule, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.RequiredValidator, ReactiveFormsModule, i1$6.FormControlDirective, MatInputModule, i5.MatInput, i4.MatFormField, i4.MatLabel, i4.MatHint, i4.MatError, i4.MatPrefix, i4.MatSuffix, MatFormFieldModule, CuiErrorsComponent, CuiIconButtonComponent, CuiIconComponent],
        styles: [_c17]
      });
    }
  }
  return CuiInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MONTH_FORMATS = {
  parse: {
    dateInput: 'MM/yyyy'
  },
  display: {
    dateInput: 'MMMM yyyy',
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy'
  }
};
let CuiMonthPickerComponent = /*#__PURE__*/(() => {
  class CuiMonthPickerComponent extends FormControlComponentBase {
    constructor(ngControl, cdr) {
      super(ngControl);
      this.cdr = cdr;
    }
    onMonthSelected(selectedDate, datepicker) {
      const monthStart = startOfMonth(selectedDate);
      this.control.setValue(monthStart);
      datepicker.close();
    }
    ngDoCheck() {
      this.cdr.detectChanges();
    }
    static {
      this.ɵfac = function CuiMonthPickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiMonthPickerComponent)(i0.ɵɵdirectiveInject(i1$6.NgControl, 10), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiMonthPickerComponent,
        selectors: [["cui-month-picker"]],
        inputs: {
          minMonth: "minMonth",
          maxMonth: "maxMonth"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: MAT_DATE_LOCALE,
          useValue: enGB
        }, {
          provide: DateAdapter,
          useClass: DateFnsAdapter,
          deps: [MAT_DATE_LOCALE]
        }, {
          provide: MAT_DATE_FORMATS,
          useValue: MONTH_FORMATS
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 8,
        consts: [["picker", ""], ["matInput", "", 3, "click", "matDatepicker", "readonly", "formControl", "min", "max"], ["matSuffix", "", 3, "for"], ["startView", "year", 3, "monthSelected"], [4, "ngIf"], [3, "control"]],
        template: function CuiMonthPickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "mat-form-field")(1, "mat-label");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "input", 1);
            i0.ɵɵlistener("click", function CuiMonthPickerComponent_Template_input_click_3_listener() {
              i0.ɵɵrestoreView(_r1);
              const picker_r2 = i0.ɵɵreference(6);
              return i0.ɵɵresetView(picker_r2.open());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "mat-datepicker-toggle", 2);
            i0.ɵɵelementStart(5, "mat-datepicker", 3, 0);
            i0.ɵɵlistener("monthSelected", function CuiMonthPickerComponent_Template_mat_datepicker_monthSelected_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              const picker_r2 = i0.ɵɵreference(6);
              return i0.ɵɵresetView(ctx.onMonthSelected($event, picker_r2));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, CuiMonthPickerComponent_mat_error_7_Template, 2, 1, "mat-error", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const picker_r2 = i0.ɵɵreference(6);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("matDatepicker", picker_r2)("readonly", true)("formControl", ctx.control)("min", ctx.minMonth)("max", ctx.maxMonth);
            i0.ɵɵadvance();
            i0.ɵɵproperty("for", picker_r2);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.control.invalid);
          }
        },
        dependencies: [MatNativeDateModule, MatFormFieldModule, i4.MatFormField, i4.MatLabel, i4.MatError, i4.MatSuffix, CommonModule, i2.NgIf, MatDatepickerModule, i4$2.MatDatepicker, i4$2.MatDatepickerInput, i4$2.MatDatepickerToggle, ReactiveFormsModule, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.FormControlDirective, MatInputModule, i5.MatInput, CuiErrorsComponent],
        styles: [_c17],
        changeDetection: 0
      });
    }
  }
  return CuiMonthPickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiRadioChoiceComponent = /*#__PURE__*/(() => {
  class CuiRadioChoiceComponent {
    static {
      this.ɵfac = function CuiRadioChoiceComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiRadioChoiceComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiRadioChoiceComponent,
        selectors: [["cui-radio-choice"]],
        viewQuery: function CuiRadioChoiceComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(TemplateRef, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
          }
        },
        inputs: {
          value: "value",
          disabled: "disabled",
          hint: "hint"
        },
        ngContentSelectors: _c3,
        decls: 1,
        vars: 0,
        consts: [["class", "hint", 4, "ngIf"], [1, "hint"]],
        template: function CuiRadioChoiceComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, CuiRadioChoiceComponent_ng_template_0_Template, 2, 1, "ng-template");
          }
        },
        dependencies: [CommonModule, i2.NgIf, ReactiveFormsModule, MatFormFieldModule, MatRadioModule],
        styles: ["small.hint[_ngcontent-%COMP%]{display:block;font-size:75%;color:var(--hui-color-breadcrumbs)}"],
        changeDetection: 0
      });
    }
  }
  return CuiRadioChoiceComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiRadioComponent = /*#__PURE__*/(() => {
  class CuiRadioComponent extends FormControlComponentBase {
    constructor(ngControl) {
      super(ngControl);
      this.ngInvalid = this.invalid;
      this.ngTouched = this.touched;
    }
    set viewChildrenChoices(value) {
      this.choices = value?.toArray() ?? [];
    }
    set valueAccessor(value) {
      this.controlValueAccessor = value;
    }
    trackByValue(_, templateChoice) {
      return templateChoice.value.toString();
    }
    static {
      this.ɵfac = function CuiRadioComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiRadioComponent)(i0.ɵɵdirectiveInject(i1$6.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiRadioComponent,
        selectors: [["cui-radio"]],
        contentQueries: function CuiRadioComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, CuiRadioChoiceComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewChildrenChoices = _t);
          }
        },
        viewQuery: function CuiRadioComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatRadioGroup, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.valueAccessor = _t.first);
          }
        },
        hostVars: 4,
        hostBindings: function CuiRadioComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ngInvalid", ctx.ngInvalid)("ngTouched", ctx.ngTouched);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 9,
        consts: [["color", "accent", 3, "formControl", "required"], [3, "value", "disabled", 4, "ngFor", "ngForOf", "ngForTrackBy"], [4, "ngIf"], [3, "value", "disabled"], [3, "ngTemplateOutlet"], [3, "control"]],
        template: function CuiRadioComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "label");
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "mat-radio-group", 0);
            i0.ɵɵtemplate(3, CuiRadioComponent_mat_radio_button_3_Template, 2, 3, "mat-radio-button", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "mat-hint");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, CuiRadioComponent_mat_error_6_Template, 2, 1, "mat-error", 2);
          }
          if (rf & 2) {
            i0.ɵɵclassProp("required", ctx.required);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formControl", ctx.control)("required", ctx.required);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.choices)("ngForTrackBy", ctx.trackByValue);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.hint);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.invalid && ctx.touched);
          }
        },
        dependencies: [CommonModule, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, ReactiveFormsModule, i1$6.NgControlStatus, i1$6.RequiredValidator, i1$6.FormControlDirective, MatFormFieldModule, i4.MatHint, i4.MatError, MatRadioModule, i4$3.MatRadioGroup, i4$3.MatRadioButton, CuiErrorsComponent],
        styles: [".ng-invalid.ng-touched[_nghost-%COMP%] > label[_ngcontent-%COMP%]{color:#f44336}mat-radio-button[_ngcontent-%COMP%]{display:block}label.required[_ngcontent-%COMP%]:after{content:\" *\"}"],
        changeDetection: 0
      });
    }
  }
  return CuiRadioComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiRadioModule = /*#__PURE__*/(() => {
  class CuiRadioModule {
    static {
      this.ɵfac = function CuiRadioModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiRadioModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CuiRadioModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CuiRadioComponent, CuiRadioChoiceComponent]
      });
    }
  }
  return CuiRadioModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiRichEditorComponent = /*#__PURE__*/(() => {
  class CuiRichEditorComponent extends FormControlComponentBase {
    constructor(ngControl, cdr, el) {
      super(ngControl);
      this.cdr = cdr;
      this.el = el;
      this.autofocus = false;
      this.config = {};
      this.uniqueId = generateRandomAlphaString(10);
      this.defaultConfig = {
        readonly: false,
        height: 300,
        minHeight: 200,
        enableDragAndDropFileToEditor: true,
        showPlaceholder: false,
        popupRoot: document.body,
        style: {
          font: '1.125rem Segoe UI'
        }
      };
    }
    ngAfterViewInit() {
      this.editor = Jodit.make(`#${this.uniqueId}`, {
        ...this.defaultConfig,
        ...this.config
      });
      this.editor.e.on(this.el.nativeElement, 'change', e => {
        this.ngControl.control?.patchValue(e.target.value);
        this.ngControl.control?.markAsDirty();
      });
      if (this.autofocus) {
        this.focus();
      }
      this.editor.events.on('blur', () => this.blur());
      this.matLabel.nativeElement.parentElement?.classList.add('mdc-floating-label--float-above');
    }
    blur() {
      this.ngControl.control?.markAsTouched();
      this.cdr.detectChanges();
    }
    focus() {
      this.editor.focus();
      this.cdr.detectChanges();
    }
    ngOnDestroy() {
      this.unsubscribe();
      this.editor.destruct();
    }
    static {
      this.ɵfac = function CuiRichEditorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiRichEditorComponent)(i0.ɵɵdirectiveInject(i1$6.NgControl, 10), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiRichEditorComponent,
        selectors: [["cui-rich-editor"]],
        viewQuery: function CuiRichEditorComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c18, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.matLabel = _t.first);
          }
        },
        inputs: {
          name: "name",
          autofocus: "autofocus",
          config: "config"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 5,
        consts: [["matLabel", ""], [1, "mat-form-field-should-float", "mat-focused", "rich-text-editor"], [1, "mdc-floating-label--float-above"], ["matInput", "", 3, "formControl", "id"], [4, "ngIf"], [3, "control"]],
        template: function CuiRichEditorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field", 1)(1, "mat-label", 2, 0);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "textarea", 3);
            i0.ɵɵtemplate(5, CuiRichEditorComponent_mat_hint_5_Template, 2, 1, "mat-hint", 4)(6, CuiRichEditorComponent_mat_error_6_Template, 2, 1, "mat-error", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formControl", ctx.control)("id", ctx.uniqueId);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.hint);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.control.invalid);
          }
        },
        dependencies: [CommonModule, i2.NgIf, FormsModule, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, ReactiveFormsModule, i1$6.FormControlDirective, MatInputModule, i5.MatInput, i4.MatFormField, i4.MatLabel, i4.MatHint, i4.MatError, MatFormFieldModule, CuiErrorsComponent],
        styles: ["[_nghost-%COMP%]{overflow:hidden;display:block;margin:var(--cui-small-space) 0}mat-form-field[_ngcontent-%COMP%]{padding:var(--cui-small-space) var(--cui-small-space);width:100%;min-height:100px}"],
        changeDetection: 0
      });
    }
  }
  return CuiRichEditorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SearchSelectService = /*#__PURE__*/(() => {
  class SearchSelectService {
    constructor(http, config) {
      this.http = http;
      this.config = config;
    }
    searchItems(params) {
      return this.http.get(`${this.config.apiUrl}/search-select`, {
        params
      });
    }
    searchOneItem(id, params) {
      return this.http.get(`${this.config.apiUrl}/search-select/${id}`, {
        params
      });
    }
    static {
      this.ɵfac = function SearchSelectService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SearchSelectService)(i0.ɵɵinject(i1$5.HttpClient), i0.ɵɵinject(Configurations));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SearchSelectService,
        factory: SearchSelectService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SearchSelectService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiSearchSelectSsrComponent = /*#__PURE__*/(() => {
  class CuiSearchSelectSsrComponent extends FormControlComponentBase {
    constructor(ngControl, cdr, searchSelectService) {
      super(ngControl);
      this.cdr = cdr;
      this.searchSelectService = searchSelectService;
      /**
       * Due to limited api of NgSelect this approach was chosen, because You can not directly pass ng-template from parent,
       * that is why viewType property was introduced.
       * viewType needs to be specified in order to render options differently. Currently there only two cases of option views.
       * Here can be added more.
       */
      this.viewType = 'name_and_value';
      this.bindValue = 'value';
      this.bindLabel = 'name';
      this.addNewText = '';
      this.clearable = true;
      this.additionalParams = {};
      this.selectionChange = new EventEmitter();
      this.addNewSelected = new EventEmitter();
      this.selectedItem = null;
      this.items = [];
      this.notFoundText = 'Enter 2 characters for results';
      this.isLoading = false;
      this.typeAheadSubject$ = new Subject();
      this.typeAhead$ = this.typeAheadSubject$.asObservable().pipe(debounceTime$1(500)).subscribe(term => {
        if (!term || term.length < 2) {
          this.isLoading = false;
          this.setItemsState();
          this.cdr.detectChanges();
          this.notFoundText = 'Enter 2 characters for results';
          return;
        }
        this.initiateSearch(term);
      });
      this.isInitialValue = true;
      this.ngControl.valueAccessor = this;
    }
    initiateSearch(term) {
      this.isLoading = true;
      this.cdr.detectChanges();
      const params = {
        entity: this.entity,
        substring: encodeURIComponent(term),
        ...this.additionalParams
      };
      this.searchSelectService.searchItems(params).subscribe({
        next: items => this.items = items,
        error: () => {
          this.notFoundText = 'Error occurred while searching';
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        complete: () => {
          if (!this.items.length) {
            this.notFoundText = 'No items found';
          }
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      });
    }
    writeValue(value) {
      if (value && this.isInitialValue) {
        this.fetchInitialItems(value);
        this.isInitialValue = false;
      }
    }
    registerOnChange() {}
    registerOnTouched() {}
    onChange(item, isAddNewAction) {
      this.selectedItem = item;
      this.setItemsState();
      this.addNewSelected.emit(item === null && isAddNewAction);
      this.selectionChange.emit(item);
    }
    onBlur() {
      this.setItemsState();
    }
    onClear() {
      this.control.markAsDirty();
      this.onChange(null);
    }
    onAddNewClick() {
      this.onChange(null, true);
      this.ngSelect.close();
    }
    fetchInitialItems(id) {
      this.isLoading = true;
      const params = {
        entity: this.entity,
        ...this.additionalParams
      };
      this.searchSelectService.searchOneItem(id, params).subscribe({
        next: item => this.onChange(item),
        error: () => {
          this.isLoading = false;
          this.notFoundText = 'Error occurred while getting initial value';
          this.cdr.detectChanges();
        },
        complete: () => {
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      });
    }
    setItemsState() {
      this.items = this.selectedItem ? [this.selectedItem] : [];
    }
    static {
      this.ɵfac = function CuiSearchSelectSsrComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiSearchSelectSsrComponent)(i0.ɵɵdirectiveInject(i1$6.NgControl, 10), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(SearchSelectService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiSearchSelectSsrComponent,
        selectors: [["cui-search-select-ssr"]],
        viewQuery: function CuiSearchSelectSsrComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c19, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ngSelect = _t.first);
          }
        },
        inputs: {
          viewType: "viewType",
          bindValue: "bindValue",
          bindLabel: "bindLabel",
          addNewText: "addNewText",
          clearable: "clearable",
          entity: "entity",
          additionalParams: "additionalParams"
        },
        outputs: {
          selectionChange: "selectionChange",
          addNewSelected: "addNewSelected"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 23,
        consts: [["ngSelect", ""], ["appendTo", "body", 3, "clear", "blur", "change", "ngClass", "formControl", "required", "clearable", "appearance", "placeholder", "bindValue", "bindLabel", "items", "loading", "typeahead", "notFoundText", "typeToSearchText", "editableSearchTerm"], [4, "ngIf"], [3, "ngSwitch"], [4, "ngSwitchCase"], ["ng-header-tmp", ""], [1, "ng-option", "ng-option-marked", "add-new", 3, "click"], [3, "name"], ["ng-option-tmp", ""], [1, "smaller-height", "text-ellipsis"], [3, "control"]],
        template: function CuiSearchSelectSsrComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "ng-select", 1, 0);
            i0.ɵɵlistener("clear", function CuiSearchSelectSsrComponent_Template_ng_select_clear_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClear());
            })("blur", function CuiSearchSelectSsrComponent_Template_ng_select_blur_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onBlur());
            })("change", function CuiSearchSelectSsrComponent_Template_ng_select_change_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onChange($event));
            });
            i0.ɵɵtemplate(2, CuiSearchSelectSsrComponent_2_Template, 1, 0, null, 2);
            i0.ɵɵelementContainerStart(3, 3);
            i0.ɵɵtemplate(4, CuiSearchSelectSsrComponent_4_Template, 1, 0, null, 4)(5, CuiSearchSelectSsrComponent_5_Template, 1, 0, null, 4);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, CuiSearchSelectSsrComponent_mat_error_6_Template, 2, 1, "mat-error", 2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(19, _c20, ctx.control.invalid && ctx.control.touched, ctx.required, !!ctx.selectedItem))("formControl", ctx.control)("required", ctx.required)("clearable", !ctx.isLoading && ctx.clearable)("appearance", "outline")("placeholder", ctx.placeholder)("bindValue", ctx.bindValue)("bindLabel", ctx.bindLabel)("items", ctx.items)("loading", ctx.isLoading)("typeahead", ctx.typeAheadSubject$)("notFoundText", ctx.notFoundText)("typeToSearchText", "Enter 2 characters for results")("editableSearchTerm", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.addNewText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitch", ctx.viewType);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "name_and_value");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "default");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.control.invalid && ctx.control.touched);
          }
        },
        dependencies: [MatProgressSpinnerModule, CommonModule, i2.NgClass, i2.NgIf, i2.NgSwitch, i2.NgSwitchCase, ReactiveFormsModule, i1$6.NgControlStatus, i1$6.RequiredValidator, i1$6.FormControlDirective, CuiErrorsComponent, MatFormFieldModule, i4.MatError, NgSelectModule, i5$1.NgSelectComponent, i5$1.NgOptionTemplateDirective, i5$1.NgHeaderTemplateDirective, CuiIconComponent],
        styles: ["[_nghost-%COMP%]{display:block;margin:var(--cui-small-space) 0;letter-spacing:.5px}cui-errors[_ngcontent-%COMP%]{font-size:75%;padding:0 1em}p.add-new[_ngcontent-%COMP%]{align-self:center;width:100%;line-height:40px;cursor:pointer;display:flex;align-items:center;gap:5px}.smaller-height[_ngcontent-%COMP%]{height:20px;line-height:20px}"],
        changeDetection: 0
      });
    }
  }
  return CuiSearchSelectSsrComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiSearchSelectComponent = /*#__PURE__*/(() => {
  class CuiSearchSelectComponent extends FormControlComponentBase {
    constructor(ngControl, cdr) {
      super(ngControl);
      this.cdr = cdr;
      /**
       * Due to limited api of NgSelect this approach was chosen, because You can not directly pass ng-template from parent,
       * that is why viewType property was introduced.
       * viewType needs to be specified in order to render options differently. Currently there only two cases of option views.
       * Here can be added more.
       */
      this.viewType = 'default';
      this.items = [];
      this.bindValue = 'value';
      this.bindLabel = 'name';
      this.customSearchFn = this.defaultSearchFn;
      this.addNewText = '';
      this.clearable = false;
      this.selectionChange = new EventEmitter();
      this.addNewSelected = new EventEmitter();
      this.selectedItem = null;
      this.ngControl.valueAccessor = this;
    }
    writeValue(value) {
      if (this.items.length) {
        const item = this.items.find(item => item.value == value);
        this.onChange(item ? item : null);
        if (this.control) {
          this.cdr.detectChanges();
        }
      }
    }
    registerOnChange() {}
    registerOnTouched() {}
    onChange(item, isAddNewAction) {
      this.selectedItem = item;
      if (this.control && this.control.value !== item?.value) {
        this.control.setValue(item && item.value);
      }
      this.addNewSelected.emit(item === null && isAddNewAction);
      this.selectionChange.emit(item);
    }
    onClear() {
      this.control.markAsDirty();
      this.onChange(null);
    }
    onAddNewClick() {
      this.onChange(null, true);
      this.ngSelect.close();
    }
    defaultSearchFn(term, item) {
      term = term.toLowerCase();
      return item.name.toLowerCase().indexOf(term) > -1 || item.value.toLowerCase() === term;
    }
    static {
      this.ɵfac = function CuiSearchSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiSearchSelectComponent)(i0.ɵɵdirectiveInject(i1$6.NgControl, 10), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiSearchSelectComponent,
        selectors: [["cui-search-select"]],
        viewQuery: function CuiSearchSelectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c19, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ngSelect = _t.first);
          }
        },
        inputs: {
          viewType: "viewType",
          items: "items",
          bindValue: "bindValue",
          bindLabel: "bindLabel",
          customSearchFn: "customSearchFn",
          addNewText: "addNewText",
          clearable: "clearable"
        },
        outputs: {
          selectionChange: "selectionChange",
          addNewSelected: "addNewSelected"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 19,
        consts: [["ngSelect", ""], ["appendTo", "body", 3, "change", "clear", "ngClass", "formControl", "required", "clearable", "appearance", "placeholder", "bindValue", "bindLabel", "items", "searchFn"], [4, "ngIf"], [3, "ngSwitch"], [4, "ngSwitchCase"], ["ng-header-tmp", ""], [1, "ng-option", "ng-option-marked", "add-new", 3, "click"], [3, "name"], ["ng-option-tmp", ""], [1, "smaller-height", "text-ellipsis"], [3, "control"]],
        template: function CuiSearchSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "ng-select", 1, 0);
            i0.ɵɵlistener("change", function CuiSearchSelectComponent_Template_ng_select_change_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onChange($event));
            })("clear", function CuiSearchSelectComponent_Template_ng_select_clear_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClear());
            });
            i0.ɵɵtemplate(2, CuiSearchSelectComponent_2_Template, 1, 0, null, 2);
            i0.ɵɵelementContainerStart(3, 3);
            i0.ɵɵtemplate(4, CuiSearchSelectComponent_4_Template, 1, 0, null, 4)(5, CuiSearchSelectComponent_5_Template, 1, 0, null, 4);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, CuiSearchSelectComponent_mat_error_6_Template, 2, 1, "mat-error", 2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(15, _c20, ctx.control.invalid && ctx.control.touched, ctx.required, !!ctx.selectedItem))("formControl", ctx.control)("required", ctx.required)("clearable", ctx.clearable)("appearance", "outline")("placeholder", ctx.placeholder)("bindValue", ctx.bindValue)("bindLabel", ctx.bindLabel)("items", ctx.items)("searchFn", ctx.customSearchFn);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.addNewText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitch", ctx.viewType);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "name_and_value");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "default");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.control.invalid && ctx.control.touched);
          }
        },
        dependencies: [CommonModule, i2.NgClass, i2.NgIf, i2.NgSwitch, i2.NgSwitchCase, FormsModule, i1$6.NgControlStatus, i1$6.RequiredValidator, ReactiveFormsModule, i1$6.FormControlDirective, CuiErrorsComponent, NgSelectModule, i5$1.NgSelectComponent, i5$1.NgOptionTemplateDirective, i5$1.NgHeaderTemplateDirective, MatSelectModule, i4.MatError, CuiIconComponent],
        styles: ["[_nghost-%COMP%]{display:block;margin:var(--cui-small-space) 0}cui-errors[_ngcontent-%COMP%]{font-size:75%;padding:0 1em}p.add-new[_ngcontent-%COMP%]{align-self:center;width:100%;line-height:40px;cursor:pointer;display:flex;align-items:center;gap:5px}.smaller-height[_ngcontent-%COMP%]{height:20px;line-height:20px}"],
        changeDetection: 0
      });
    }
  }
  return CuiSearchSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiSimpleSelectComponent = /*#__PURE__*/(() => {
  class CuiSimpleSelectComponent extends FormControlComponentBase {
    constructor(ngControl) {
      super(ngControl);
      this.choices = [];
      this.multiple = false;
      this.selectionChange = new EventEmitter();
    }
    set valueAccessor(value) {
      this.controlValueAccessor = value;
    }
    trackBy(index, choice) {
      return choice.value.toString();
    }
    static {
      this.ɵfac = function CuiSimpleSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiSimpleSelectComponent)(i0.ɵɵdirectiveInject(i1$6.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiSimpleSelectComponent,
        selectors: [["cui-simple-select"]],
        viewQuery: function CuiSimpleSelectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatSelect, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.valueAccessor = _t.first);
          }
        },
        inputs: {
          choices: "choices",
          multiple: "multiple"
        },
        outputs: {
          selectionChange: "selectionChange"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 7,
        consts: [[3, "selectionChange", "formControl", "required", "placeholder", "multiple"], [3, "value"], [4, "ngIf"], [3, "control"]],
        template: function CuiSimpleSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field")(1, "mat-label");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "mat-select", 0);
            i0.ɵɵlistener("selectionChange", function CuiSimpleSelectComponent_Template_mat_select_selectionChange_3_listener($event) {
              return ctx.selectionChange.emit($event);
            });
            i0.ɵɵrepeaterCreate(4, CuiSimpleSelectComponent_For_5_Template, 2, 2, "mat-option", 1, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, CuiSimpleSelectComponent_mat_hint_6_Template, 2, 1, "mat-hint", 2)(7, CuiSimpleSelectComponent_mat_error_7_Template, 2, 1, "mat-error", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formControl", ctx.control)("required", ctx.required)("placeholder", ctx.placeholder)("multiple", ctx.multiple);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.choices);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.hint);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.control.invalid);
          }
        },
        dependencies: [CommonModule, i2.NgIf, ReactiveFormsModule, i1$6.NgControlStatus, i1$6.RequiredValidator, i1$6.FormControlDirective, MatFormFieldModule, i4.MatFormField, i4.MatLabel, i4.MatHint, i4.MatError, MatSelectModule, i4$4.MatSelect, i5$2.MatOption, CuiErrorsComponent],
        styles: ["[_nghost-%COMP%]{display:block;margin:var(--cui-small-space) 0}mat-form-field[_ngcontent-%COMP%]{width:100%}mat-select[_ngcontent-%COMP%]{display:flex;align-items:center;font-family:var(--cui-font-family)}mat-option[_ngcontent-%COMP%]{font-family:var(--cui-font-family)}.mat-mdc-select[_ngcontent-%COMP%]{color:var(--cui-color-label-text-color)}.mat-mdc-select.mat-mdc-select-disabled[_ngcontent-%COMP%]{color:var(--cui-color-label-disabled-text-color)}"],
        changeDetection: 0
      });
    }
  }
  return CuiSimpleSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTextAreaComponent = /*#__PURE__*/(() => {
  class CuiTextAreaComponent extends FormControlComponentBase {
    constructor(ngControl) {
      super(ngControl);
      this.rows = 10;
    }
    set valueAccessor(value) {
      this.controlValueAccessor = value;
    }
    focus() {
      this.textareaElement.nativeElement.focus();
    }
    static {
      this.ɵfac = function CuiTextAreaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTextAreaComponent)(i0.ɵɵdirectiveInject(i1$6.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTextAreaComponent,
        selectors: [["cui-textarea"]],
        viewQuery: function CuiTextAreaComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c21, 5);
            i0.ɵɵviewQuery(DefaultValueAccessor, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textareaElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.valueAccessor = _t.first);
          }
        },
        inputs: {
          rows: "rows"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 7,
        consts: [["textareaElement", ""], [1, "cui-textarea"], ["matInput", "", 3, "formControl", "required", "placeholder", "rows"], [4, "ngIf"], [3, "control"]],
        template: function CuiTextAreaComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field", 1)(1, "mat-label");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "textarea", 2, 0);
            i0.ɵɵtemplate(5, CuiTextAreaComponent_mat_hint_5_Template, 2, 1, "mat-hint", 3)(6, CuiTextAreaComponent_mat_error_6_Template, 2, 1, "mat-error", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formControl", ctx.control)("required", ctx.required)("placeholder", ctx.placeholder)("rows", ctx.rows);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.hint);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.control.invalid);
          }
        },
        dependencies: [CommonModule, i2.NgIf, FormsModule, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.RequiredValidator, ReactiveFormsModule, i1$6.FormControlDirective, MatInputModule, i5.MatInput, i4.MatFormField, i4.MatLabel, i4.MatHint, i4.MatError, MatFormFieldModule, CuiErrorsComponent],
        styles: ["[_nghost-%COMP%]{display:block;margin:var(--cui-small-space) 0}mat-form-field[_ngcontent-%COMP%]{width:100%;min-height:100px}"],
        changeDetection: 0
      });
    }
  }
  return CuiTextAreaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTimepickerComponent = /*#__PURE__*/(() => {
  class CuiTimepickerComponent extends FormControlComponentBase {
    set minTime(value) {
      this.currentMinTime = value;
      if (this.control) {
        if (this.currentMinValidator) {
          this.control.removeValidators([this.currentMinValidator]);
          this.currentMinValidator = null;
        }
        if (value && value !== '') {
          this.currentMinValidator = CuiValidators.timeMin(value);
          this.control.addValidators([this.currentMinValidator]);
        }
        this.control.updateValueAndValidity();
      }
    }
    set maxTime(value) {
      this.currentMaxTime = value;
      if (this.control) {
        if (this.currentMaxValidator) {
          this.control.removeValidators([this.currentMaxValidator]);
          this.currentMaxValidator = null;
        }
        if (value && value != '') {
          this.currentMaxValidator = CuiValidators.timeMax(value);
          this.control.addValidators([this.currentMaxValidator]);
        }
        this.control.updateValueAndValidity();
      }
    }
    constructor(ngControl) {
      super(ngControl);
      this.currentMinTime = null;
      this.currentMinValidator = null;
      this.currentMaxTime = null;
      this.currentMaxValidator = null;
    }
    ngOnInit() {
      if (this.control) {
        if (this.currentMinTime && this.currentMinTime !== '') {
          this.currentMinValidator = CuiValidators.timeMin(this.currentMinTime);
          this.control.addValidators([this.currentMinValidator]);
        }
        if (this.currentMaxTime && this.currentMaxTime !== '') {
          this.currentMaxValidator = CuiValidators.timeMax(this.currentMaxTime);
          this.control.addValidators([this.currentMaxValidator]);
        }
        this.control.updateValueAndValidity();
      }
    }
    getLabel() {
      if (this.required || this.control.hasValidator(Validators.required)) {
        return `${this.label}*`;
      } else return this.label;
    }
    set valueAccessor(value) {
      this.controlValueAccessor = value;
    }
    static {
      this.ɵfac = function CuiTimepickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTimepickerComponent)(i0.ɵɵdirectiveInject(i1$6.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTimepickerComponent,
        selectors: [["cui-time-picker"]],
        viewQuery: function CuiTimepickerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(DefaultValueAccessor, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.valueAccessor = _t.first);
          }
        },
        inputs: {
          minTime: "minTime",
          maxTime: "maxTime"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 6,
        vars: 10,
        consts: [[1, "form-input", 3, "ngClass"], ["type", "time", 3, "ngClass", "formControl", "required"], [1, "placeholder"], [3, "control", "hint", 4, "ngIf"], [3, "control", "hint"]],
        template: function CuiTimepickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "label");
            i0.ɵɵelement(2, "input", 1);
            i0.ɵɵelementStart(3, "span", 2);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, CuiTimepickerComponent_cui_errors_5_Template, 1, 2, "cui-errors", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c22, !!ctx.control.invalid && ctx.control.touched));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c23, !!ctx.control.value))("formControl", ctx.control)("required", ctx.required);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getLabel(), " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.control.invalid && ctx.control.touched);
          }
        },
        dependencies: [CommonModule, i2.NgClass, i2.NgIf, FormsModule, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.RequiredValidator, ReactiveFormsModule, i1$6.FormControlDirective, MatInputModule, MatFormFieldModule, CuiErrorsComponent],
        styles: [".form-input[_ngcontent-%COMP%]{min-width:9rem}.form-input[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{position:relative;display:block;width:100%;min-height:var(--mat-form-field-container-height)}.form-input[_ngcontent-%COMP%]   .placeholder[_ngcontent-%COMP%]{position:absolute;display:block;top:.75rem;margin:0 0 0 .825rem;padding:0 .125rem;font-family:var(--cui-font-placeholder-font-family);font-size:var(--cui-font-placeholder-size);color:var(--cui-font-placeholder-font-color);letter-spacing:.2px;cursor:text;transition:all .2s ease-in-out;background-color:var(--cui-color-page-bg)}.form-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{height:var(--mat-form-field-container-height);width:100%;margin:0;padding:0 .875rem;background-color:var(--cui-color-page-bg);outline:0;border:1px solid var(--cui-color-input-outline-color);border-radius:.3125rem;color:var(--cui-color-body-text);font:inherit;cursor:text;transition:border-color .2s ease-in-out}.form-input[_ngcontent-%COMP%]   .has-value[_ngcontent-%COMP%] + .placeholder[_ngcontent-%COMP%]{top:-.5rem;font-size:.6rem}.form-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:hover{border-color:var(--cui-color-icon)}.form-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{padding:0 .8125rem 0 .875rem;border:2px solid var(--cui-color-primary)}.form-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus + .placeholder[_ngcontent-%COMP%]{top:-.5rem;font-size:.6rem;color:var(--cui-color-primary)}.form-input[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]::-webkit-calendar-picker-indicator{scale:1.4;cursor:pointer}.form-input[_ngcontent-%COMP%]   cui-errors[_ngcontent-%COMP%]{margin:0 0 0 .825rem;font-size:.65rem;color:var(--color-danger)}.form-input.has-error[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border-color:var(--color-danger);color:var(--color-danger);margin:0 0 -.25rem}.form-input.has-error[_ngcontent-%COMP%]   .placeholder[_ngcontent-%COMP%]{color:var(--color-danger)}[_nghost-%COMP%]{display:block;margin:var(--cui-small-space) 0}"],
        changeDetection: 0
      });
    }
  }
  return CuiTimepickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiIconLinkComponent = /*#__PURE__*/(() => {
  class CuiIconLinkComponent {
    constructor() {
      this.name = '';
      this.url = '';
      this.target = '_self';
      this.disabled = false;
      this.clicked = new EventEmitter();
    }
    static {
      this.ɵfac = function CuiIconLinkComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiIconLinkComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiIconLinkComponent,
        selectors: [["cui-icon-link"]],
        inputs: {
          name: "name",
          url: "url",
          target: "target",
          disabled: "disabled"
        },
        outputs: {
          clicked: "clicked"
        },
        decls: 2,
        vars: 4,
        consts: [["mat-icon-button", "", 3, "click", "href", "target", "disabled"], [4, "ngIf"]],
        template: function CuiIconLinkComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "a", 0);
            i0.ɵɵlistener("click", function CuiIconLinkComponent_Template_a_click_0_listener() {
              return ctx.clicked.emit();
            });
            i0.ɵɵtemplate(1, CuiIconLinkComponent_mat_icon_1_Template, 2, 1, "mat-icon", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("href", ctx.url, i0.ɵɵsanitizeUrl)("target", ctx.target)("disabled", ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.name);
          }
        },
        dependencies: [CommonModule, i2.NgIf, MatIconModule, i2$1.MatIcon, MatButtonModule, i1.MatIconAnchor],
        styles: ["[_nghost-%COMP%]{display:flex}"],
        changeDetection: 0
      });
    }
  }
  return CuiIconLinkComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const cuiTheme = themeBalham.withParams({
  // Header
  headerBackgroundColor: getCssVariableValue('--color-gray-very-light'),
  headerTextColor: getCssVariableValue('--cui-color-titles'),
  headerFontFamily: getCssVariableValue('--cui-font-h4-font-family'),
  headerFontSize: getCssVariableValue('--cui-font-h4-size'),
  headerHeight: '2.25rem',
  headerFontWeight: getCssVariableValue('--cui-font-h4-weight'),
  headerCellHoverBackgroundColor: getCssVariableValue('--cui-color-hover'),
  // Grid and Rows
  spacing: '0.313rem',
  rowHeight: '1.875rem',
  selectedRowBackgroundColor: getCssVariableValue('--cui-color-active'),
  rowHoverColor: getCssVariableValue('--cui-color-hover'),
  listItemHeight: getCssVariableValue('--cui-font-p-line-height'),
  foregroundColor: getCssVariableValue('--cui-color-breadcrumbs'),
  backgroundColor: getCssVariableValue('--cui-color-card-bg'),
  cellTextColor: getCssVariableValue('--cui-color-breadcrumbs'),
  fontFamily: getCssVariableValue('--cui-font-h6-font-family'),
  fontSize: getCssVariableValue('--cui-font-h6-size'),
  checkboxCheckedShapeColor: getCssVariableValue('--cui-color-primary'),
  tabSelectedBorderColor: getCssVariableValue('--cui-color-links'),
  menuBackgroundColor: getCssVariableValue('--cui-color-card-bg'),
  borderRadius: getCssVariableValue('--cui-border-radius'),
  menuShadow: getCssVariableValue('--cui-shadow'),
  inputFocusBorder: getCssVariableValue('--cui-color-links')
});
let CuiLibraryModule = /*#__PURE__*/(() => {
  class CuiLibraryModule {
    // Create this static method in the library module.
    static forRoot(config) {
      provideGlobalGridOptions({
        theme: cuiTheme,
        rowSelection: {
          mode: 'singleRow',
          checkboxes: false
        }
      });
      return {
        ngModule: CuiLibraryModule,
        providers: [{
          provide: Configurations,
          useValue: config
        }, {
          provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
          useValue: {
            appearance: 'outline'
          }
        }, {
          provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
          useValue: {
            hideMultipleSelectionIndicator: true,
            hideSingleSelectionIndicator: true
          }
        }]
      };
    }
    static {
      this.ɵfac = function CuiLibraryModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiLibraryModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CuiLibraryModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return CuiLibraryModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiListItemComponent = /*#__PURE__*/(() => {
  class CuiListItemComponent {
    constructor() {
      this.textIfEmpty = '-';
    }
    static {
      this.ɵfac = function CuiListItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiListItemComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiListItemComponent,
        selectors: [["cui-list-item"]],
        inputs: {
          title: "title",
          textIfEmpty: "textIfEmpty"
        },
        ngContentSelectors: _c3,
        decls: 5,
        vars: 2,
        consts: [["ref", ""], ["class", "item-text", 4, "ngIf"], [1, "item-text"], [4, "ngIf"]],
        template: function CuiListItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, CuiListItemComponent_label_0_Template, 2, 1, "label", 1);
            i0.ɵɵelementStart(1, "div", 2, 0);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, CuiListItemComponent_span_4_Template, 2, 1, "span", 3);
          }
          if (rf & 2) {
            const ref_r2 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.title);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", (!ref_r2.innerHTML.trim() || ref_r2.innerHTML.trim().startsWith("<!--bindings=")) && !ref_r2.children.length);
          }
        },
        dependencies: [CommonModule, i2.NgIf],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;align-items:center;gap:var(--cui-large-space);padding:var(--cui-small-space) 0;border-bottom:1px solid var(--cui-color-border)}.item-text[_ngcontent-%COMP%]{word-break:break-word;text-align:end}label.item-text[_ngcontent-%COMP%]{text-align:start}"],
        changeDetection: 0
      });
    }
  }
  return CuiListItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiListComponent = /*#__PURE__*/(() => {
  class CuiListComponent {
    static {
      this.ɵfac = function CuiListComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiListComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiListComponent,
        selectors: [["cui-list"]],
        ngContentSelectors: _c3,
        decls: 1,
        vars: 0,
        template: function CuiListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;align-items:stretch}"],
        changeDetection: 0
      });
    }
  }
  return CuiListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiListModule = /*#__PURE__*/(() => {
  class CuiListModule {
    static {
      this.ɵfac = function CuiListModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiListModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CuiListModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CuiListItemComponent]
      });
    }
  }
  return CuiListModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiMenuComponent = /*#__PURE__*/(() => {
  class CuiMenuComponent {
    constructor() {
      this.isLoading = false;
    }
    static {
      this.ɵfac = function CuiMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiMenuComponent,
        selectors: [["cui-menu"]],
        inputs: {
          isLoading: "isLoading"
        },
        ngContentSelectors: _c3,
        decls: 2,
        vars: 2,
        consts: [[4, "ngIf"], ["mode", "indeterminate", 1, "absolute-centered", 3, "diameter"]],
        template: function CuiMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, CuiMenuComponent_div_0_Template, 2, 0, "div", 0)(1, CuiMenuComponent_div_1_Template, 2, 1, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.isLoading);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isLoading);
          }
        },
        dependencies: [MatProgressSpinnerModule, i3$1.MatProgressSpinner, CommonModule, i2.NgIf],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;align-items:stretch;height:auto;max-height:100%;overflow-y:auto;position:relative;min-height:500px}.absolute-centered[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}"],
        changeDetection: 0
      });
    }
  }
  return CuiMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiMenuGroupComponent = /*#__PURE__*/(() => {
  class CuiMenuGroupComponent {
    constructor() {
      this.showCloseBtn = false;
      this.close = new EventEmitter();
    }
    static {
      this.ɵfac = function CuiMenuGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiMenuGroupComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiMenuGroupComponent,
        selectors: [["cui-menu-group"]],
        inputs: {
          title: "title",
          template: "template",
          templateContext: "templateContext",
          showCloseBtn: "showCloseBtn"
        },
        outputs: {
          close: "close"
        },
        ngContentSelectors: _c3,
        decls: 8,
        vars: 4,
        consts: [[1, "flex-between"], [1, "flex-column"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["aria-label", "close", 3, "name", "clicked", 4, "ngIf"], [1, "body"], ["aria-label", "close", 3, "clicked", "name"]],
        template: function CuiMenuGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, CuiMenuGroupComponent_ng_container_4_Template, 1, 0, "ng-container", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, CuiMenuGroupComponent_cui_icon_btn_5_Template, 1, 1, "cui-icon-btn", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 4);
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", ctx.templateContext);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showCloseBtn);
          }
        },
        dependencies: [CommonModule, i2.NgIf, i2.NgTemplateOutlet, CuiIconButtonComponent, MatButtonModule],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;align-items:stretch;margin:var(--cui-medium-space) var(--cui-large-space)}[_nghost-%COMP%]   .body[_ngcontent-%COMP%]{margin-top:var(--cui-medium-space);border-radius:var(--cui-border-radius);box-shadow:var(--cui-shadow)}[_nghost-%COMP%]   .flex-between[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;align-items:center}[_nghost-%COMP%]   .flex-between[_ngcontent-%COMP%]   .flex-column[_ngcontent-%COMP%]{display:flex;flex-direction:column;overflow:hidden}[_nghost-%COMP%]   .flex-between[_ngcontent-%COMP%]   .flex-column[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}"],
        changeDetection: 0
      });
    }
  }
  return CuiMenuGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiMenuItemComponent = /*#__PURE__*/(() => {
  class CuiMenuItemComponent {
    constructor() {
      this.disabled = false;
      this.iconTooltip = '';
      this.itemTooltip = '';
    }
    static {
      this.ɵfac = function CuiMenuItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiMenuItemComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiMenuItemComponent,
        selectors: [["cui-menu-item"]],
        hostVars: 2,
        hostBindings: function CuiMenuItemComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("disabled", ctx.disabled);
          }
        },
        inputs: {
          title: "title",
          link: "link",
          matIcon: "matIcon",
          disabled: "disabled",
          template: "template",
          templateContext: "templateContext",
          iconTooltip: "iconTooltip",
          itemTooltip: "itemTooltip"
        },
        decls: 6,
        vars: 13,
        consts: [["routerLinkActive", "active", 3, "matTooltip", "routerLink", "tabindex", "ngClass"], [1, "link-text"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "name", "tooltipText"]],
        template: function CuiMenuItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "a", 0)(1, "span")(2, "span", 1);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, CuiMenuItemComponent_ng_container_4_Template, 1, 0, "ng-container", 2);
            i0.ɵɵelement(5, "cui-icon", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_8_0;
            i0.ɵɵproperty("matTooltip", ctx.itemTooltip)("routerLink", ctx.link)("tabindex", ctx.disabled ? -1 : 0)("ngClass", i0.ɵɵpureFunction1(11, _c24, ctx.disabled));
            i0.ɵɵadvance();
            i0.ɵɵclassMap("link-wrapper " + (ctx.matIcon || ""));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", ctx.templateContext);
            i0.ɵɵadvance();
            i0.ɵɵproperty("name", (tmp_8_0 = ctx.matIcon) !== null && tmp_8_0 !== undefined ? tmp_8_0 : "chevron_right")("tooltipText", ctx.iconTooltip);
          }
        },
        dependencies: [CuiIconComponent, RouterModule, i1$1.RouterLink, i1$1.RouterLinkActive, CommonModule, i2.NgClass, i2.NgTemplateOutlet, MatTooltip],
        styles: ["[_nghost-%COMP%]:first-child{border-top-left-radius:var(--cui-border-radius);border-top-right-radius:var(--cui-border-radius)}[_nghost-%COMP%]:first-child   a[_ngcontent-%COMP%]{border-top-left-radius:var(--cui-border-radius);border-top-right-radius:var(--cui-border-radius)}[_nghost-%COMP%]:last-child{border-bottom-left-radius:var(--cui-border-radius);border-bottom-right-radius:var(--cui-border-radius)}[_nghost-%COMP%]:last-child   a[_ngcontent-%COMP%]{border-bottom-left-radius:var(--cui-border-radius);border-bottom-right-radius:var(--cui-border-radius)}[_nghost-%COMP%]:last-child   a[_ngcontent-%COMP%]   .link-wrapper[_ngcontent-%COMP%]{border-bottom:none}.disabled[_nghost-%COMP%]:active{pointer-events:none}a[_ngcontent-%COMP%]{cursor:pointer;display:block;font-weight:var(--cui-font-weight-medium);text-decoration:none;color:var(--cui-color-breadcrumbs);padding:0 var(--cui-medium-space);background-color:var(--cui-color-card-bg);transition:background-color .2s,color .2s}a[_ngcontent-%COMP%]:hover{background-color:var(--cui-color-hover)}a.active[_ngcontent-%COMP%]{background-color:var(--cui-color-active);color:var(--cui-color-titles)}a.active[_ngcontent-%COMP%]   cui-icon[_ngcontent-%COMP%]{transform:rotate(180deg)}a.item-disabled[_ngcontent-%COMP%]{cursor:default;background-color:#d6d6d654;color:#808080b5}a.item-disabled[_ngcontent-%COMP%]:active{pointer-events:none}a.item-disabled[_ngcontent-%COMP%]   .link-wrapper[_ngcontent-%COMP%]   .link-text[_ngcontent-%COMP%]{color:#808080b5}.link-wrapper[_ngcontent-%COMP%]{padding:var(--cui-small-space) 1.5rem var(--cui-small-space) 0;border-bottom:1px solid var(--cui-color-border);display:flex;justify-content:space-around;flex-direction:column;position:relative}.link-wrapper[_ngcontent-%COMP%]   cui-icon[_ngcontent-%COMP%]{position:absolute;right:0}.link-wrapper.delete[_ngcontent-%COMP%]   span.link-text[_ngcontent-%COMP%]{color:var(--color-danger)}.link-text[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}"],
        changeDetection: 0
      });
    }
  }
  return CuiMenuItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiMenuModule = /*#__PURE__*/(() => {
  class CuiMenuModule {
    static {
      this.ɵfac = function CuiMenuModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiMenuModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CuiMenuModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CuiMenuComponent, CuiMenuGroupComponent, CuiMenuItemComponent]
      });
    }
  }
  return CuiMenuModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiPageTitleComponent = /*#__PURE__*/(() => {
  class CuiPageTitleComponent {
    constructor() {
      this.showClose = true;
      this.close = new EventEmitter();
    }
    static {
      this.ɵfac = function CuiPageTitleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiPageTitleComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiPageTitleComponent,
        selectors: [["cui-page-title"]],
        inputs: {
          title: "title",
          showClose: "showClose"
        },
        outputs: {
          close: "close"
        },
        decls: 3,
        vars: 2,
        consts: [["aria-label", "close", 3, "name", "clicked", 4, "ngIf"], ["aria-label", "close", 3, "clicked", "name"]],
        template: function CuiPageTitleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h2");
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, CuiPageTitleComponent_cui_icon_btn_2_Template, 1, 1, "cui-icon-btn", 0);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showClose);
          }
        },
        dependencies: [CommonModule, i2.NgIf, CuiIconButtonComponent, MatButtonModule],
        styles: ["[_nghost-%COMP%]{display:flex;width:100%;justify-content:space-between;align-items:center}h2[_ngcontent-%COMP%]{margin-bottom:var(--cui-medium-space)}"],
        changeDetection: 0
      });
    }
  }
  return CuiPageTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AppContainerService = /*#__PURE__*/(() => {
  class AppContainerService {
    constructor(media) {
      this.media = media;
      this._mobileQueryListener = e => this._isMobileView.next(e.matches);
      this.mediaMatcher = media.matchMedia('(max-width: 600px)');
      this.mediaMatcher.addEventListener('change', this._mobileQueryListener);
      this._isMobileView = new BehaviorSubject(this.isMobileView);
      this.isMobileView$ = this._isMobileView.asObservable();
    }
    /**
     * Use to get exact value at that time.
     */
    get isMobileView() {
      return this.mediaMatcher.matches;
    }
    static {
      this.ɵfac = function AppContainerService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AppContainerService)(i0.ɵɵinject(i1$7.MediaMatcher));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AppContainerService,
        factory: AppContainerService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AppContainerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SideNavService = /*#__PURE__*/(() => {
  class SideNavService {
    constructor(appService) {
      this.appService = appService;
      this.openedSideNavItemId = new BehaviorSubject(null);
      this.openedSideNavItemId$ = this.openedSideNavItemId.asObservable();
      this.sideNavVisibilityState = new BehaviorSubject(this.prefersExpandedSideNav);
      this.sideNavVisibilityState$ = this.sideNavVisibilityState.asObservable();
    }
    onNavItemExpandChange(navId, isExpanded) {
      this.openedSideNavItemId.next(isExpanded ? navId : null);
    }
    onSideNavVisibilityChange(isExpanded) {
      this.saveToLocalStorage(isExpanded);
      this.sideNavVisibilityState.next(isExpanded);
    }
    saveToLocalStorage(isOpened) {
      localStorage.setItem('prefersOpenSideNav', JSON.stringify(isOpened));
    }
    get prefersExpandedSideNav() {
      if (this.appService.isMobileView) return false;
      return JSON.parse(localStorage.getItem('prefersOpenSideNav') ?? 'false');
    }
    static {
      this.ɵfac = function SideNavService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SideNavService)(i0.ɵɵinject(AppContainerService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SideNavService,
        factory: SideNavService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SideNavService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiSideNavComponent = /*#__PURE__*/(() => {
  class CuiSideNavComponent {
    constructor(elementRef, sideNavService, appContainerService) {
      this.elementRef = elementRef;
      this.sideNavService = sideNavService;
      this.appContainerService = appContainerService;
      this.id = 'highlander';
      this.sidenavWidth = '3.125rem';
      this.isNavExpanded$ = this.sideNavService.sideNavVisibilityState$.pipe(tap(isOpen => {
        this.isOpened = isOpen;
        if (this.appContainerService.isMobileView && this.drawer) {
          isOpen ? this.drawer.open('program') : this.drawer.close();
        }
        isOpen ? this.increase() : this.decrease(this.appContainerService.isMobileView);
      }));
      this.isMobileView$ = this.appContainerService.isMobileView$.pipe(tap(isMobile => {
        if (isMobile) {
          this.elementRef.nativeElement.classList.add('mobile-view');
          this.decrease(true);
        } else {
          this.elementRef.nativeElement.classList.remove('mobile-view');
          if (this.isOpened) {
            this.increase();
          } else {
            this.decrease(false);
          }
        }
      }));
      this.isOpened = false;
    }
    onClosed() {
      this.drawer.close();
      this.sideNavService.onSideNavVisibilityChange(false);
    }
    changeNavState(isMobileView, isOpen) {
      this.isOpened ? this.decrease(isMobileView) : this.increase();
      this.sideNavService.onSideNavVisibilityChange(isOpen);
    }
    increase() {
      this.sidenavWidth = '18.75rem';
      this.elementRef.nativeElement.style.width = this.sidenavWidth;
    }
    decrease(isMobileView) {
      this.sidenavWidth = isMobileView ? '0px' : '3.125rem';
      this.elementRef.nativeElement.style.width = this.sidenavWidth;
    }
    static {
      this.ɵfac = function CuiSideNavComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiSideNavComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(SideNavService), i0.ɵɵdirectiveInject(AppContainerService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiSideNavComponent,
        selectors: [["cui-side-nav-container"]],
        viewQuery: function CuiSideNavComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c25, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.drawer = _t.first);
          }
        },
        hostVars: 1,
        hostBindings: function CuiSideNavComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
          }
        },
        ngContentSelectors: _c27,
        decls: 3,
        vars: 8,
        consts: [["drawer", ""], ["class", "cui-side-nav-container", 3, "hasBackdrop", "ngClass", "backdropClick", 4, "ngIf"], [1, "cui-side-nav-container", 3, "backdropClick", "hasBackdrop", "ngClass"], [3, "closed", "mode", "opened", "disableClose", "ngStyle"], [1, "top"], [1, "body"], [1, "bottom"], [1, "footer"], ["class", "handle expand-collapse", 3, "matTooltipDisabled", "matTooltip", "matTooltipPosition", "ngClass", "click", 4, "ngIf"], [1, "handle", "expand-collapse", 3, "click", "matTooltipDisabled", "matTooltip", "matTooltipPosition", "ngClass"], [3, "name"]],
        template: function CuiSideNavComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c26);
            i0.ɵɵtemplate(0, CuiSideNavComponent_mat_drawer_container_0_Template, 10, 11, "mat-drawer-container", 1);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction2(5, _c28, i0.ɵɵpipeBind1(1, 1, ctx.isNavExpanded$), i0.ɵɵpipeBind1(2, 3, ctx.isMobileView$)));
          }
        },
        dependencies: [CommonModule, i2.NgClass, i2.NgIf, i2.NgStyle, i2.AsyncPipe, MatSidenavModule, i4$5.MatDrawer, i4$5.MatDrawerContainer, CuiIconComponent, MatTooltipModule, i3.MatTooltip],
        styles: ["[_nghost-%COMP%]{grid-area:side-nav;transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:width}.mobile-view[_nghost-%COMP%]{top:2rem;right:0;left:0;bottom:0;position:absolute}.mobile-view[_nghost-%COMP%]   mat-drawer-container[_ngcontent-%COMP%]{background-color:inherit}.mobile-view[_nghost-%COMP%]   .full-width[_ngcontent-%COMP%]{width:100vw}.mat-drawer-transition[_ngcontent-%COMP%]   mat-drawer.mat-drawer[_ngcontent-%COMP%]{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:width}mat-drawer[_ngcontent-%COMP%]   .top[_ngcontent-%COMP%]{overflow:auto}mat-drawer[_ngcontent-%COMP%]   .bottom[_ngcontent-%COMP%]{box-shadow:0 0 1px var(--cui-color-titles)}mat-drawer-container[_ngcontent-%COMP%]{height:100%;width:100%;display:block;background-color:inherit}.handle[_ngcontent-%COMP%]{cursor:pointer;height:2.5rem;padding:0 var(--cui-large-space);display:flex;border:none;justify-content:space-between;font-family:var(--cui-font-family);font-size:var(--cui-font-h5-size);text-decoration:none;align-items:center;color:var(--cui-color-breadcrumbs);font-weight:var(--cui-font-weight-medium);transition:background-color linear .2s,color linear .2s}.handle.collapsed-view[_ngcontent-%COMP%]{display:flex;justify-content:center;width:100%;padding:0}.handle.collapsed-view[_ngcontent-%COMP%]   cui-icon[_ngcontent-%COMP%]{margin:0;transform:none}.handle[_ngcontent-%COMP%]   cui-icon[_ngcontent-%COMP%]{transform:rotate(180deg);transition:transform linear .2s}a.expand-collapse[_ngcontent-%COMP%]{display:flex;width:inherit;justify-content:center}.cui-side-nav-container[_ngcontent-%COMP%]{z-index:999}"],
        changeDetection: 0
      });
    }
  }
  return CuiSideNavComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiSideNavExpandComponent = /*#__PURE__*/(() => {
  class CuiSideNavExpandComponent extends SubscribingBase {
    set navExpandNodes(nodes) {
      this.dataSource = new ArrayDataSource(nodes);
      this.nodes = nodes;
      if (nodes[0].children) {
        nodes[0].children.forEach(node => {
          if (this.route.routerState.snapshot.url.includes(node.url)) {
            this.treeControl.expand(nodes[0]);
          }
        });
      }
    }
    constructor(route, navService, appService, cdr) {
      super();
      this.route = route;
      this.navService = navService;
      this.appService = appService;
      this.cdr = cdr;
      this.linkClicked = new EventEmitter();
      this.treeControl = new NestedTreeControl(node => node.children);
      this.navExpanded$ = this.navService.sideNavVisibilityState$;
      this.nodes = [];
      this.hasChild = (_, node) => !!node.children && node.children.length > 0;
    }
    ngOnInit() {
      this.subscribe(this.navService.openedSideNavItemId$, id => {
        if (id !== this.nodes[0].id) {
          this.treeControl.collapseAll();
          this.cdr.detectChanges();
        }
      });
    }
    onExpandClick(node, isExpanded) {
      if (!node.parentId) {
        this.navService.onNavItemExpandChange(node.id, isExpanded);
      }
    }
    onLinkClick({
      url,
      customAction
    }) {
      this.linkClicked.emit({
        url,
        customAction
      });
      if (this.appService.isMobileView) this.navService.onSideNavVisibilityChange(false);
    }
    static {
      this.ɵfac = function CuiSideNavExpandComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiSideNavExpandComponent)(i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(SideNavService), i0.ɵɵdirectiveInject(AppContainerService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiSideNavExpandComponent,
        selectors: [["cui-side-nav-expand"]],
        inputs: {
          navExpandNodes: "navExpandNodes"
        },
        outputs: {
          linkClicked: "linkClicked"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 5,
        consts: [["elem", ""], [4, "ngIf"], [3, "dataSource", "treeControl", 4, "ngIf"], [3, "dataSource", "treeControl"], ["class", "tree-node", 4, "cdkTreeNodeDef"], ["class", "tree-node", 4, "cdkTreeNodeDef", "cdkTreeNodeDefWhen"], [1, "tree-node"], ["class", "sub-title", 4, "ngIf"], ["routerLinkActive", "active", 1, "handle", "no-wrap", 3, "click", "matTooltipDisabled", "matTooltip", "matTooltipPosition", "routerLink", "ngClass"], ["routerLinkActive", "active", 3, "isActive", "name"], [1, "sub-title"], ["routerLinkActive", "active", "cdkTreeNodeToggle", "", 1, "handle", "handle-expand", "no-wrap", 3, "click", "matTooltipDisabled", "matTooltip", "matTooltipPosition", "ngClass"], [1, "no-wrap", "flex-center"], [3, "name", "isActive"], ["class", "expand-icon", 3, "name", 4, "ngIf"], [3, "ngClass"], ["cdkTreeNodeOutlet", ""], [1, "expand-icon", 3, "name"]],
        template: function CuiSideNavExpandComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CuiSideNavExpandComponent_ng_container_0_Template, 2, 1, "ng-container", 1);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction1(3, _c31, i0.ɵɵpipeBind1(1, 1, ctx.navExpanded$)));
          }
        },
        dependencies: [CommonModule, i2.NgClass, i2.NgIf, i2.AsyncPipe, CuiIconComponent, RouterModule, i1$1.RouterLink, i1$1.RouterLinkActive, CdkTreeModule, i5$3.CdkNestedTreeNode, i5$3.CdkTreeNodeDef, i5$3.CdkTreeNodeToggle, i5$3.CdkTree, i5$3.CdkTreeNodeOutlet, MatTooltipModule, i3.MatTooltip],
        styles: ["[_nghost-%COMP%]{display:flex;justify-content:stretch;font-weight:var(--cui-font-weight-medium)}.active[_nghost-%COMP%]   .handle[_ngcontent-%COMP%]{background-color:var(--cui-color-active);color:var(--cui-color-titles)}.active[_nghost-%COMP%]   .handle[_ngcontent-%COMP%]:hover{background-color:var(--cui-color-hover);color:var(--cui-color-titles)}.handle[_ngcontent-%COMP%]:hover{background-color:var(--cui-color-hover);color:var(--cui-color-titles)}.handle[_ngcontent-%COMP%]{cursor:pointer;height:2.5rem;padding:0 var(--cui-large-space);display:flex;border:none;width:100%;font-family:var(--cui-font-family);font-size:var(--cui-font-h5-size);text-decoration:none;align-items:center;color:var(--cui-color-breadcrumbs);font-weight:var(--cui-font-weight-medium);transition:background-color linear .2s,color linear .2s}.handle.collapsed-view[_ngcontent-%COMP%]{display:flex;justify-content:center;width:100%;padding:0}.handle.collapsed-view[_ngcontent-%COMP%]   cui-icon[_ngcontent-%COMP%]{margin:0}.no-wrap[_ngcontent-%COMP%]{overflow:hidden}.no-wrap[_ngcontent-%COMP%]   div[_ngcontent-%COMP%], .no-wrap[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}cui-icon[_ngcontent-%COMP%]{color:var(--cui-color-primary);margin-right:var(--cui-medium-space)}a[href].active[_ngcontent-%COMP%]{color:var(--cui-color-primary);background-color:var(--cui-color-active)}", ".tree-invisible[_ngcontent-%COMP%]{display:none}.tree-node[_ngcontent-%COMP%]{display:block;overflow:hidden}.tree-node[_ngcontent-%COMP%]   .tree-node[_ngcontent-%COMP%]{padding-left:40px}cdk-tree[_ngcontent-%COMP%]{width:100%}.handle[_ngcontent-%COMP%]{width:inherit}.handle-expand[_ngcontent-%COMP%]{justify-content:space-between}.handle-expand[_ngcontent-%COMP%]   cui-icon.expand-icon[_ngcontent-%COMP%]{margin-right:0;margin-left:var(--cui-medium-space);font-size:1.5rem;height:1.5rem;width:1.5rem;min-width:1.5rem;min-height:1.5rem}.collapsed-view[_ngcontent-%COMP%]{display:flex;justify-content:center;width:100%;padding:0}.collapsed-view[_ngcontent-%COMP%]   cui-icon[_ngcontent-%COMP%]{margin:0}.collapsed-view-child[_ngcontent-%COMP%]   cdk-nested-tree-node.cdk-nested-tree-node.cdk-tree-node[_ngcontent-%COMP%]{padding-left:0}.collapsed-view-child[_ngcontent-%COMP%]   cdk-nested-tree-node.cdk-nested-tree-node.cdk-tree-node[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{padding:0;width:100%;display:flex;justify-content:center}.collapsed-view-child[_ngcontent-%COMP%]   cdk-nested-tree-node.cdk-nested-tree-node.cdk-tree-node[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   cui-icon[_ngcontent-%COMP%]{margin:0}div.flex-center[_ngcontent-%COMP%]{display:flex;align-items:center}cdk-tree[_ngcontent-%COMP%]   cdk-nested-tree-node.tree-node[_ngcontent-%COMP%]   span.sub-title[_ngcontent-%COMP%]{color:var(--cui-color-breadcrumbs)}"],
        data: {
          animation: [trigger('fadeIn', [state('void', style({
            opacity: 0
          })), transition(':enter', [animate('200ms 50ms ease-out', style({
            opacity: 1
          }))])])]
        },
        changeDetection: 0
      });
    }
  }
  return CuiSideNavExpandComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiSideNavGroupComponent = /*#__PURE__*/(() => {
  class CuiSideNavGroupComponent {
    constructor(navService, elRef) {
      this.navService = navService;
      this.elRef = elRef;
      this.text = '';
      this.isSideNavOpen$ = this.navService.sideNavVisibilityState$.pipe(tap(isOpen => {
        if (isOpen) {
          this.elRef.nativeElement.classList.add('padding-left');
        } else {
          this.elRef.nativeElement.classList.remove('padding-left');
        }
      }));
    }
    static {
      this.ɵfac = function CuiSideNavGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiSideNavGroupComponent)(i0.ɵɵdirectiveInject(SideNavService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiSideNavGroupComponent,
        selectors: [["cui-side-nav-group"]],
        inputs: {
          text: "text"
        },
        ngContentSelectors: _c3,
        decls: 3,
        vars: 3,
        consts: [[4, "ngIf"]],
        template: function CuiSideNavGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, CuiSideNavGroupComponent_h2_0_Template, 2, 1, "h2", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵprojection(2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.isSideNavOpen$));
          }
        },
        dependencies: [CommonModule, i2.NgIf, i2.AsyncPipe],
        styles: ["[_nghost-%COMP%]{display:block}"],
        changeDetection: 0
      });
    }
  }
  return CuiSideNavGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiSideNavItemComponent = /*#__PURE__*/(() => {
  class CuiSideNavItemComponent {
    constructor(sideNavService, appService) {
      this.sideNavService = sideNavService;
      this.appService = appService;
      this.linkClicked = new EventEmitter();
      this.isNavExpanded$ = this.sideNavService.sideNavVisibilityState$;
    }
    onLinkClick(url) {
      this.linkClicked.emit({
        url,
        customAction: this.customAction
      });
      if (this.appService.isMobileView) this.sideNavService.onSideNavVisibilityChange(false);
    }
    static {
      this.ɵfac = function CuiSideNavItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiSideNavItemComponent)(i0.ɵɵdirectiveInject(SideNavService), i0.ɵɵdirectiveInject(AppContainerService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiSideNavItemComponent,
        selectors: [["cui-side-nav-item"]],
        inputs: {
          icon: "icon",
          name: "name",
          url: "url",
          externalUrl: "externalUrl",
          customAction: "customAction"
        },
        outputs: {
          linkClicked: "linkClicked"
        },
        decls: 2,
        vars: 5,
        consts: [["elem", ""], [4, "ngIf"], [1, "handle", "no-wrap", 3, "click", "href", "matTooltipDisabled", "matTooltip", "matTooltipPosition", "ngClass"], ["routerLinkActive", "active", 3, "name", "isActive"], ["routerLinkActive", "active", "class", "handle no-wrap", 3, "routerLink", "matTooltipDisabled", "matTooltip", "matTooltipPosition", "ngClass", "click", 4, "ngIf"], ["class", "handle no-wrap", 3, "matTooltipDisabled", "matTooltip", "matTooltipPosition", "ngClass", "click", 4, "ngIf"], ["routerLinkActive", "active", 1, "handle", "no-wrap", 3, "click", "routerLink", "matTooltipDisabled", "matTooltip", "matTooltipPosition", "ngClass"], [1, "handle", "no-wrap", 3, "click", "matTooltipDisabled", "matTooltip", "matTooltipPosition", "ngClass"], ["routerLinkActive", "active", "x", "", 3, "name", "isActive"]],
        template: function CuiSideNavItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CuiSideNavItemComponent_ng_container_0_Template, 3, 2, "ng-container", 1);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction1(3, _c31, i0.ɵɵpipeBind1(1, 1, ctx.isNavExpanded$)));
          }
        },
        dependencies: [CommonModule, i2.NgClass, i2.NgIf, i2.AsyncPipe, CuiIconComponent, RouterModule, i1$1.RouterLink, i1$1.RouterLinkActive, MatTooltipModule, i3.MatTooltip],
        styles: [_c33],
        data: {
          animation: [trigger('fadeIn', [state('void', style({
            opacity: 0
          })), transition(':enter', [animate('200ms 50ms ease-out', style({
            opacity: 1
          }))])])]
        },
        changeDetection: 0
      });
    }
  }
  return CuiSideNavItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiSideNavModule = /*#__PURE__*/(() => {
  class CuiSideNavModule {
    static {
      this.ɵfac = function CuiSideNavModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiSideNavModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CuiSideNavModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CuiSideNavComponent, CuiSideNavItemComponent, CuiSideNavExpandComponent, CuiSideNavGroupComponent]
      });
    }
  }
  return CuiSideNavModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiSimpleTableComponent = /*#__PURE__*/(() => {
  class CuiSimpleTableComponent {
    constructor() {
      this.dataSource = [];
      this._colDefs = [];
      this._colHeaders = [];
    }
    set colDefs(val) {
      this._colDefs = val ?? [];
      this._colHeaders = this._colDefs.map(c => c.key);
    }
    static {
      this.ɵfac = function CuiSimpleTableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiSimpleTableComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiSimpleTableComponent,
        selectors: [["cui-simple-table"]],
        inputs: {
          colDefs: "colDefs",
          dataSource: "dataSource"
        },
        decls: 1,
        vars: 1,
        consts: [["mat-table", "", 3, "dataSource", 4, "ngIf"], ["mat-table", "", 3, "dataSource"], [3, "matColumnDef", 4, "ngFor", "ngForOf"], [4, "matHeaderRowDef", "matHeaderRowDefSticky"], [4, "matRowDef", "matRowDefColumns"], [3, "matColumnDef"], [4, "matHeaderCellDef"], ["mat-cell", "", 4, "matCellDef"], ["mat-cell", ""]],
        template: function CuiSimpleTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CuiSimpleTableComponent_mat_table_0_Template, 5, 5, "mat-table", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx._colDefs.length > 0);
          }
        },
        dependencies: [MatTableModule, i1$8.MatTable, i1$8.MatHeaderCellDef, i1$8.MatHeaderRowDef, i1$8.MatColumnDef, i1$8.MatCellDef, i1$8.MatRowDef, i1$8.MatHeaderCell, i1$8.MatCell, i1$8.MatHeaderRow, i1$8.MatRow, CommonModule, i2.NgForOf, i2.NgIf],
        styles: ["[_nghost-%COMP%]{width:100%}[_nghost-%COMP%]   mat-table[_ngcontent-%COMP%]{width:100%;max-height:inherit;overflow:auto}"],
        changeDetection: 0
      });
    }
  }
  return CuiSimpleTableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiSlideToggleComponent = /*#__PURE__*/(() => {
  class CuiSlideToggleComponent {
    constructor() {
      this.checked = false;
      this.label = '';
      this.disabled = true;
      this.change = new EventEmitter();
    }
    onChange(e) {
      this.change.emit(e.checked);
    }
    static {
      this.ɵfac = function CuiSlideToggleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiSlideToggleComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiSlideToggleComponent,
        selectors: [["cui-slide-toggle"]],
        inputs: {
          checked: "checked",
          label: "label",
          disabled: "disabled"
        },
        outputs: {
          change: "change"
        },
        decls: 3,
        vars: 6,
        consts: [[3, "ngClass"], [4, "ngIf"], ["disableRipple", "", 3, "change", "disabled", "checked"]],
        template: function CuiSlideToggleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "label", 0);
            i0.ɵɵtemplate(1, CuiSlideToggleComponent_span_1_Template, 2, 1, "span", 1);
            i0.ɵɵelementStart(2, "mat-slide-toggle", 2);
            i0.ɵɵlistener("change", function CuiSlideToggleComponent_Template_mat_slide_toggle_change_2_listener($event) {
              return ctx.onChange($event);
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c16, ctx.disabled));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.disabled)("checked", ctx.checked);
          }
        },
        dependencies: [MatSlideToggleModule, i2$4.MatSlideToggle, CommonModule, i2.NgClass, i2.NgIf],
        styles: ["[_nghost-%COMP%]{display:block;margin:11px 0}label[_ngcontent-%COMP%]{cursor:pointer;display:flex;align-items:center;width:100%}label[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{margin-right:var(--cui-small-space)}label.disabled[_ngcontent-%COMP%]{color:var(--color-disabled);cursor:default}"],
        changeDetection: 0
      });
    }
  }
  return CuiSlideToggleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CustomLoadingOverlayComponent = /*#__PURE__*/(() => {
  class CustomLoadingOverlayComponent {
    constructor() {
      this.diameter = 50;
    }
    agInit(params) {
      this.refresh(params);
    }
    refresh(params) {
      this.params = params;
      if (params.diameter) {
        this.diameter = params.diameter;
      }
    }
    static {
      this.ɵfac = function CustomLoadingOverlayComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CustomLoadingOverlayComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CustomLoadingOverlayComponent,
        selectors: [["cui-custom-loading-overlay"]],
        inputs: {
          diameter: "diameter"
        },
        decls: 1,
        vars: 1,
        consts: [["mode", "indeterminate", 1, "absolute-centered", 3, "diameter"]],
        template: function CustomLoadingOverlayComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "mat-spinner", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("diameter", ctx.diameter);
          }
        },
        dependencies: [MatProgressSpinnerModule, i3$1.MatProgressSpinner],
        styles: ["[_nghost-%COMP%]{margin:var(--cui-small-space)}"],
        changeDetection: 0
      });
    }
  }
  return CustomLoadingOverlayComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'dd/MM/yyyy' // this is how your date will be parsed from Input
  },
  display: {
    dateInput: 'yyyy-MM-dd',
    // this is how your date will get displayed on the Input
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy'
  }
};
let CuiTableDatepickerComponent = /*#__PURE__*/(() => {
  class CuiTableDatepickerComponent {
    constructor() {
      this.date = new UntypedFormControl();
    }
    agInit(params) {
      this.label = params.filterParams.label ?? 'Filter by date';
    }
    getDate() {
      return this.date.value;
    }
    setDate(date) {
      this.date.setValue(date);
    }
    static {
      this.ɵfac = function CuiTableDatepickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTableDatepickerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTableDatepickerComponent,
        selectors: [["cui-table-datepicker"]],
        features: [i0.ɵɵProvidersFeature([{
          provide: MAT_DATE_LOCALE,
          useValue: enGB
        }, {
          provide: DateAdapter,
          useClass: DateFnsAdapter,
          deps: [MAT_DATE_LOCALE]
        }, {
          provide: MAT_DATE_FORMATS,
          useValue: MY_DATE_FORMAT
        }])],
        decls: 8,
        vars: 5,
        consts: [["picker", ""], ["matInput", "", 3, "matDatepicker", "formControl"], ["matSuffix", "", 3, "for"], [3, "panelClass"]],
        template: function CuiTableDatepickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "mat-form-field")(2, "mat-label");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "input", 1)(5, "mat-datepicker-toggle", 2)(6, "mat-datepicker", 3, 0);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const picker_r1 = i0.ɵɵreference(7);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("matDatepicker", picker_r1)("formControl", ctx.date);
            i0.ɵɵadvance();
            i0.ɵɵproperty("for", picker_r1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("panelClass", "ag-custom-component-popup");
          }
        },
        dependencies: [MatFormFieldModule, i4.MatFormField, i4.MatLabel, i4.MatSuffix, MatInputModule, i5.MatInput, MatDatepickerModule, i4$2.MatDatepicker, i4$2.MatDatepickerInput, i4$2.MatDatepickerToggle, ReactiveFormsModule, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.FormControlDirective],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CuiTableDatepickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RangeDateFilterComponent = /*#__PURE__*/(() => {
  class RangeDateFilterComponent {
    get filterValues() {
      return {
        from: this.form?.controls.from.value,
        to: this.form?.controls.to.value
      };
    }
    get createdFromControl() {
      return this.form.controls.from;
    }
    /** Check if values differ from the initial state */
    get valueChanged() {
      return this.getStringified(this.initialValues.from) !== this.getStringified(this.filterValues.from) || this.getStringified(this.initialValues.to) !== this.getStringified(this.filterValues.to);
    }
    /** Determine if the clear button should be enabled */
    get canResetFilter() {
      return !!this.form && !this.isFilterDefault();
    }
    /** Determine if the apply button should be enabled */
    get canApplyFilter() {
      return !!this.form && this.form.valid && this.valueChanged;
    }
    constructor(fb) {
      this.fb = fb;
      this.initialValues = {
        from: null,
        to: null
      };
    }
    agInit(params) {
      this.params = params;
      const dateFrom = this.convertToStartOfDay(params.defaultFromValue);
      const dateTo = this.convertToStartOfDay(params.defaultToValue);
      this.form = this.fb.group({
        from: this.fb.control(dateFrom, {
          nonNullable: false,
          validators: this.params.fromValidators
        }),
        to: this.fb.control(dateTo, {
          nonNullable: false,
          validators: this.params.toValidators
        })
      });
      this.initialValues = {
        from: dateFrom,
        to: dateTo
      };
    }
    isFilterActive() {
      return !!this.filterValues.from && !!this.filterValues.to;
    }
    //** Check if filter values are at default state */
    isFilterDefault() {
      if (this.params.defaultFromValue && this.params.defaultToValue) {
        return this.initialValues.from?.toDateString() === this.params.defaultFromValue.toDateString() && this.initialValues.to?.toDateString() === this.params.defaultToValue.toDateString();
      } else {
        return false;
      }
    }
    getModel() {
      if (!this.isFilterActive()) {
        return null;
      }
      return {
        filterType: 'date',
        dateFrom: this.filterValues.from,
        dateTo: this.filterValues.to
      };
    }
    setModel(model) {
      const dateFrom = this.convertToStartOfDay(model?.dateFrom ?? null);
      const dateTo = this.convertToStartOfDay(model?.dateTo ?? null);
      this.form.controls.from.setValue(dateFrom);
      this.form.controls.to.setValue(dateTo);
      this.initialValues = {
        from: dateFrom,
        to: dateTo
      };
    }
    onApplyFilter() {
      if (this.canApplyFilter) {
        this.initialValues = {
          ...this.filterValues
        };
        this.params.filterChangedCallback();
      }
    }
    doesFilterPass(params) {
      return true;
    }
    convertToStartOfDay(date) {
      return date ? startOfDay(date) : null;
    }
    getStringified(date) {
      return JSON.stringify(date);
    }
    onResetFilter() {
      if (this.canResetFilter) {
        this.form.reset({
          from: this.convertToStartOfDay(this.params.defaultFromValue),
          to: this.convertToStartOfDay(this.params.defaultToValue)
        });
        this.initialValues = {
          ...this.filterValues
        };
        this.params.filterChangedCallback();
      }
    }
    static {
      this.ɵfac = function RangeDateFilterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RangeDateFilterComponent)(i0.ɵɵdirectiveInject(i1$6.FormBuilder));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RangeDateFilterComponent,
        selectors: [["cui-date-range-filter"]],
        decls: 6,
        vars: 3,
        consts: [[3, "formGroup", 4, "ngIf"], [1, "ag-filter-apply-panel"], [1, "ag-button", "ag-standard-button", "ag-filter-apply-panel-button", 3, "click", "disabled"], [3, "formGroup"], ["formControlName", "from", 3, "label", "panelClass"], ["formControlName", "to", 3, "label", "panelClass", "minDate"]],
        template: function RangeDateFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, RangeDateFilterComponent_form_0_Template, 3, 6, "form", 0);
            i0.ɵɵelementStart(1, "div", 1)(2, "button", 2);
            i0.ɵɵlistener("click", function RangeDateFilterComponent_Template_button_click_2_listener() {
              return ctx.onResetFilter();
            });
            i0.ɵɵtext(3, " Reset ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "button", 2);
            i0.ɵɵlistener("click", function RangeDateFilterComponent_Template_button_click_4_listener() {
              return ctx.onApplyFilter();
            });
            i0.ɵɵtext(5, " Apply ");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.form);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", !ctx.canResetFilter);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", !ctx.canApplyFilter);
          }
        },
        dependencies: [CommonModule, i2.NgIf, ReactiveFormsModule, i1$6.ɵNgNoValidate, i1$6.NgControlStatus, i1$6.NgControlStatusGroup, i1$6.FormGroupDirective, i1$6.FormControlName, CuiDatepickerComponent],
        styles: ["[_nghost-%COMP%]{display:block;padding:var(--cui-small-space);padding-bottom:0}.ag-filter-apply-panel[_ngcontent-%COMP%]{display:flex;gap:var(--cui-small-space)}"],
        changeDetection: 0
      });
    }
  }
  return RangeDateFilterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CustomTextFilterComponent = /*#__PURE__*/(() => {
  class CustomTextFilterComponent extends SubscribingBase {
    get valueChanged() {
      return this.initialValue !== this.filterText;
    }
    constructor(fb) {
      super();
      this.fb = fb;
      this.initialValue = '';
    }
    get filterText() {
      return this.form?.value.filterText ?? '';
    }
    agInit(params) {
      this.params = params;
      this.form = this.fb.group({
        filterText: this.fb.control('', {
          nonNullable: false,
          validators: this.params.validators
        })
      });
    }
    isFilterActive() {
      return this.form.valid && this.filterText.length > 0;
    }
    onApplyFilter() {
      if (!this.form.valid || !this.valueChanged) {
        return;
      }
      this.initialValue = this.filterText;
      this.params.filterChangedCallback();
    }
    onClearFilter() {
      if (!this.filterText || !this.initialValue) {
        return;
      }
      this.form.reset();
      this.initialValue = this.filterText;
      this.params.filterChangedCallback();
    }
    getModel() {
      if (!this.form.valid || !this.filterText) {
        return null;
      }
      return {
        type: 'equals',
        filter: this.filterText
      };
    }
    getModelAsString(model) {
      if (!this.isFilterActive()) {
        return '';
      }
      return this.filterText;
    }
    setModel(model) {
      this.initialValue = model?.filter || '';
      this.form.controls.filterText.setValue(model?.filter || '');
    }
    doesFilterPass(params) {
      return true;
    }
    static {
      this.ɵfac = function CustomTextFilterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CustomTextFilterComponent)(i0.ɵɵdirectiveInject(i1$6.FormBuilder));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CustomTextFilterComponent,
        selectors: [["cui-table-text-filter"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 6,
        vars: 3,
        consts: [[3, "formGroup", 4, "ngIf"], [1, "ag-filter-apply-panel"], [1, "ag-button", "ag-standard-button", "ag-filter-apply-panel-button", 3, "click", "disabled"], [3, "formGroup"], ["formControlName", "filterText", 3, "label"]],
        template: function CustomTextFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CustomTextFilterComponent_form_0_Template, 2, 2, "form", 0);
            i0.ɵɵelementStart(1, "div", 1)(2, "button", 2);
            i0.ɵɵlistener("click", function CustomTextFilterComponent_Template_button_click_2_listener() {
              return ctx.onClearFilter();
            });
            i0.ɵɵtext(3, " Clear ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "button", 2);
            i0.ɵɵlistener("click", function CustomTextFilterComponent_Template_button_click_4_listener() {
              return ctx.onApplyFilter();
            });
            i0.ɵɵtext(5, " Apply ");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.form);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", !ctx.filterText || !ctx.initialValue);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.form && !ctx.form.valid || !ctx.valueChanged);
          }
        },
        dependencies: [CommonModule, i2.NgIf, ReactiveFormsModule, i1$6.ɵNgNoValidate, i1$6.NgControlStatus, i1$6.NgControlStatusGroup, i1$6.FormGroupDirective, i1$6.FormControlName, CuiInputComponent],
        styles: [_c34],
        changeDetection: 0
      });
    }
  }
  return CustomTextFilterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiMultilineCellRendererComponent = /*#__PURE__*/(() => {
  class CuiMultilineCellRendererComponent {
    constructor() {
      this.line1 = null;
      this.line2 = null;
      this.errorMessage = null;
    }
    agInit(cellRendererParams) {
      this.updateValues(cellRendererParams);
    }
    refresh(cellRendererParams) {
      this.updateValues(cellRendererParams);
    }
    updateValues({
      data,
      line1Renderer,
      line2Renderer,
      errorMessageRenderer
    }) {
      this.line1 = line1Renderer(data);
      this.line2 = line2Renderer ? line2Renderer(data) : null;
      this.errorMessage = errorMessageRenderer ? errorMessageRenderer(data) : null;
    }
    static {
      this.ɵfac = function CuiMultilineCellRendererComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiMultilineCellRendererComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiMultilineCellRendererComponent,
        selectors: [["ng-component"]],
        decls: 4,
        vars: 3,
        consts: [[4, "ngIf"]],
        template: function CuiMultilineCellRendererComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "p");
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, CuiMultilineCellRendererComponent_small_2_Template, 2, 1, "small", 0)(3, CuiMultilineCellRendererComponent_mat_error_3_Template, 2, 1, "mat-error", 0);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.line1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.line2);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.errorMessage);
          }
        },
        dependencies: [CommonModule, i2.NgIf, MatFormFieldModule, i4.MatError],
        styles: ["[_nghost-%COMP%]{display:block;padding-top:var(--cui-small-space);padding-bottom:var(--cui-small-space)}small[_ngcontent-%COMP%], mat-error[_ngcontent-%COMP%]{display:block;line-height:var(--cui-font-h5-and-p-size);margin-top:0}mat-error[_ngcontent-%COMP%]{color:var(--cui-color-attention);font-weight:var(--cui-font-weight-regular);font-family:var(--cui-font-placeholder-font-family);font-size:var(--cui-font-placeholder-size);line-height:var(--cui-font-placeholder-line-height)}"]
      });
    }
  }
  return CuiMultilineCellRendererComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTableCellCheckmarkRendererComponent = /*#__PURE__*/(() => {
  class CuiTableCellCheckmarkRendererComponent {
    constructor() {
      this.isChecked = false;
    }
    agInit(params) {
      this.isChecked = params.data[params.colDef.field];
    }
    static {
      this.ɵfac = function CuiTableCellCheckmarkRendererComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTableCellCheckmarkRendererComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTableCellCheckmarkRendererComponent,
        selectors: [["cui-table-cell-checkmark-renderer"]],
        decls: 3,
        vars: 3,
        consts: [[4, "ngIf"], [3, "name", 4, "ngIf"], [3, "name"]],
        template: function CuiTableCellCheckmarkRendererComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CuiTableCellCheckmarkRendererComponent_ng_container_0_Template, 2, 0, "ng-container", 0)(1, CuiTableCellCheckmarkRendererComponent_cui_icon_1_Template, 1, 1, "cui-icon", 1)(2, CuiTableCellCheckmarkRendererComponent_cui_icon_2_Template, 1, 1, "cui-icon", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.isChecked !== false && ctx.isChecked !== true);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isChecked === true);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isChecked === false);
          }
        },
        dependencies: [CommonModule, i2.NgIf, CuiIconComponent],
        styles: ["[_nghost-%COMP%]{height:100%;width:100%;display:flex;align-items:center;justify-content:center}"]
      });
    }
  }
  return CuiTableCellCheckmarkRendererComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTableCellIconRendererComponent = /*#__PURE__*/(() => {
  class CuiTableCellIconRendererComponent {
    agInit(params) {
      this.iconName = params.value.iconName;
      this.iconTooltip = params.value.iconTooltip;
      this.cellValue = params.value.cellValue;
    }
    static {
      this.ɵfac = function CuiTableCellIconRendererComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTableCellIconRendererComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTableCellIconRendererComponent,
        selectors: [["cui-table-cell-icon-renderer"]],
        decls: 3,
        vars: 3,
        consts: [[3, "name", "tooltipText"]],
        template: function CuiTableCellIconRendererComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "span");
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(2, "cui-icon", 0);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.cellValue);
            i0.ɵɵadvance();
            i0.ɵɵproperty("name", ctx.iconName)("tooltipText", ctx.iconTooltip);
          }
        },
        dependencies: [CommonModule, MatTooltipModule, CuiIconComponent],
        styles: ["[_nghost-%COMP%]{display:inline-flex;align-items:center}[_nghost-%COMP%]   span[_ngcontent-%COMP%]{margin-right:var(--cui-extra-small-space)}"]
      });
    }
  }
  return CuiTableCellIconRendererComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTableCellIconButtonRendererComponent = /*#__PURE__*/(() => {
  class CuiTableCellIconButtonRendererComponent {
    agInit(params) {
      this.params = params;
      this.iconName = this.params.value.iconName;
      this.iconTooltip = this.params.value.iconTooltip;
      this.iconAction = this.params.value.iconAction;
      this.cellValue = this.params.value.cellValue ?? '';
      this.setIconButtonDisabled(params, this.params.value.iconStatus);
    }
    setValue() {
      const selectedData = this.params.node.data;
      this.params.api.applyTransaction({
        [this.iconAction]: [selectedData]
      });
      if (this.params.setValue instanceof Function) {
        this.params.setValue(selectedData);
      }
    }
    setIconButtonDisabled({
      data
    }, status) {
      this.iconDisabled = status === 'valid' ? false : !data[status];
    }
    static {
      this.ɵfac = function CuiTableCellIconButtonRendererComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTableCellIconButtonRendererComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTableCellIconButtonRendererComponent,
        selectors: [["ng-component"]],
        decls: 3,
        vars: 4,
        consts: [[3, "clicked", "name", "matTooltip", "disabled"]],
        template: function CuiTableCellIconButtonRendererComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "span");
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "cui-icon-btn", 0);
            i0.ɵɵlistener("clicked", function CuiTableCellIconButtonRendererComponent_Template_cui_icon_btn_clicked_2_listener() {
              return ctx.setValue();
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.cellValue);
            i0.ɵɵadvance();
            i0.ɵɵproperty("name", ctx.iconName)("matTooltip", ctx.iconTooltip)("disabled", ctx.iconDisabled);
          }
        },
        dependencies: [MatTooltipModule, i3.MatTooltip, CuiIconButtonComponent],
        styles: ["[_nghost-%COMP%]{display:inline-flex}[_nghost-%COMP%]   span[_ngcontent-%COMP%]{margin-right:var(--cui-extra-small-space)}"]
      });
    }
  }
  return CuiTableCellIconButtonRendererComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTableRowDetailRendererComponent = /*#__PURE__*/(() => {
  class CuiTableRowDetailRendererComponent {
    constructor() {
      this.propertiesToPrint = [];
      this.actionColumns = [];
      this.propertiesToIgnore = [];
      this.customColumnList = [];
    }
    agInit(params) {
      this.params = params;
      this.customColumnList = params.value.customColumnList;
      this.actionColumns = params.value.actionColumns;
      this.propertiesToIgnore = params.value.propertiesToIgnore;
      const isCustomColumnListProvided = this.customColumnList.length !== 0;
      const isActionListProvided = this.actionColumns.length !== 0;
      if (!isActionListProvided || !isCustomColumnListProvided) {
        params.api.getAllGridColumns().forEach(column => {
          const colDef = column.getColDef();
          if (!isCustomColumnListProvided && (colDef.field && this.propertiesToIgnore.indexOf(colDef.field) < 0 || colDef.valueGetter)) {
            this.propertiesToPrint.push({
              name: colDef.headerName ?? this.params.api.getDisplayNameForColumn(column, 'header'),
              value: this.getPropertyValue(colDef),
              renderer: this.getCellRenderer(colDef)
            });
          }
          if (!isActionListProvided && !colDef.field && colDef.cellRenderer && colDef.cellRendererParams?.setValue) {
            this.actionColumns.push(this.getCellRenderer(colDef));
          }
        });
      } else if (isCustomColumnListProvided) {
        this.customColumnList.forEach(column => {
          this.propertiesToPrint.push({
            name: column.headerName,
            value: this.getPropertyValue({
              field: column.field,
              valueFormatter: column.valueFormatter,
              valueGetter: column.valueGetter
            }),
            renderer: column.renderer
          });
        });
      }
    }
    refresh(params) {
      return false;
    }
    setValue(iconAction, setValue) {
      const selectedData = this.params.node.data;
      this.params.api.applyTransaction({
        [iconAction]: [selectedData]
      });
      if (setValue instanceof Function) {
        setValue(selectedData);
      }
    }
    getCellRenderer(colDef) {
      let renderer = {
        type: '',
        params: undefined,
        isChecked: undefined
      };
      if (colDef.cellRenderer) {
        if (colDef.cellRenderer === 'cuiTableCellCheckmarkRenderer') {
          renderer = {
            type: colDef.cellRenderer,
            isChecked: this.params.data[colDef.field],
            params: undefined
          };
        } else {
          renderer = {
            type: colDef.cellRenderer,
            params: typeof colDef.cellRendererParams == 'function' ? colDef.cellRendererParams({
              data: this.params.data
            }) // because of this, all cell renderer params (including cellValue) HAVE to be computed from params.data (or hardcoded) when defining colDef for everything to be shown in details properly
            : colDef.cellRendererParams,
            isChecked: undefined
          };
        }
      } else if (colDef.cellRendererSelector) {
        const selectorResult = colDef.cellRendererSelector({
          data: this.params.data
        });
        if (selectorResult) {
          renderer = {
            type: selectorResult.component,
            params: selectorResult.params,
            isChecked: undefined
          };
        }
      }
      return renderer;
    }
    getPropertyValue(colDef) {
      let value = '\u00A0';
      if (colDef.field) {
        if (colDef.valueFormatter) {
          value = typeof colDef.valueFormatter !== 'string' ? colDef.valueFormatter({
            value: this.params.data[colDef.field]
          }) : colDef.valueFormatter;
        } else {
          value = this.params.data[colDef.field];
        }
      } else if (colDef.valueGetter) {
        value = typeof colDef.valueGetter !== 'string' ? colDef.valueGetter({
          ...this.params
        }) : colDef.valueGetter;
      }
      return !value || value === '' ? '\u00A0' : value;
    }
    static {
      this.ɵfac = function CuiTableRowDetailRendererComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTableRowDetailRendererComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTableRowDetailRendererComponent,
        selectors: [["ng-component"]],
        decls: 4,
        vars: 1,
        consts: [[1, "details-container"], [1, "property-name"], [1, "value-container"], [3, "name"], [3, "clicked", "name", "disabled"], [3, "name", "tooltipText"], [1, "action-columns"], [3, "name", "disabled"]],
        template: function CuiTableRowDetailRendererComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵrepeaterCreate(1, CuiTableRowDetailRendererComponent_For_2_Template, 7, 2, "div", null, _forTrack0);
            i0.ɵɵtemplate(3, CuiTableRowDetailRendererComponent_Conditional_3_Template, 5, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.propertiesToPrint);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.actionColumns.length > 0 ? 3 : -1);
          }
        },
        dependencies: [CuiIconButtonComponent, CuiIconComponent],
        styles: [".details-container[_ngcontent-%COMP%]{margin:var(--cui-small-space) var(--cui-medium-space);height:100%;overflow:auto;display:flex;flex-direction:column;flex-wrap:wrap;column-gap:var(--cui-small-space)}.details-container[_ngcontent-%COMP%]   .property-name[_ngcontent-%COMP%]{font-size:calc(var(--cui-font-h6-size) * .8)}.details-container[_ngcontent-%COMP%]   .value-container[_ngcontent-%COMP%]{display:flex;margin:0 0 var(--cui-extra-small-space) 0;font-size:var(--cui-font-h6-size)}.details-container[_ngcontent-%COMP%]   .value-container[_ngcontent-%COMP%]   cui-icon-btn[_ngcontent-%COMP%]{margin-top:-.3rem}.details-container[_ngcontent-%COMP%]   .action-columns[_ngcontent-%COMP%]{display:flex}"]
      });
    }
  }
  return CuiTableRowDetailRendererComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTableBaseComponent = /*#__PURE__*/(() => {
  class CuiTableBaseComponent {
    constructor() {
      this.domLayout = false;
      this.rowClicked = new EventEmitter();
      this.filterChanged = new EventEmitter();
      this.gridReady = new EventEmitter();
      this.defaultDetailCellRendererConfig = {
        screenWidthBreakpoint: -1,
        value: {
          actionColumns: [],
          propertiesToIgnore: [],
          customColumnList: []
        }
      };
      this.initialColDefs = [];
      this.currentColDefs = [];
      this.groupDisplayType = 'groupRows';
      this.defaultColDef = {
        flex: 1,
        minWidth: 100,
        sortable: true,
        resizable: true,
        menuTabs: ['filterMenuTab'],
        suppressHeaderMenuButton: true
      };
      this.defaultGridOptions = {
        getRowId: params => params.data.id,
        accentedSort: true,
        includeHiddenColumnsInQuickFilter: true,
        detailCellRenderer: 'cuiTableRowDetailRenderer',
        detailCellRendererParams: () => {
          return {
            value: this.defaultDetailCellRendererConfig.value
          };
        },
        onRowGroupOpened: params => {
          this.handleGroupToggle(params);
        },
        onRowSelected(event) {
          const rowIndex = event.node.rowIndex;
          if (event.node.isSelected() && rowIndex) event.api.ensureIndexVisible(rowIndex);
        },
        loadingOverlayComponent: CustomLoadingOverlayComponent,
        animateRows: true,
        groupAllowUnbalanced: true
      };
      this._gridOptions = {
        ...this.defaultGridOptions
      };
      this._isLoading = false;
      this._rowData = [];
      this.isScreenSmallerThanGivenSize = false;
      this.isDetailComponentEnabled = false;
    }
    set columnDefs(value) {
      this.initialColDefs = value;
      this.currentColDefs = value;
    }
    get columnDefs() {
      return this.currentColDefs;
    }
    set gridOptions(options) {
      this._gridOptions = {
        ...this.defaultGridOptions,
        ...options
      };
    }
    set rowData(value) {
      this._rowData = value ?? [];
      this.updateTableOverlay();
    }
    set isLoading(value) {
      this._isLoading = value;
      this.updateTableOverlay();
    }
    set quickSearch(value) {
      if (!this._gridApi) {
        return;
      }
      this._gridApi.setGridOption('quickFilterText', value);
      if (!this._gridApi.getRenderedNodes().length) {
        this._gridApi.showNoRowsOverlay();
      } else {
        this._gridApi.hideOverlay();
      }
    }
    set selectedRowId(value) {
      this._selectedRowId = value;
      this.handleSelectedRow(value);
    }
    set detailCellRendererConfig(value) {
      this.defaultDetailCellRendererConfig = {
        ...this.detailCellRendererConfig,
        ...value
      };
      if (this.defaultDetailCellRendererConfig.screenWidthBreakpoint > 0) {
        this.isDetailComponentEnabled = true;
      } else {
        this.isDetailComponentEnabled = false;
      }
    }
    get isLoading() {
      return this._isLoading;
    }
    get gridOptions() {
      return this._gridOptions;
    }
    get rowData() {
      return this._rowData;
    }
    get gridApi() {
      return this._gridApi;
    }
    onViewPortChanged() {
      if (this._selectedRowId) {
        this.handleSelectedRow(this._selectedRowId);
      }
    }
    onGridReady(params) {
      this._gridApi = params.api;
      if (this._gridApi && this.filterSetting) {
        this._gridApi.setFilterModel(this.filterSetting.gridSearch);
      }
      this.handleSelectedRow(this._selectedRowId);
      this.updateTableOverlay();
      this.resizeColumnsToFit();
      // Emit the grid API to parent components
      this.gridReady.emit(this._gridApi);
    }
    ngOnInit() {
      this.components = {
        cuiTableCellIconButtonRenderer: CuiTableCellIconButtonRendererComponent,
        cuiTableCellIconRenderer: CuiTableCellIconRendererComponent,
        cuiMultilineCellRenderer: CuiMultilineCellRendererComponent,
        cuiTableCellCheckmarkRenderer: CuiTableCellCheckmarkRendererComponent,
        agDateInput: CuiTableDatepickerComponent,
        cuiTableRowDetailRenderer: CuiTableRowDetailRendererComponent
      };
      if (this.isDetailComponentEnabled) {
        const observer = new ResizeObserver(entries => {
          entries.forEach(entry => {
            if (entry.contentRect.width < this.defaultDetailCellRendererConfig.screenWidthBreakpoint && !this.isScreenSmallerThanGivenSize) {
              this.smallScreenActions();
            } else if (entry.contentRect.width > this.defaultDetailCellRendererConfig.screenWidthBreakpoint && this.isScreenSmallerThanGivenSize) {
              this.bigScreenActions();
            }
          });
        });
        const body = document.querySelector('body');
        if (body?.clientWidth && body.clientWidth < this.defaultDetailCellRendererConfig.screenWidthBreakpoint) {
          this.smallScreenActions();
        }
        if (body) {
          observer.observe(body);
        }
      }
    }
    smallScreenActions() {
      this.isScreenSmallerThanGivenSize = true;
      this.gridOptions = {
        ...this.defaultGridOptions,
        masterDetail: true
      };
      this.currentColDefs = this.initialColDefs.map(item => ({
        ...item,
        minWidth: 100,
        hide: item.hide === true || item.context.showInSmallScreen === false
      }));
      this.currentColDefs.push({
        maxWidth: 35,
        pinned: 'right',
        valueFormatter: () => '',
        cellRenderer: 'agGroupCellRenderer'
      });
      if (this._gridApi) {
        this._gridApi.updateGridOptions(this.defaultGridOptions);
      }
    }
    bigScreenActions() {
      this.isScreenSmallerThanGivenSize = false;
      this.gridOptions = {
        ...this.defaultGridOptions,
        masterDetail: false
      };
      this.currentColDefs = this.initialColDefs.map(item => ({
        ...item,
        hide: item.hide === true
      }));
      if (this._gridApi) {
        this._gridApi.updateGridOptions(this.defaultGridOptions);
      }
    }
    onRowClicked(params) {
      this.rowClicked.emit(params.data);
      this.handleSelectedRow(params.data?.id);
    }
    onGridSizeChanged() {
      this.resizeColumnsToFit();
    }
    onFilterChanged($event) {
      this.filterChanged.emit($event);
    }
    handleSelectedRow(id) {
      if (!id) {
        this._gridApi?.deselectAll();
        return;
      }
      const selectedRowNode = this._gridApi?.getRowNode(id);
      if (!!selectedRowNode) {
        selectedRowNode.setSelected(true);
      } else {
        this._gridApi?.deselectAll();
      }
    }
    updateTableOverlay() {
      if (!this._gridApi) {
        return;
      } else if (this.gridOptions.rowModelType !== 'serverSide') {
        if (this.isLoading) {
          this._gridApi.setGridOption('loading', true);
          return;
        }
        if (this.rowData.length < 1) {
          this._gridApi.setGridOption('loading', false);
          this._gridApi.showNoRowsOverlay();
          return;
        }
        this._gridApi.setGridOption('loading', false);
        this._gridApi.hideOverlay();
      }
    }
    resizeColumnsToFit() {
      if (!this._gridApi || this.gridOptions?.context && this.gridOptions?.context.noAutoSize) {
        return;
      }
      this._gridApi.sizeColumnsToFit();
    }
    handleGroupToggle(params) {
      if (params.expanded) {
        this.resizeColumnsToFit();
        if (params.node.level === 0) {
          params.api.forEachNode(node => {
            if (node.parent?.id === params.node.id) {
              node.setExpanded(false);
            }
          });
        }
        if (params.node.level === 1) {
          params.api.forEachNode(node => {
            if (node.expanded && node.level === 1 && node.rowIndex !== params.rowIndex) {
              node.setExpanded(false);
            }
          });
        }
      }
      setTimeout(() => this.resizeColumnsToFit(), 400);
    }
    static {
      this.ɵfac = function CuiTableBaseComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTableBaseComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTableBaseComponent,
        selectors: [["cui-table-base"]],
        inputs: {
          domLayout: "domLayout",
          columnDefs: "columnDefs",
          loadingMessage: "loadingMessage",
          noRowsMessage: "noRowsMessage",
          filterSetting: "filterSetting",
          gridOptions: "gridOptions",
          rowData: "rowData",
          isLoading: "isLoading",
          quickSearch: "quickSearch",
          selectedRowId: "selectedRowId",
          detailCellRendererConfig: "detailCellRendererConfig"
        },
        outputs: {
          rowClicked: "rowClicked",
          filterChanged: "filterChanged",
          gridReady: "gridReady"
        },
        decls: 1,
        vars: 11,
        consts: [[3, "gridReady", "rowClicked", "filterChanged", "gridSizeChanged", "viewportChanged", "domLayout", "rowData", "defaultColDef", "columnDefs", "suppressCellFocus", "gridOptions", "components", "overlayNoRowsTemplate", "overlayLoadingTemplate", "groupDisplayType", "groupDefaultExpanded"]],
        template: function CuiTableBaseComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ag-grid-angular", 0);
            i0.ɵɵlistener("gridReady", function CuiTableBaseComponent_Template_ag_grid_angular_gridReady_0_listener($event) {
              return ctx.onGridReady($event);
            })("rowClicked", function CuiTableBaseComponent_Template_ag_grid_angular_rowClicked_0_listener($event) {
              return ctx.onRowClicked($event);
            })("filterChanged", function CuiTableBaseComponent_Template_ag_grid_angular_filterChanged_0_listener($event) {
              return ctx.onFilterChanged($event);
            })("gridSizeChanged", function CuiTableBaseComponent_Template_ag_grid_angular_gridSizeChanged_0_listener() {
              return ctx.onGridSizeChanged();
            })("viewportChanged", function CuiTableBaseComponent_Template_ag_grid_angular_viewportChanged_0_listener() {
              return ctx.onViewPortChanged();
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("domLayout", ctx.domLayout ? "autoHeight" : undefined)("rowData", ctx.gridOptions.rowModelType === "serverSide" ? null : ctx.rowData)("defaultColDef", ctx.defaultColDef)("columnDefs", ctx.columnDefs)("suppressCellFocus", true)("gridOptions", ctx.gridOptions)("components", ctx.components)("overlayNoRowsTemplate", ctx.noRowsMessage)("overlayLoadingTemplate", ctx.loadingMessage)("groupDisplayType", ctx.groupDisplayType)("groupDefaultExpanded", ctx.gridOptions.rowModelType === "serverSide" ? undefined : 0);
          }
        },
        dependencies: [CommonModule, AgGridAngular],
        styles: ["[_nghost-%COMP%], [_nghost-%COMP%]   ag-grid-angular[_ngcontent-%COMP%]{width:100%;height:100%}"],
        changeDetection: 0
      });
    }
  }
  return CuiTableBaseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function createServerSideDatasource(server) {
  return {
    getRows: async params => {
      params.api.hideOverlay();
      const result = await server.getData(params.request);
      if (result.success) {
        params.success({
          rowData: result.rows
        });
        if (result.rows.length === 0) {
          params.api.showNoRowsOverlay();
        } else {
          params.api.hideOverlay();
        }
      } else {
        params.fail();
      }
    }
  };
}
let CuiTableButtonComponent = /*#__PURE__*/(() => {
  class CuiTableButtonComponent {
    constructor() {
      this.ctaClicked = new EventEmitter();
      this.secondaryBtnClicked = new EventEmitter();
    }
    static {
      this.ɵfac = function CuiTableButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTableButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTableButtonComponent,
        selectors: [["cui-table-buttons"]],
        inputs: {
          isMobile: "isMobile",
          ctaText: "ctaText",
          ctaDisabled: "ctaDisabled",
          ctaTooltip: "ctaTooltip",
          secondaryBtnText: "secondaryBtnText",
          secondaryBtnDisabled: "secondaryBtnDisabled",
          secondaryBtnTooltip: "secondaryBtnTooltip"
        },
        outputs: {
          ctaClicked: "ctaClicked",
          secondaryBtnClicked: "secondaryBtnClicked"
        },
        decls: 7,
        vars: 5,
        consts: [["menu", "matMenu"], [3, "ctaTooltip", "disabled", "clicked", 4, "ngIf"], ["class", "menu-button", "mat-mini-fab", "", "type", "button", "color", "none", 3, "matMenuTriggerFor", 4, "ngIf"], ["class", "cta-button", "mat-menu-item", "", 3, "disabled", "click", 4, "ngIf"], [3, "clicked", "ctaTooltip", "disabled"], ["mat-mini-fab", "", "type", "button", "color", "none", 1, "menu-button", 3, "matMenuTriggerFor"], [3, "name"], ["mat-menu-item", "", 1, "cta-button", 3, "click", "disabled"]],
        template: function CuiTableButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CuiTableButtonComponent_cui_button_cta_0_Template, 2, 3, "cui-button-cta", 1)(1, CuiTableButtonComponent_cui_button_cta_1_Template, 2, 3, "cui-button-cta", 1)(2, CuiTableButtonComponent_button_2_Template, 2, 2, "button", 2);
            i0.ɵɵelementStart(3, "mat-menu", null, 0);
            i0.ɵɵtemplate(5, CuiTableButtonComponent_button_5_Template, 2, 2, "button", 3)(6, CuiTableButtonComponent_button_6_Template, 2, 2, "button", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.ctaText && !ctx.isMobile);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.secondaryBtnText && !ctx.isMobile);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isMobile && (ctx.ctaText || ctx.secondaryBtnText));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.ctaText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.secondaryBtnText);
          }
        },
        dependencies: [CommonModule, i2.NgIf, CuiButtonCtaComponent, CuiIconComponent, MatMenuModule, i2$2.MatMenu, i2$2.MatMenuItem, i2$2.MatMenuTrigger, MatButtonModule, i1.MatMiniFabButton],
        styles: ["[_nghost-%COMP%]{display:flex;gap:var(--cui-small-space)}.menu-button[_ngcontent-%COMP%]{height:var(--cui-size-buttons-height-large);width:var(--cui-size-buttons-height-large)}.cta-button[_ngcontent-%COMP%]{color:var(--cui-color-cta)}"],
        changeDetection: 0
      });
    }
  }
  return CuiTableButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTableToggleComponent = /*#__PURE__*/(() => {
  class CuiTableToggleComponent {
    constructor() {
      this.toggleClicked = new EventEmitter();
    }
    static {
      this.ɵfac = function CuiTableToggleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTableToggleComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTableToggleComponent,
        selectors: [["cui-table-toggle"]],
        inputs: {
          toggleDefaultOption: "toggleDefaultOption",
          toggleOptions: "toggleOptions"
        },
        outputs: {
          toggleClicked: "toggleClicked"
        },
        decls: 3,
        vars: 2,
        consts: [["group", "matButtonToggleGroup"], [3, "value"], ["disableRipple", "true", "color", "accent", 3, "value", "click", 4, "ngFor", "ngForOf"], ["disableRipple", "true", "color", "accent", 3, "click", "value"]],
        template: function CuiTableToggleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-button-toggle-group", 1, 0);
            i0.ɵɵtemplate(2, CuiTableToggleComponent_mat_button_toggle_2_Template, 2, 2, "mat-button-toggle", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("value", ctx.toggleDefaultOption);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.toggleOptions);
          }
        },
        dependencies: [CommonModule, i2.NgForOf, MatButtonToggleModule, i2$3.MatButtonToggleGroup, i2$3.MatButtonToggle],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CuiTableToggleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTableControlsComponent = /*#__PURE__*/(() => {
  class CuiTableControlsComponent extends SubscribingBase {
    constructor() {
      super();
      this.includeSearch = true;
      this.searchChanged = new EventEmitter(true);
      this.ctaClicked = new EventEmitter();
      this.secondaryBtnClicked = new EventEmitter();
      this.toggleClicked = new EventEmitter();
      this.mobileSize = 600;
    }
    onResize() {
      const offsetWidth = window.innerWidth;
      this.isMobile = offsetWidth === 0 ? false : this.mobileSize > offsetWidth;
    }
    clearSearch() {
      this.searchControl.setValue('');
    }
    ngOnInit() {
      this.onResize();
      this.searchControl = new FormControl('');
      this.subscribe(this.searchControl.valueChanges.pipe(debounceTime(1000)), res => {
        this.searchChanged.emit(res || '');
      });
      if (this.filterSetting?.quickSearch) {
        this.searchControl.setValue(this.filterSetting.quickSearch);
      }
      if (this.filterSetting?.toggleSearch) {
        this.toggleDefaultOption = this.filterSetting.toggleSearch;
      }
    }
    static {
      this.ɵfac = function CuiTableControlsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTableControlsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTableControlsComponent,
        selectors: [["cui-table-controls"]],
        hostBindings: function CuiTableControlsComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("resize", function CuiTableControlsComponent_resize_HostBindingHandler() {
              return ctx.onResize();
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          includeSearch: "includeSearch",
          ctaText: "ctaText",
          ctaDisabled: "ctaDisabled",
          ctaTooltip: "ctaTooltip",
          secondaryBtnText: "secondaryBtnText",
          secondaryBtnDisabled: "secondaryBtnDisabled",
          secondaryBtnTooltip: "secondaryBtnTooltip",
          toggleDefaultOption: "toggleDefaultOption",
          toggleOptions: "toggleOptions",
          filterSetting: "filterSetting"
        },
        outputs: {
          searchChanged: "searchChanged",
          ctaClicked: "ctaClicked",
          secondaryBtnClicked: "secondaryBtnClicked",
          toggleClicked: "toggleClicked"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 9,
        consts: [[1, "remove-subscript", 3, "formControl", "label", "prefixIcon", "clearBtn"], [3, "toggleDefaultOption", "toggleOptions"], [3, "ctaClicked", "secondaryBtnClicked", "isMobile", "ctaTooltip", "ctaText", "ctaDisabled", "secondaryBtnTooltip", "secondaryBtnText", "secondaryBtnDisabled"], [1, "remove-subscript", 3, "clearSearch", "formControl", "label", "prefixIcon", "clearBtn"], [3, "toggleClicked", "toggleDefaultOption", "toggleOptions"]],
        template: function CuiTableControlsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CuiTableControlsComponent_Conditional_0_Template, 1, 4, "cui-input", 0)(1, CuiTableControlsComponent_Conditional_1_Template, 1, 2, "cui-table-toggle", 1);
            i0.ɵɵelementStart(2, "cui-table-buttons", 2);
            i0.ɵɵlistener("ctaClicked", function CuiTableControlsComponent_Template_cui_table_buttons_ctaClicked_2_listener() {
              return ctx.ctaClicked.emit();
            })("secondaryBtnClicked", function CuiTableControlsComponent_Template_cui_table_buttons_secondaryBtnClicked_2_listener() {
              return ctx.secondaryBtnClicked.emit();
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.includeSearch ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!!ctx.toggleOptions ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("isMobile", ctx.isMobile)("ctaTooltip", ctx.ctaTooltip)("ctaText", ctx.ctaText)("ctaDisabled", ctx.ctaDisabled)("secondaryBtnTooltip", ctx.secondaryBtnTooltip)("secondaryBtnText", ctx.secondaryBtnText)("secondaryBtnDisabled", ctx.secondaryBtnDisabled);
          }
        },
        dependencies: [CuiTableButtonComponent, CuiTableToggleComponent, ReactiveFormsModule, i1$6.NgControlStatus, i1$6.FormControlDirective, CommonModule, CuiInputComponent],
        styles: ["[_nghost-%COMP%]{display:grid;grid-template-columns:1fr auto auto;grid-gap:var(--cui-small-space);margin:var(--cui-small-space);align-items:center;color:var(--cui-color-breadcrumbs)}[_nghost-%COMP%]   h2[_ngcontent-%COMP%]{margin-bottom:var(--cui-medium-space)}[_nghost-%COMP%]   cui-input[_ngcontent-%COMP%]{margin:0;min-width:7.5rem}"],
        changeDetection: 0
      });
    }
  }
  return CuiTableControlsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TABLE_FILTER_SETTINGS_KEY = 'TABLE_FILTER_SETTINGS';
let CuiTableComponent = /*#__PURE__*/(() => {
  class CuiTableComponent {
    constructor() {
      this.includeSearch = true;
      this.domLayout = false;
      this.rowData = [];
      this.ctaClicked = new EventEmitter();
      this.secondaryBtnClicked = new EventEmitter();
      this.rowClicked = new EventEmitter();
      this.toggleClicked = new EventEmitter();
      this.gridApiReady = new EventEmitter();
    }
    set tableId(id) {
      if (id) {
        this.filterSettings = JSON.parse(localStorage.getItem(TABLE_FILTER_SETTINGS_KEY));
        if (this.filterSettings?.id !== id) {
          this.clearFilterSettings();
          this.setFilterSettings({
            id
          });
        }
      }
      this._tableId = id;
    }
    get tableId() {
      return this._tableId;
    }
    get gridApi() {
      return this._gridApi;
    }
    onSearchChanged(value = '') {
      this.quickSearchValue = value;
      this.setFilterSettings({
        quickSearch: value
      });
    }
    onCtaClicked() {
      this.ctaClicked.emit();
    }
    onRowClicked(value) {
      this.rowClicked.emit(value);
    }
    onToggleClicked(value) {
      this.toggleClicked.emit(value);
      this.setFilterSettings({
        toggleSearch: value
      });
    }
    onFilterChanged(options) {
      if (this.tableId) {
        this.setFilterSettings({
          gridSearch: options.api.getFilterModel()
        });
      }
    }
    onGridReady(gridApi) {
      this._gridApi = gridApi;
      this.gridApiReady.emit(gridApi);
    }
    setFilterSettings(value) {
      this.filterSettings = {
        ...this.filterSettings,
        ...value
      };
      localStorage.setItem(TABLE_FILTER_SETTINGS_KEY, JSON.stringify({
        ...this.filterSettings,
        ...value
      }));
    }
    clearFilterSettings() {
      this.filterSettings = {
        id: undefined,
        gridSearch: null,
        quickSearch: undefined,
        toggleSearch: undefined
      };
      localStorage.removeItem(TABLE_FILTER_SETTINGS_KEY);
    }
    static {
      this.ɵfac = function CuiTableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTableComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTableComponent,
        selectors: [["cui-table"]],
        inputs: {
          includeSearch: "includeSearch",
          domLayout: "domLayout",
          columnDefs: "columnDefs",
          rowData: "rowData",
          ctaText: "ctaText",
          ctaDisabled: "ctaDisabled",
          ctaTooltip: "ctaTooltip",
          secondaryBtnText: "secondaryBtnText",
          secondaryBtnDisabled: "secondaryBtnDisabled",
          secondaryBtnTooltip: "secondaryBtnTooltip",
          toggleDefaultOption: "toggleDefaultOption",
          toggleOptions: "toggleOptions",
          selectedRowId: "selectedRowId",
          loadingMessage: "loadingMessage",
          noRowsMessage: "noRowsMessage",
          isLoading: "isLoading",
          detailCellRendererConfig: "detailCellRendererConfig",
          gridOptions: "gridOptions",
          tableId: "tableId"
        },
        outputs: {
          ctaClicked: "ctaClicked",
          secondaryBtnClicked: "secondaryBtnClicked",
          rowClicked: "rowClicked",
          toggleClicked: "toggleClicked",
          gridApiReady: "gridApiReady"
        },
        ngContentSelectors: _c3,
        decls: 4,
        vars: 21,
        consts: [[3, "ctaClicked", "secondaryBtnClicked", "searchChanged", "toggleClicked", "includeSearch", "ctaTooltip", "ctaText", "ctaDisabled", "secondaryBtnTooltip", "secondaryBtnText", "secondaryBtnDisabled", "toggleDefaultOption", "toggleOptions", "filterSetting"], [1, "table-container"], [3, "rowClicked", "filterChanged", "gridReady", "quickSearch", "domLayout", "columnDefs", "rowData", "selectedRowId", "isLoading", "loadingMessage", "noRowsMessage", "gridOptions", "detailCellRendererConfig", "filterSetting"]],
        template: function CuiTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "cui-table-controls", 0);
            i0.ɵɵlistener("ctaClicked", function CuiTableComponent_Template_cui_table_controls_ctaClicked_0_listener() {
              return ctx.onCtaClicked();
            })("secondaryBtnClicked", function CuiTableComponent_Template_cui_table_controls_secondaryBtnClicked_0_listener() {
              return ctx.secondaryBtnClicked.emit();
            })("searchChanged", function CuiTableComponent_Template_cui_table_controls_searchChanged_0_listener($event) {
              return ctx.onSearchChanged($event);
            })("toggleClicked", function CuiTableComponent_Template_cui_table_controls_toggleClicked_0_listener($event) {
              return ctx.onToggleClicked($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(1, "div", 1)(2, "cui-table-base", 2);
            i0.ɵɵlistener("rowClicked", function CuiTableComponent_Template_cui_table_base_rowClicked_2_listener($event) {
              return ctx.onRowClicked($event);
            })("filterChanged", function CuiTableComponent_Template_cui_table_base_filterChanged_2_listener($event) {
              return ctx.onFilterChanged($event);
            })("gridReady", function CuiTableComponent_Template_cui_table_base_gridReady_2_listener($event) {
              return ctx.onGridReady($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("includeSearch", ctx.includeSearch)("ctaTooltip", ctx.ctaTooltip)("ctaText", ctx.ctaText)("ctaDisabled", ctx.ctaDisabled)("secondaryBtnTooltip", ctx.secondaryBtnTooltip)("secondaryBtnText", ctx.secondaryBtnText)("secondaryBtnDisabled", ctx.secondaryBtnDisabled)("toggleDefaultOption", ctx.toggleDefaultOption)("toggleOptions", ctx.toggleOptions)("filterSetting", ctx.filterSettings);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("quickSearch", ctx.quickSearchValue)("domLayout", ctx.domLayout)("columnDefs", ctx.columnDefs)("rowData", ctx.rowData)("selectedRowId", ctx.selectedRowId)("isLoading", ctx.isLoading)("loadingMessage", ctx.loadingMessage)("noRowsMessage", ctx.noRowsMessage)("gridOptions", ctx.gridOptions)("detailCellRendererConfig", ctx.detailCellRendererConfig)("filterSetting", ctx.filterSettings);
          }
        },
        dependencies: [CuiTableBaseComponent, CuiTableControlsComponent],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;align-items:stretch;position:relative;height:100%;width:100%;background-color:var(--cui-color-page-bg);border-radius:var(--cui-border-radius);box-shadow:var(--cui-shadow)}[_nghost-%COMP%]   .table-container[_ngcontent-%COMP%]{height:100%;padding-bottom:var(--cui-medium-space);border-bottom-right-radius:var(--cui-border-radius);border-bottom-left-radius:var(--cui-border-radius);background-color:var(--cui-color-card-bg)}"],
        changeDetection: 0
      });
    }
  }
  return CuiTableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTableModule = /*#__PURE__*/(() => {
  class CuiTableModule {
    static {
      this.ɵfac = function CuiTableModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTableModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CuiTableModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CuiTableBaseComponent, CuiTableComponent, CustomLoadingOverlayComponent]
      });
    }
  }
  return CuiTableModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTopMenuItemComponent = /*#__PURE__*/(() => {
  class CuiTopMenuItemComponent {
    constructor(appService) {
      this.appService = appService;
      this.text = '';
      this.tooltipText = '';
      this.isMobileView$ = this.appService.isMobileView$;
    }
    static {
      this.ɵfac = function CuiTopMenuItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTopMenuItemComponent)(i0.ɵɵdirectiveInject(AppContainerService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTopMenuItemComponent,
        selectors: [["cui-top-menu-item"]],
        inputs: {
          iconName: "iconName",
          text: "text",
          tooltipText: "tooltipText"
        },
        decls: 2,
        vars: 5,
        consts: [[3, "matTooltipDisabled", "matTooltip", "matTooltipPosition", 4, "ngIf"], [3, "matTooltipDisabled", "matTooltip", "matTooltipPosition"], [3, "name", 4, "ngIf"], [4, "ngIf"], [3, "name"]],
        template: function CuiTopMenuItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CuiTopMenuItemComponent_div_0_Template, 3, 5, "div", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction1(3, _c35, i0.ɵɵpipeBind1(1, 1, ctx.isMobileView$)));
          }
        },
        dependencies: [CommonModule, i2.NgIf, i2.AsyncPipe, CuiIconComponent, MatTooltipModule, i3.MatTooltip],
        styles: ["[_nghost-%COMP%]{display:block;height:100%}div[_ngcontent-%COMP%]{display:flex;align-items:center;cursor:pointer;height:100%;padding:0 var(--cui-small-space);transition:background-color linear .2s,color linear .2s}div[_ngcontent-%COMP%]:hover{background-color:var(--cui-color-hover);color:var(--cui-color-titles)}"],
        changeDetection: 0
      });
    }
  }
  return CuiTopMenuItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTopMenuComponent = /*#__PURE__*/(() => {
  class CuiTopMenuComponent {
    constructor(navService, appContainerService) {
      this.navService = navService;
      this.appContainerService = appContainerService;
      this.showLogo = true;
      this.backgroundColor = '#d4d4d4';
      this.isSideOpen$ = this.navService.sideNavVisibilityState$;
      this.isMobileView$ = this.appContainerService.isMobileView$;
    }
    onToolbarMenuToggle(isSideOpen) {
      this.navService.onSideNavVisibilityChange(!isSideOpen);
    }
    static {
      this.ɵfac = function CuiTopMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTopMenuComponent)(i0.ɵɵdirectiveInject(SideNavService), i0.ɵɵdirectiveInject(AppContainerService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CuiTopMenuComponent,
        selectors: [["cui-top-menu"]],
        hostVars: 2,
        hostBindings: function CuiTopMenuComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          }
        },
        inputs: {
          showLogo: "showLogo",
          backgroundColor: "backgroundColor"
        },
        ngContentSelectors: _c37,
        decls: 3,
        vars: 8,
        consts: [["id", "mainToolbar", 4, "ngIf"], ["id", "mainToolbar"], [1, "left-side"], ["class", "burger-menu", "id", "toolbarMenu", 3, "name", "click", 4, "ngIf"], ["alt", "Companial", 3, "ngClass", "src", 4, "ngIf"], [1, "right-side"], ["id", "toolbarMenu", 1, "burger-menu", 3, "click", "name"], ["alt", "Companial", 3, "ngClass", "src"]],
        template: function CuiTopMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c36);
            i0.ɵɵtemplate(0, CuiTopMenuComponent_mat_toolbar_0_Template, 6, 2, "mat-toolbar", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction2(5, _c38, i0.ɵɵpipeBind1(1, 1, ctx.isSideOpen$), i0.ɵɵpipeBind1(2, 3, ctx.isMobileView$)));
          }
        },
        dependencies: [CommonModule, i2.NgClass, i2.NgIf, i2.AsyncPipe, MatToolbarModule, i4$6.MatToolbar, CuiIconComponent],
        styles: ["[_nghost-%COMP%]{display:block;grid-area:top-menu;max-height:2rem;height:2rem}mat-toolbar#mainToolbar[_ngcontent-%COMP%]{padding:0;width:100%;color:var(--cui-color-titles);display:flex;background-color:inherit;justify-content:space-between}mat-toolbar#mainToolbar.mat-toolbar-single-row[_ngcontent-%COMP%]{height:inherit}mat-toolbar#mainToolbar[_ngcontent-%COMP%]   .left-side[_ngcontent-%COMP%], mat-toolbar#mainToolbar[_ngcontent-%COMP%]   .right-side[_ngcontent-%COMP%]{height:100%;display:flex;align-items:center}.burger-menu[_ngcontent-%COMP%]{padding:var(--cui-small-space);display:none;cursor:pointer}@media only screen and (max-width: 600px){.burger-menu[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}}.companial-logo-size[_ngcontent-%COMP%]{width:130px}.mobile-logo-size[_ngcontent-%COMP%]{width:90px}"],
        changeDetection: 0
      });
    }
  }
  return CuiTopMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CuiTopMenuModule = /*#__PURE__*/(() => {
  class CuiTopMenuModule {
    static {
      this.ɵfac = function CuiTopMenuModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CuiTopMenuModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CuiTopMenuModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CuiTopMenuItemComponent, CuiTopMenuComponent]
      });
    }
  }
  return CuiTopMenuModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of cui-components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApplicationReloadNotificationComponent, BlobStorageService, Configurations, CuiAlertComponent, CuiAppContainerComponent, CuiButtonComponent, CuiButtonCtaComponent, CuiButtonDropdownActionComponent, CuiButtonDropdownComponent, CuiButtonLinkComponent, CuiButtonLinkCtaComponent, CuiButtonsModule, CuiCardBodyComponent, CuiCardComponent, CuiCardFooterComponent, CuiCardHeaderComponent, CuiCardModule, CuiCheckboxComponent, CuiDashboardBaseComponent, CuiDashboardModule, CuiDashboardTileComponent, CuiDatepickerComponent, CuiErrorsComponent, CuiFileInputComponent, CuiFilesUploaderComponent, CuiFilesUploaderComponentDeprecated, CuiFormSlideToggleComponent, CuiGuardLoadingIndicatorComponent, CuiIconButtonComponent, CuiIconComponent, CuiIconLinkComponent, CuiInputComponent, CuiLibraryModule, CuiListComponent, CuiListItemComponent, CuiListModule, CuiMenuComponent, CuiMenuGroupComponent, CuiMenuItemComponent, CuiMenuModule, CuiMonthPickerComponent, CuiMultilineCellRendererComponent, CuiPageTitleComponent, CuiRadioChoiceComponent, CuiRadioComponent, CuiRadioModule, CuiRichEditorComponent, CuiSearchSelectComponent, CuiSearchSelectSsrComponent, CuiSideNavComponent, CuiSideNavExpandComponent, CuiSideNavGroupComponent, CuiSideNavItemComponent, CuiSideNavModule, CuiSimpleSelectComponent, CuiSimpleTableComponent, CuiSlideToggleComponent, CuiTableBaseComponent, CuiTableCellCheckmarkRendererComponent, CuiTableCellIconButtonRendererComponent, CuiTableCellIconRendererComponent, CuiTableComponent, CuiTableDatepickerComponent, CuiTableModule, CuiTableRowDetailRendererComponent, CuiTextAreaComponent, CuiTileBaseBobyComponent, CuiTileBaseFooterComponent, CuiTileNumberComponent, CuiTimepickerComponent, CuiTopMenuComponent, CuiTopMenuItemComponent, CuiTopMenuModule, CuiValidators, CustomLoadingOverlayComponent, CustomTextFilterComponent, DEFAULT_CONFIG, DialogService, FileDragNDropDirective$1 as FileDragNDropDirective, FileStorageService, FileUploadComponentDialog, FormArrayComponentBase, FormComponentBase, FormControlComponentBase, FormatBytesPipe, IsoDatePipe, NotificationsService, ParseHtmlPipe, RangeDateFilterComponent, SearchSelectService, SideNavService, SubscribingBase, TABLE_FILTER_SETTINGS_KEY, UserValidationService, allowedExpirationDateFormatRegExp, allowedPhoneNumberSymbols, allowedUrlLinkRegExp, createDateWithZeroTime, createServerSideDatasource, digitRegExp, emailBlockedDomainRegExp, formatDate, formatToISODate, formatToISODateEndOfDay, generateRandomAlphaString, getCssVariableValue, integerRegExp, isGUID, isNotNullOrUndefined, latinLettersAndNumbersRegExp, lowerCaseRegExp, numericRegExp, plusSymbolRegExp, specialSymbolRegExp, upperCaseRegExp };
